PJQ.views.settings = {};
PJQ.models.settings = {};
PJQ.collections.settings = {};

PJQ.modules.settings = {
    oldRoutes: [],
    routes: [
        {
            route: '?procore=:procore&code=:code',
            name: 'procoreRefer',
            callback: function (procore, code) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'integration'
                        },
                        {
                            endpoint: 'procore'
                        },
                        {
                            endpoint: 'link'
                        }
                    ], [
                        {
                            parameter: 'userId',
                            value: procore
                        },
                        {
                            parameter: 'code',
                            value: code
                        }
                    ])
                }).post().done(function () {
                    PJQ.app.initNavigator({
                        activeItem: 'settings',
                        viewOptions: {
                            procoreCode: code
                        }
                    });
                });
            }
        },
        {
            route: "settings",
            name: 'settings',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "settings"
                });
            }
        },
        {
            route: "settings/billing",
            name: 'billingInfo',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "settings",
                    viewOptions: {
                        initView: "billing"
                    },
                    preventTour: true
                });
            }
        },
        {
            route: 'settings/addressbook',
            name: 'addressBookSettings',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "settings"
                });
            }
        },
        {
            route: 'settings/account/:subscriptionId',
            name: 'settings',
            callback: function (subscriptionId) {
                PJQ.app.initNavigator({
                    activeItem: "settings",
                    viewOptions: {
                        subscriptionId: parseInt(subscriptionId)
                    }
                });
            }
        },
        {
            route: 'settings/projects',
            name: 'projectSettings',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "settings"
                });
            }
        },
        {
            route: 'settings/:module',
            name: 'projectSettings',
            callback: function (module) {
                PJQ.app.initNavigator({
                    activeItem: "settings",
                    viewOptions: {
                        initView: module
                    }
                });
            }
        },
        {
            route: "settings/integrations/:name",
            name: 'integration',
            callback: function (name) {
                PJQ.app.initNavigator({
                    activeItem: "settings",
                    viewOptions: {
                        initView: "integrations",
                        integrationName: name
                    },
                    preventTour: true
                });
            }
        },
        {
            route: "settings/integrations/:name?authorized=:authorized",
            name: 'integrationAuth',
            callback: function (name, authorized) {
                PJQ.app.initNavigator({
                    activeItem: "settings",
                    viewOptions: {
                        initView: "integrations",
                        integrationName: name,
                        authorized: authorized === 'true'
                    },
                    preventTour: true
                });
            }
        },
    ]
};

PJQ.app.addOldRoutes(PJQ.modules.settings.oldRoutes);
PJQ.app.addRoutes(PJQ.modules.settings.routes);

PJQ.views.settings.CompanyInfo = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'company-info'),
        subTemplates: {
            subscription: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'subscription-info'),
        },
        onChange: null,
        editingLogo: false
    },
    events: {
        "mouseup .btn-password-reset-modal": "resetPasswordModal",
        'change .cb-directory-status': 'directoryStatusChanged',
        "keyup input[type='text']": "onChange",
        'change .user-procore-link': 'procoreLink',
        'click .btn-join-directory': 'joinDirectory',
        'click .btn-edit-logo': 'editLogo',
        'click .btn-cancel-edit-logo': 'cancelEditLogo',
        'click .btn-save-logo': 'saveLogo',
        'click .btn-enable-auto-renew': 'enableAutoRenew',
        'click .btn-disable-auto-renew': 'disableAutoRenew',
        'click .btn-edit-card': 'changeCard'
    },
    beforeFirstRender: function () {
        if (this.options.procoreCode)
            PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.PROCORE_ACCESS_REFRESH_TOKEN, 'code:' + this.options.procoreCode);

        this.model = PJQ.app.session.user;
        if (!this.model.isFetched) {
            this.model.fetch({
                success: _.bind(function () {
                    this.render();
                    this.listenTo(this.model, 'fetch', this.render);
                }, this)
            });
        }

        this.options.canEditLogo = !PJQ.app.session.get('onAccount') || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK);
    },
    renderData: function () {
        return {
            model: this.model,
            logoUrl: PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.EMAIL_LOGO_URL),
            canEditLogo: this.options.canEditLogo,
            editingLogo: this.options.editingLogo ?? false
        };
    },
    afterRender: function () {
        if (this.model == null || !this.model.isFetched) {
            return;
        }

        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-user-phone'));
        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-user-cell'));
        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-user-fax'));

        if (PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-company-type'),
                hideDisabled: true,
                defaultValue: this.model.get('companyType'),
                onChange: _.bind(function (value) {
                    this.model.set('companyType', value);
                    this.onChange();
                }, this)
            });
        }

        let statePicker = new PJQ.inputs.StatePicker({
            el: this.$('.user-edit-state'),
            country: this.model.get('country') ?? null,
            defaultValue: this.model.get('state') ?? null,
            size: 20,
            onChange: (value) => {
                this.model.set('state', value);
                this.onChange();
            }
        });

        new PJQ.inputs.CountryPicker({
            el: this.$('.user-edit-country'),
            defaultValue: this.model.get('country') ?? null,
            statePicker: statePicker,
            zipInput: this.$('.user-edit-zip'),
            enableInternational: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_INTERNATIONAL_COUNTRIES),
            size: 20,
            onChange: (value) => {
                this.model.set('country', value);
                this.onChange();
            }
        });

        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
        new PJQ.Binder(this.$el, this.model, {
            afterChange: _.bind(function () {
                this.onChange();
            }, this)
        });

        if (this.options.procoreCode) {
            PJQ.notifications.notify.successNotify({
                message: 'Your Procore login has been linked to your Pantera account.'
            });
            this.options.procoreCode = null;
        }

        this.renderLogoUploader();

        if (PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
            this.renderSubscriptionInfo();
            this.renderDirectoryStatus();
        }
    },
    renderLogoUploader: function () {
        if (!this.options.canEditLogo || !this.options.editingLogo) {
            return;
        }

        this.logoUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.logo-uploader'),
            useApiV2: true,
            maxFiles: 1,
            allowedExtensions: ['jpeg', 'jpg', 'png'],
            onSuccess: (file) => {
                this.logoFile = file;
            }
        });
    },
    directoryStatusChanged: function (e) {
        let isActive = $(e.currentTarget).prop('checked');
        if (isActive) {
            this.joinDirectory();
        } else {
            this.leaveDirectory();
        }
    },
    joinDirectory: function () {
        PJQ.app.session.joinDirectory(_.bind(function () {
            this.$(".directory-alert").remove();
            this.renderDirectoryStatus();
        }, this));
    },
    leaveDirectory: function () {
        PJQ.app.session.leaveDirectory(_.bind(function () {
            this.renderDirectoryStatus();
        }, this));
    },
    editLogo: function () {
        this.options.editingLogo = true;
        this.logoFile = null;
        this.render();
    },
    cancelEditLogo: function () {
        this.options.editingLogo = false;
        this.logoFile = null;
        this.render();
    },
    saveLogo: function () {
        if (this.logoFile == null) {
            if (this.logoUploader == null) {
                this.options.editingLogo = false;
                this.render();
            }
            this.logoUploader.showError("Please select a file to upload");
            return;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'companies'
                },
                {
                    endpoint: 'logo'
                }
            ]),
            data: this.logoFile,
            isAPIv2: true
        }).post().done((res) => {
            PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.EMAIL_LOGO_URL, res.url);
            this.options.editingLogo = false;
            this.logoFile = null;
            this.render();
        });
    },
    renderDirectoryStatus: function () {
        let isActive = PJQ.app.session.contact != null && !PJQ.app.session.contact.get('isBlacklisted');
        this.$('.directory-status-label').html(isActive ? 'Active' : 'Inactive').css('color', isActive ? PJQ.constants.colors.GREEN : PJQ.constants.colors.RED);
        this.$('.cb-directory-status').prop('checked', isActive);
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.model);
        }
    },
    renderSubscriptionInfo: function () {
        if (!PJQ.app.session.get('onAccount') && PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
            PJQ.app.session.listenSubscriptionChanged("accountSettings", _.bind(function () {
                this.renderSubscriptionInfo();
            }, this));
            PJQ.app.session.fetchBillingInfo(_.bind(function (billingInfo) {
                this.renderSubTemplate(false, this.options.subTemplates.subscription, this.$('.subscription-info'), {
                    subscription: PJQ.app.session.subscription,
                    billingInfo: billingInfo
                });
            }, this));
        }
    },
    enableAutoRenew: function () {
        PJQ.app.session.updateAutoRenew(true, _.bind(function () {
            this.renderSubscriptionInfo();
            PJQ.notifications.notify.successNotify({
                message: "Auto renew successfully enabled"
            });
        }, this), _.bind(function () {
            PJQ.notifications.notify.errorNotify({
                message: "Encountered an error enabling auto renew.  Please contact customer service,"
            });
        }, this));
    },
    disableAutoRenew: function () {
        new PJQ.views.subscriptions.DisableAutoRenewModal({
            subscription: PJQ.app.session.subscription,
            onYes: _.bind(function () {
                PJQ.app.session.updateAutoRenew(false, _.bind(function () {
                    this.renderSubscriptionInfo();
                    PJQ.notifications.notify.successNotify({
                        message: "Auto renew successfully disabled"
                    });
                }, this), _.bind(function () {
                    PJQ.notifications.notify.errorNotify({
                        message: "Encountered an error disabling auto renew.  Please contact customer service,"
                    });
                }, this));
            }, this)
        });
    },
    changeCard: function () {
        PJQ.app.session.fetchBillingInfo(_.bind(function (billingInfo) {
            new PJQ.views.payment.PaySimplePaymentModal({
                model: billingInfo,
                onSave: _.bind(function () {
                    this.renderSubscriptionInfo();
                    PJQ.notifications.notify.successNotify({
                        message: "You have successfully updated your card on file."
                    });
                }, this),
                onError: function () {
                    PJQ.notifications.notify.errorNotify({
                        message: "Encountered an error updating your card.  Please contact customer service."
                    });
                }
            });
        }, this));
    },
    resetPasswordModal: function () {
        new PJQ.views.settings.ResetPasswordModal();
    },
    validate: function () {
        let errors = 0;
        let isValid = true;

        let isCompanyValid = _.size(this.model.get('companyName').trim()) > 0;
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-company-name'), isCompanyValid);
        isValid = isCompanyValid && isValid;
        if (!isValid) {
            errors += 1
        }

        return !!(isValid && errors === 0);
    },
    procoreLink: function () {
        let isLinked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROCORE_ACCESS_REFRESH_TOKEN);
        if (isLinked) {
            new PJQ.views.modals.YesNo({
                header: "Remove Procore User Link?",
                body: "Are you sure you would like to remove your link between Pantera and Procore? ",
                onYes: _.bind(function () {

                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'integration'
                            },
                            {
                                endpoint: 'procore'
                            },
                            {
                                endpoint: 'unlink'
                            }
                        ])
                    }).post().done(_.bind(function (data) {
                        PJQ.app.session.preferences.deletePref(PJQ.constants.preferenceTypes.PROCORE_ACCESS_REFRESH_TOKEN);
                        PJQ.notifications.notify.successNotify({
                            message: 'Your Procore login has been unlinked from your Pantera account.'
                        });
                    }, this));

                }, this),
                onNo: _.bind(function () {
                    this.$('.user-procore-link').prop('checked', true);
                }, this)
            });

        } else {
            new PJQ.views.modals.YesNo({
                header: "Link Procore Account",
                body: "Are you sure you want to link your Procore account?  Please note this will redirect you to Procore to sign in and authorize the link.",
                onYes: _.bind(function () {
                    let redirect = window.location.origin + '?procore=' + PJQ.app.session.user.id.toString(),
                        url = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROCORE_URL_AUTH) + '/oauth/authorize?response_type=code&client_id=' + PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROCORE_CLIENT_ID) + '&redirect_uri=' + encodeURIComponent(redirect);
                    document.location = url;
                }, this),
                onNo: _.bind(function () {
                    this.$('.user-procore-link').prop('checked', false);
                }, this)
            });

        }
    }
});

PJQ.views.settings.ResetPasswordModal = PJQ.views.BaseModal.extend({
    baseOptions: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Reset-Password'),
        isVerticalCenter: false,
        isShowResetButton: true,
        resetButtonText: "Reset Password",
        resetButtonColorClass: 'primary',
        isShowCancelButton: true,
        cancelButtonText: "Close",
        onReset: _.noop,
        width: null,
        minWidth: null,
        maxWidth: null,
        height: null,
        minHeight: null,
        maxHeight: null,
        fitHeight: false
    },
    defaults: {},
    options: {},
    defaultEvents: {
        'hidden.bs.modal': 'removeModal',
        'click .modal-reset': 'onReset',
        'click .show-hide': 'showHide',
        'click .show-hide-confirm': 'showHide'
    },
    events: {},
    beforeFirstRender: function () {
        this.options = _.defaults(this.options, {
            uuid: "modal-" + _.uniqueId()
        });
        //force element to null in case one was passed in
        //this view uses modals only so it creates its own container to insert into in the <body>
        this.createModal();
        this.afterModalCreated();
    },
    onReset: function () {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }
        let isConfirmValid = true,
            isConfirmLength = true,
            error = "",
            newPass = this.$('.new-pass').val(),
            newPassConfirm = this.$('.new-pass-confirm').val();

        if (newPass !== newPassConfirm) {
            isConfirmValid = false;
            error += "Passwords do not match.  ";
            this.errorAlert = new PJQ.Alert(this.$('.error'), {
                type: 'danger',
                text: error
            });
        }

        if (newPass.trim().length < 7) {
            isConfirmLength = false;
            error += "Password is too short.";
            this.errorAlert = new PJQ.Alert(this.$('.error'), {
                type: 'danger',
                text: error
            });
        }
        PJQ.helpers.inputHelpers.setInputError(this.$('.new-pass-confirm'), isConfirmValid);
        PJQ.helpers.inputHelpers.setInputError(this.$('.new-pass'), isConfirmLength);
        if ((isConfirmValid && isConfirmLength)) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'users'
                    },
                    {
                        endpoint: 'resetpassword'
                    },
                ]),
                data: {
                    password: newPass
                }
            }).post().success(_.bind(function (data) {
                if (data.success) {
                    this.options.success = true;
                    this.options.request = null;
                    this.$('.password-group').hide();
                    this.$('.modal-reset').hide();

                    this.errorAlert = new PJQ.Alert(this.$('.error'), {
                        type: 'success',
                        text: "Password successfully changed!"
                    });
                } else {
                    if (data.error === "CURRENT_PASSWORD") {
                        this.errorAlert = new PJQ.Alert(this.$('.error'), {
                            type: 'danger',
                            text: "New password matches current password"
                        });
                    }
                }
            }, this)).fail(_.bind(function () {
                this.options.success = false;
                this.render();
            }, this));
        }
    },
    showHide: function (e) {
        let target = $(e.currentTarget),
            showHide = this.$('.new-pass').attr('type'),
            showHideConfirm = this.$('.new-pass-confirm').attr('type');
        if (target.attr('id') === "btn-show-hide") {
            if (showHide === "password") {
                this.$('.new-pass').attr('type', "text");
                this.$('.show-hide span').removeClass('fa-eye-slash');
                this.$('.show-hide span').addClass('fa-eye')
            } else {
                this.$('.new-pass').attr('type', "password");
                this.$('.show-hide span').addClass('fa-eye-slash');
                this.$('.show-hide span').removeClass('fa-eye')
            }
        }
        if (target.attr('id') === "btn-show-hide-confirm") {
            if (showHideConfirm === "password") {
                this.$('.new-pass-confirm').attr('type', "text");
                this.$('.show-hide-confirm span').removeClass('fa-eye-slash');
                this.$('.show-hide-confirm span').addClass('fa-eye')
            } else {
                this.$('.new-pass-confirm').attr('type', "password");
                this.$('.show-hide-confirm span').addClass('fa-eye-slash');
                this.$('.show-hide-confirm span').removeClass('fa-eye')
            }
        }
    }
});

PJQ.views.settings.AddressBookGeneralSettings = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Address-Book-General'),
		onChange: null
	},
	beforeFirstRender: function () {
		this.listenTo(this.model, 'fetch', this.render);
	},
	beforeRender: function () {
		this.showLaborStatus = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS) !== true;
		this.groupLabel = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.GROUP_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL) : "Trades";
		this.renderData = {
			model: this.model,
			groupLabel: this.groupLabel,
			newAddressBook: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_ADDRESSBOOK),
			showLaborStatus: this.showLaborStatus
		};
	},
	afterRender: function () {
		if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_ADDRESSBOOK)) {
			new PJQ.inputs.Selectpicker({
				el: this.$('.select-company-default-view'),
				defaultValue: (_.size(this.model.get('companyDefaultView')) > 0) ? this.model.get('companyDefaultView') : "view_group",
				onChange: _.bind(function (value) {
					this.model.set('companyDefaultView', value);
					this.onChange();
				}, this)
			});

			new PJQ.inputs.Selectpicker({
				el: this.$('.select-default-view'),
				defaultValue: (_.size(this.model.get('defaultView')) > 0) ? this.model.get('defaultView') : "view_group",
				onChange: _.bind(function (value) {
					this.model.set('defaultView', value);
					this.onChange();
				}, this)
			});
		}

		let defaultFilters = _.map(PJQ.app.session.userTypes.getByIsCompany(false), function (userType) {
			return userType.get('userTypeId');
		});
		$.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY, PJQ.constants.addressBook.contactStatusFilter.ACTIVE, PJQ.constants.addressBook.contactStatusFilter.INACTIVE]);
		if (this.showLaborStatus)
			$.merge(defaultFilters, [PJQ.constants.addressBook.laborStatusFilter.UNION, PJQ.constants.addressBook.laborStatusFilter.NON_UNION, PJQ.constants.addressBook.laborStatusFilter.PREV_WAGE, PJQ.constants.addressBook.laborStatusFilter.NOT_AVAILABLE]);
		this.filterSelectPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.select-default-filter'),
			isIntChoices: true,
			isMultiple: true,
			exclusiveChoices: [-3, -4],
			isGroup: true,
			mustSelectValuePerOptGroup: true,
			defaultValue: this.model.get('defaultFilters').length > 0 ? this.model.get('defaultFilters').split(',') : defaultFilters,
			onChange: _.bind(function (value) {
				this.model.set('defaultFilters', value.join())
				this.onChange();
			}, this)
		});

		this.locationTypeSelectPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.select-default-location-type'),
			isIntChoices: true,
			isMultiple: true,
			mustSelectValue: true,
			defaultValue: this.model.get('defaultLocationFilters').length > 0 ? this.model.get('defaultLocationFilters').split(',') : [PJQ.constants.addressBook.locationTypeFilter.WORK_AREA, PJQ.constants.addressBook.locationTypeFilter.OFFICE_LOCATION],
			onChange: _.bind(function (value) {
				this.model.set('defaultLocationFilters', value.join())
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-rows-per-page'),
			defaultValue: this.model.get('rowsPerPage'),
			onChange: _.bind(function (value) {
				this.model.set('rowsPerPage', value);
				this.onChange();
			}, this)
		});

		$(function () {
			$('[data-toggle="tooltip"]').tooltip()
		});
		new PJQ.Binder(this.$el, this.model, {
			setDefaultValues: true,
			watchElements: [
				'input'
			],
			afterChange: _.bind(function () {
				this.onChange();
			}, this)
		});
	},
	onChange: function () {
		if (typeof this.options.onChange === 'function') {
			this.options.onChange(this.model);
		}
	}
});

PJQ.views.settings.ContactFieldSettings = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Contact-Core-Fields')
	},
	events: {
		'click .cb-visible-contact': 'contactVisibleChanged',
		'click .cb-visible-admin': 'adminVisibleChanged',
		'click .cb-required-contact': 'contactRequiredChanged',
		'click .cb-required-admin': 'adminRequiredChanged'
	},
	beforeFirstRender: function () {
		PJQ.app.session.fetchContactFieldSettings(null, _.bind(function (fields) {
			this.collection = fields;

			let fillFields = [
				{
					fieldName: "active",
					name: "Active",
					canContactEdit: false,
					isVisibleContact: false,
					isRequiredContact: false,
					isRequiredAdmin: false,
					canBeRequired: false
				},
				{
					fieldName: "companyName",
					name: "Company Name"
				},
				{
					fieldName: "laborStatus",
					name: "Labor Status"
				},
				{
					fieldName: "classifications",
					name: "Certifications",
					isRequiredContact: false,
					isRequiredAdmin: false
				},
				{
					fieldName: "sector",
					name: "Sector"
				},
				{
					fieldName: "companyNotes",
					name: "Company Notes",
					canContactEdit: false,
					isVisibleContact: false,
					isRequiredContact: false
				},
				{
					fieldName: "contactName",
					name: "Contact Name"
				},
				{
					fieldName: "title",
					name: "Title"
				},
				{
					fieldName: "address1",
					name: "Address 1"
				},
				{
					fieldName: "address2",
					name: "Address 2"
				},
				{
					fieldName: "city",
					name: "City"
				},
				{
					fieldName: "state",
					name: "State"
				},
				{
					fieldName: "zip",
					name: "Postal Code"
				},
				{
					fieldName: "country",
					name: "Country"
				},
				{
					fieldName: "phone",
					name: "Phone"
				},
				{
					fieldName: "cell",
					name: "Cell"
				},
				{
					fieldName: "fax",
					name: "Fax"
				},
				{
					fieldName: "email",
					name: "Email"
				},
				{
					fieldName: "contactNotes",
					name: "Contact Notes",
					canContactEdit: false,
					isVisibleContact: false,
					isRequiredContact: false
				},
				{
					fieldName: "groups",
					name: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.GROUP_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL) : "Trades"
				},
				{
					fieldName: "workAreas",
					name: "Work Areas"
				}
			];

			_.each(fillFields, _.bind(function (field, index) {
				let matchField = this.collection.findWhere({fieldName: field.fieldName});
				if (matchField == null) {
					this.collection.add(_.defaults(field, {
						isVisibleContact: true,
						isVisibleAdmin: true,
						isRequiredContact: false,
						isRequiredAdmin: false,
						sortOrder: index,
						canContactEdit: field.canContactEdit !== false
					}));
				}
				else {
					matchField.set({
						name: field.name,
						sortOrder: index,
						canContactEdit: field.canContactEdit !== false
					});
				}
			}, this));

			this.render();
		}, this));
	},
	afterRender: function () {
		if (this.collection == null || !this.collection.isFetched) {
			return;
		}

		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$(".field-table"),
			data: this.collection.models,
			isHideSearch: true,
			paging: false,
			rowId: "cid",
			order: [0, 'asc'],
			columns: [
				{
					"title": "",
					"data": "attributes.sortOrder",
					"visible": false
				},
				{
					"title": "Name",
					"data": "attributes.name",
					"orderable": false
				},
				{
					"title": "Visible To Contact",
					"data": "attributes.isVisibleContact",
					"orderable": false,
					"render": function (data, type, row) {
						let contactEdit = row.get('canContactEdit') !== false;
						return '<div class="pretty p-switch" ' + (contactEdit ? '' : 'title="This field is never visible to contacts"') + '><input ' + (contactEdit ? '' : 'disabled') + ' type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-visible-contact"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>';
					}
				},
				{
					"title": "Required for Contact",
					"data": "attributes.isRequiredContact",
					"orderable": false,
					"render": function (data, type, row) {
						if (row.get('canBeRequired') === false) {
							return '<div class="pretty p-switch" title="This field can not be required"><input disabled type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-required-contact"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>';
						}
						let contactEdit = row.get('canContactEdit') !== false;
						return '<div class="pretty p-switch" ' + (contactEdit ? '' : 'title="This field is never visible to contacts"') + '><input ' + (contactEdit ? '' : 'disabled') + ' type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-required-contact"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>';
					}
				},
				{
					"title": "Visible To Admin",
					"data": "attributes.isVisibleAdmin",
					"orderable": false,
					"render": function (data) {
						return '<div class="pretty p-switch"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-visible-admin"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>'
					}
				},
				{
					"title": "Required for Admin",
					"data": "attributes.isRequiredAdmin",
					"orderable": false,
					"render": function (data, type, row) {
						if (row.get('canBeRequired') === false) {
							return '<div class="pretty p-switch" title="This field can not be required"><input disabled type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-required-admin"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>';
						}
						return '<div class="pretty p-switch"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-required-admin"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>'
					}
				}
			]
		});
	},
	contactVisibleChanged: function (e) {
		let $target = $(e.currentTarget),
			$row = $target.closest('tr'),
			row = this.dataTable.getRow($row),
			setting = row.data(),
			enabled = $target.prop('checked');
		setting.set('isVisibleContact', enabled);

		if (enabled) {
			// if the field is made visible to contacts, it must be visible to admins too
			setting.set('isVisibleAdmin', true);
		}
		else {
			// if the field is made invisible to contacts
			// it must be made not required for contacts
			setting.set('isRequiredContact', false);
			setting.set({
				isRequiredContact: false
			});
		}

		setting.queueSave();
		this.dataTable.refresh();
	},
	adminVisibleChanged: function (e) {
		let $target = $(e.currentTarget),
			$row = $target.closest('tr'),
			row = this.dataTable.getRow($row),
			setting = row.data(),
			enabled = $target.prop('checked');
		setting.set('isVisibleAdmin', enabled);

		if (!enabled) {
			// if the field is made invisible to admins
			// it must be made not required for admins
			// it must also be made not visible and not required for contacts
			setting.set({
				isVisibleContact: false,
				isRequiredContact: false,
				isRequiredAdmin: false
			});
			this.dataTable.refresh();
		}

		setting.queueSave();
	},
	contactRequiredChanged: function (e) {
		let $target = $(e.currentTarget),
			$row = $target.closest('tr'),
			row = this.dataTable.getRow($row),
			setting = row.data();
		setting.set('isRequiredContact', $target.prop('checked'));
		setting.queueSave();
	},
	adminRequiredChanged: function (e) {
		let $target = $(e.currentTarget),
			$row = $target.closest('tr'),
			row = this.dataTable.getRow($row),
			setting = row.data();
		setting.set('isRequiredAdmin', $target.prop('checked'));
		setting.queueSave();
	}
});

PJQ.views.settings.ChangeRequestSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'change-requests'),
        model: null,
        customFields: null
    },
    events: {},
    beforeFirstRender: function () {
        this.listenTo(this.model, 'fetch', this.render);
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            useDecimalPercentFields: true,
            watchElements: [
                'input'
            ],
            afterChange: ($el, attribute) => {
                this.onChange();
            }
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format'),
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('numberFormat', value);
                this.onChange();
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});
PJQ.views.settings.CommitmentSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'commitments'),
        model: null,
        customFields: null
    },
    events: {
        'click .btn-manage-signature': 'manageSignature',
        'keydown .input-percent': 'numbersOnly',
        'change .input-percent': 'formatPercent',
    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            useDecimalPercentFields: true,
            watchElements: [
                'input'
            ],
            afterChange: ($el, attribute) => {
                if (attribute === 'disableSubcontracts' || attribute === 'disablePO') {
                    this.render();
                }

                this.onChange();
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-default-accounting-method'),
            isIntChoices: true,
            isMultiple: false,
            defaultValue: this.model.get('defaultAccountingMethod') != null ? this.model.get('defaultAccountingMethod') : PJQ.constants.budget.accountingMethod.UNIT_QUANTITY,
            onChange: _.bind(function (value) {
                this.model.set('defaultAccountingMethod', value);
                this.onChange();
            }, this)
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format-po'),
            commitmentType: PJQ.constants.commitments.commitmentType.PURCHASE_ORDER,
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('purchaseOrderNumberFormat', value);
                this.onChange();
            }
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format-subcontract'),
            commitmentType: PJQ.constants.commitments.commitmentType.SUBCONTRACT,
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('subcontractNumberFormat', value);
                this.onChange();
            }
        });

        new PJQ.views.settings.SignatureEditInput({
            el: this.$('.manage-signature-input'),
            signature: this.model.get('defaultSignature'),
            headerSubText: "Manage your company's default signature for Commitments",
            onSave: _.bind(function (signature) {
                this.model.set('defaultSignature', signature);
                this.onChange();
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    formatPercent: function (e) {
        $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatPercent($(e.currentTarget).val()));
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});

PJQ.views.settings.CommitmentChangeOrderSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'commitment-change-orders'),
        model: null,
        customFields: null
    },
    events: {},
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ],
            afterChange: ($el, attribute) => {
                this.onChange();
            }
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format'),
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('numberFormat', value);
                this.onChange();
            }
        });

        new PJQ.views.settings.SignatureEditInput({
            el: this.$('.manage-signature-input'),
            signature: this.model.get('defaultSignature'),
            headerSubText: "Manage your company's default signature for Commitment Change Orders",
            onSave: _.bind(function (signature) {
                this.model.set('defaultSignature', signature);
                this.onChange();
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});
PJQ.views.settings.CustomFieldSettings = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Custom-Fields'),
		fieldModel: PJQ.models.customFields.CustomField
	},
	events: {
		'click .add-field': 'addClicked',
		'click .edit-field': 'editClicked',
		'click .delete-field': 'deleteClicked',
		'click .btn-sort-alpha': 'sortFieldsAlpha'
	},
	afterRender: function () {
		this.fieldModel = new this.options.fieldModel();
		if (this.fieldModel instanceof PJQ.models.contacts.ContactCustomField) {
			this.fieldModelName = 'contact';
		}
		else if (this.fieldModel instanceof PJQ.models.contacts.CompanyCustomField) {
			this.fieldModelName = 'company';
		}
		else if (this.fieldModel instanceof PJQ.models.projects.ProjectCustomField) {
			this.fieldModelName = 'project';
		}
		else if (this.fieldModel instanceof PJQ.models.actionItems.ActionItemCustomField) {
			this.fieldModelName = 'actionItems';
		}
		else if (this.fieldModel instanceof PJQ.models.punchlists.PunchlistCustomField) {
			this.fieldModelName = 'punchList';
		}
		else if (this.fieldModel instanceof PJQ.models.commitments.CustomField) {
			this.fieldModelName = 'commitment';
		}
		else if (this.fieldModel instanceof PJQ.models.commitments.ChangeOrderCustomField) {
			this.fieldModelName = 'commitmentChangeOrder';
		}
		else if (this.fieldModel instanceof PJQ.models.primeContracts.CustomField) {
			this.fieldModelName = 'primeContract';
		}
		else if (this.fieldModel instanceof PJQ.models.primeContracts.ChangeOrderCustomField) {
			this.fieldModelName = 'primeContractChangeOrder';
		}
		else if (this.fieldModel instanceof PJQ.models.directcosts.CustomField) {
			this.fieldModelName = 'directCost';
		}
		else if (this.fieldModel instanceof PJQ.models.invoicing.PayableInvoiceCustomField) {
			this.fieldModelName = 'payableInvoice';
		}
		else if (this.fieldModel instanceof PJQ.models.invoicing.ReceivableInvoiceCustomField) {
			this.fieldModelName = 'receivableInvoice';
		}
		else if (this.fieldModel instanceof PJQ.models.schedule.ScheduleCustomField) {
			this.fieldModelName = 'schedule';
		}
		else if (this.fieldModel instanceof PJQ.models.submittals.SubmittalCustomField) {
			this.fieldModelName = 'submittals';
		}
		else if (this.fieldModel instanceof PJQ.models.users.UserCustomField) {
			this.fieldModelName = 'user';
		}
		else if (this.fieldModel instanceof PJQ.models.meetings.CustomField) {
			this.fieldModelName = 'meetings';
		}
		else if (this.fieldModel instanceof PJQ.models.changeRequests.CustomField){
			this.fieldModelName = 'changeRequest'
		}
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$(".custom-field-table"),
			data: this.collection.models,
			isHideSearch: true,
			rowId: "cid",
			language: {
				zeroRecords: 'Click "Add New Field" to create a new custom field'
			},
			order: [0, 'asc'],
			sortableOptions: {
				data: this.collection,
				containment: ".custom-field-table",
			},
			bSort: false,
			onRowDoubleClick: _.bind(function (row) {
				this.editField(row.data());
			}, this),
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editField(row.data());
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						onClick: _.bind(function (row) {
							this.deleteField(row);
						}, this)

					}
				]
			},
			columns: [
				{
					"data": "attributes.sortOrder",
					"title": "",
					"searchable": false,
					"orderable": false,
					"visible": false,
					"render": _.bind(function (data, type, row) {
						let content = '';
						if (data != null) {
							content = '<div><i class="fas fa-sort"></i></div>'
						}

						return content
					}, this)
				},
				{
					"title": "Name",
					"data": "attributes.fieldName",
					"orderable": false
				},
				{
					"title": "Type",
					"data": "attributes.fieldType",
					"orderable": false
				},
				{
					"title": "Required",
					"data": "attributes.isRequired",
					"orderable": false,
					"render": function (data) {
						return '<div>' + (data ? 'Yes' : 'No') + '</div>';
					}
				},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					resizable: false,
					"width": "100px",
					"render": function () {
						return '<div class="text-align-right show-on-row-hover" style="width:80px"><button type="button" class="btn btn-info edit-field ml-1"><span class="fal fa-pencil"></span></button><button type="button" class="btn btn-danger delete-field ml-1"><span class="fal fa-trash"></span></button></div>';
					}
				}
			]
		});
	},
	addClicked: function () {
		let newField = new this.options.fieldModel({
			fieldName: "",
			fieldType: PJQ.constants.customFields.fieldTypes.TEXT,
			isRequired: false,
			defaultValue: "",
			description: "",
			sortOrder: this.collection.length + 1
		});
		let names = [];
		_.each(this.collection.models, function (model) {
			names.push(model.get('fieldName'))
		});
		this.editField(newField, names);
	},
	editClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr')),
			field = row.data(),
			names = [];
		_.each(this.collection.models, function (model) {
			if (field.get('fieldName') !== model.get('fieldName')) {
				names.push(model.get('fieldName'))
			}
		});
		this.editField(field, names);
	},
	editField: function (field, names) {
		new PJQ.views.settings.EditCustomFieldModal({
			model: field,
			names: names,
			newSort: _.bind(function (field) {
				this.collection.add(field);
				this.dataTable.addRow(field);
				this.dataTable.refresh();
			}, this),
			onSave: _.bind(function (field) {
				if (field.hasChanged() || field.isNew()) {
					if (field.isNew()) {
						this.collection.add(field);
						this.dataTable.addRow(field);
						this.dataTable.refresh()
					}
					field.save(null, {
						notify: true,
						success: _.bind(function () {
							field.fetch({
								success: _.bind(function () {
									this.dataTable.refresh();

									PJQ.notifications.notify.successNotify({
										message: 'Custom field saved successfully'
									});
								}, this)
							});
						}, this)
					});
				}
			}, this),
			onClose: _.bind(function (field) {
				if (field ? field.hasChanged() : field) {
					field.fetch({
						success: _.bind(function () {
							this.dataTable.refresh();
						}, this)
					});
				}
			}, this),
			onDelete: _.bind(function (field) {
				if (field.id > 0) {
					let row = this.dataTable.getRow(field.cid);
					this.collection.remove(field);
					field.destroy();
					if (row != null) {
						this.dataTable.removeRow(row);
					}
				}
			}, this)
		});
	},
	deleteClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.deleteField(row);
	},
	deleteField: function (row) {
		let field = row.data();
		let sortNumber = field.attributes.sortOrder;
		_.each(this.collection.models, function (model) {
			if (model.get('sortOrder') > sortNumber) {
				let newNumber = (model.get('sortOrder') - 1);
				model.set('sortOrder', newNumber);
			}
		});
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this field?",
			onDelete: _.bind(function () {
				this.collection.remove(field);
				field.destroy();
				this.dataTable.removeRow(row);
			}, this)
		});
	},
	fetchCollection: function () {
		this.collection.fetch();
	},
	sortFieldsAlpha: function () {
		if (this.fieldModelName === 'project') {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'settings',
						value: 'sortprojectfieldsalpha'
					},
				])
			}).put().done(_.bind(function () {
				this.collection.fetch({
					success: _.bind(function () {
						this.dataTable.render();
					}, this)
				})
			}, this));
		}
		else if (this.fieldModelName === 'contact') {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'settings',
						value: 'sortcontactfieldsalpha'
					},
				])
			}).put().done(_.bind(function () {
				this.collection.fetch({
					success: _.bind(function () {
						this.dataTable.render();
					}, this)
				})
			}, this));

		}
		else if (this.fieldModelName === 'company') {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'settings',
						value: 'sortcontactcompanyfieldsalpha'
					},
				])
			}).put().done(_.bind(function () {
				this.collection.fetch({
					success: _.bind(function () {
						this.dataTable.render();
					}, this)
				})
			}, this));

		}
		else if (this.fieldModelName === 'submittals') {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'settings',
						value: 'sortsubmittalfieldsalpha'
					},
				])
			}).put().done(_.bind(function () {
				this.collection.fetch({
					success: _.bind(function () {
						this.dataTable.render();
					}, this)
				})
			}, this));
		}
		else {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'settings',
						value: 'sortpunchlistfieldsalpha'
					},
				])
			}).put().done(_.bind(function () {
				this.collection.fetch({
					success: _.bind(function () {
						this.dataTable.render();
					}, this)
				})
			}, this));
		}
	}
});

PJQ.views.settings.EditCustomFieldModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Edit-Custom-Field'),
		subTemplates: {
			choice: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Custom-Field-Choice')
		},
		maxWidth: 600
	},
	events: {
		'click .btn-delete-choice': 'deleteChoice',
		'click .btn-add-choice': 'addChoice',
		'click .field-save': 'save',
		'click .field-close': 'close',
		'click .field-delete': 'delete',
		'keydown .input-default-integer': 'numbersOnly',
		'change .input-multiple-choice': 'render',
		'click .btn-sort-alpha': 'sortChoicesAlpha',
		'click .btn-is-required': 'checkAllSub',
		'colorpickerChange': 'setBGColor',
		'keyup .colorpicker-input-box': 'setBGColor',
		'change .cb-read-only': 'render'
	},
	beforeRender: function () {
		if (this.model instanceof PJQ.models.contacts.ContactCustomField) {
			this.fieldModel = 'contact';
		}
		else if (this.model instanceof PJQ.models.contacts.CompanyCustomField) {
			this.fieldModel = 'company';
		}
		else if (this.model instanceof PJQ.models.projects.ProjectCustomField) {
			this.fieldModel = 'project';
		}
		else if (this.model instanceof PJQ.models.actionItems.ActionItemCustomField) {
			this.fieldModel = 'actionItems';
		}
		else if (this.model instanceof PJQ.models.punchlists.PunchlistCustomField) {
			this.fieldModel = 'punchList';
		}
		else if (this.fieldModel instanceof PJQ.models.commitments.CustomField) {
			this.fieldModelName = 'commitment';
		}
		else if (this.fieldModel instanceof PJQ.models.commitments.ChangeOrderCustomField) {
			this.fieldModelName = 'commitmentChangeOrder';
		}
		else if (this.fieldModel instanceof PJQ.models.primeContracts.CustomField) {
			this.fieldModelName = 'primeContract';
		}
		else if (this.fieldModel instanceof PJQ.models.primeContracts.ChangeOrderCustomField) {
			this.fieldModelName = 'primeContractChangeOrder';
		}
		else if (this.fieldModel instanceof PJQ.models.directcosts.CustomField) {
			this.fieldModelName = 'directCost';
		}
		else if (this.fieldModel instanceof PJQ.models.invoicing.PayableInvoiceCustomField) {
			this.fieldModelName = 'payableInvoice';
		}
		else if (this.fieldModel instanceof PJQ.models.invoicing.ReceivableInvoiceCustomField) {
			this.fieldModelName = 'receivableInvoice';
		}
		else if (this.model instanceof PJQ.models.schedule.ScheduleCustomField) {
			this.fieldModel = 'schedule';
		}
		else if (this.model instanceof PJQ.models.submittals.SubmittalCustomField) {
			this.fieldModel = 'submittals';
		}
		else if (this.model instanceof PJQ.models.meetings.CustomField) {
			this.fieldModel = 'meetings';
		}
		else if (this.model instanceof PJQ.models.changeRequests.CustomField) {
			this.fieldModel = 'changeRequest'
		}
	},
	renderData: function () {
		return {
			model: this.model,
			fieldModel: this.fieldModel
		};
	},
	afterRender: function () {
		new PJQ.Binder(this.$el, this.model, {
			setDefaultValues: true,
			watchElements: [
				'input',
				'textarea'
			]
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-field-type'),
			noneSelectedText: 'Select Field Type',
			defaultValue: this.model.get('fieldType'),
			onChange: _.bind(function (value) {
				this.model.set({
					fieldType: value.toUpperCase(),
					defaultValue: ""
				});
				this.render();
			}, this),
		});
		if(this.fieldModel === "project"){
			this.renderColorPicker();
		}

		if (this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.DATE || this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.DATETIME) {
			new PJQ.inputs.Datepicker({
				el: this.$('.input-default-date'),
				isShowTimezone: false,
				datepickerOptions: {
					defaultDate: this.model.get('defaultValue'),
					format: this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.DATE ? PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE : PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME
				},
				onChange: _.bind(function (value) {
					this.model.set('defaultValue', value);
				}, this),
			});
		}
		else if (this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.MONEY) {
			PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2);
		}
		else if (this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.PERCENT) {
			PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-decimal'), 2);
		}
		else if (this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.BOOL) {
			new PJQ.inputs.Selectpicker({
				el: this.$('.select-default-bool'),
				defaultValue: this.model.get('defaultValue'),
				onChange: _.bind(function (value) {
					if (value === "true") {
						this.model.set('defaultValue', true)
					}
					else if (value === "false") {
						this.model.set('defaultValue', false)
					}
				}, this),
			});
		}
		else if (this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.CHOICE) {
			let defaultId = null;
			if (_.size(this.model.get('defaultValue')) > 0) {
				let defaultChoice = "";
				_.each(this.model.choices.models, function (choice) {
					if (choice.get('id') == this.model.get('defaultValue')) {
						defaultChoice += choice.cid
					}
				}, this);
				if (defaultChoice != null) {
					defaultId = defaultChoice
				}
			}
			this.choicePicker = new PJQ.inputs.Selectpicker({
				el: this.$('.select-default-choice'),
				defaultValue: defaultId,
				onChange: _.bind(function (value) {
					let choice = this.model.choices.get(value);
					if(choice == null){
						this.model.set('defaultValue', null);
					}
					else if(choice.get('id') > 0) {
						this.model.set('defaultValue', choice.get('id'));
					}
					else{
						choice.set('isDefault', true);
					}
				}, this),
			});
			this.updateChoicePicker();
			this.renderChoices();
		}
	},
	updateChoicePicker: function () {
		this.choicePicker.updateChoices(_.map(this.model.choices.models, function (choice) {
			return {
				id: choice.cid,
				name: choice.get('choiceName')
			};
		}));
	},
	renderChoices: function () {
		let $choices = this.$('.custom-field-choices');
		$choices.empty();
		if (_.size(this.model.choices.models) > 0) {
			_.each(_.sortBy(_.filter(this.model.choices.models, function (model) {
				return !model.get('isDeleted');
			}), function (model) {
				return model.get('sortOrder');
			}), _.bind(function (choice) {
				this.renderChoice(choice);
			}, this));
		}
		else {
			$choices.append($('<div>', {
				class: 'no-choices-text fs-16 font-weight-light text-muted text-align-center mt-2 mb-2',
				text: 'No choices added yet'
			}));
		}
	},
	renderChoice: function (choice) {
		let $choices = this.$('.custom-field-choices');
		$choices.find('.no-choices-text').remove();
		this.renderSubTemplate(true, this.options.subTemplates.choice, $choices, {
			model: choice
		}, _.bind(function ($choice) {
			new PJQ.Binder($choice, choice, {
				setDefaultValues: true,
				watchElements: [
					'input'
				],
				afterChange: _.bind(function () {
					this.model.isDirty = true;
					this.updateChoicePicker();
				}, this)
			});
		}, this));
		let self = this;
		self.fieldSortable = new PJQ.Sortable(self.$('.custom-field-choices'), {
			containment: "parent",
			items: '.custom-field-choice',
			connectWith: '.custom-field-choice',
			onStop: function () {
				self.$('.custom-field-choice').each(function (index) {
					let name = $(this).data('name'),
						sortItem = _.find(self.model.choices.models, function (choice) {
							return choice.get('choiceName') === name
						}),
						sortOrder = index + 1;
					sortItem.set('sortOrder', sortOrder);
				});
				self.model.save();
			}
		});
	},
	renderColorPicker: function (e) {
		this.colorPicker = new PJQ.colors.ColorPicker(this.$('.color-picker'), {
			format: 'hex',
			color: _.size(this.model.get('color')) > 0 ? this.model.get('color') : '#000000',
			autoInputFallback: false
		});
		this.$('.colorpicker-input-box').val(_.size(this.model.get('color')) > 0 ? this.model.get('color') : '#000000');
	},
	setBGColor: function (e) {
		if (e.type === 'keyup') {
			if (e.keyCode === 13) {
				$(e.currentTarget).blur()
			}
			let color = this.$('.colorpicker-input-box').val();
			if (color.split('')[0] === '#' && color.trim().length === 7) {
				this.colorPicker.setColor(color);
				this.model.set('color', color.toUpperCase());
				PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), true);
			}
		}

		else {
			let color = this.colorPicker.getColor();
			if (color.split('')[0] === '#' && color.trim().length === 7) {
				this.$('.colorpicker-input-box').val(color);
				this.model.set('color', color);
				PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), true);
			}
		}
	},
	validate: function () {
		let isValid = true,
			isDuplicate = false;

		PJQ.helpers.inputHelpers.setInputError(this.$('.input-field-name'), true);
		_.each(this.options.names, function (name) {
			if (this.$('.input-field-name').val().trim() === name) {
				isValid = false;
				isDuplicate = true;
				PJQ.helpers.inputHelpers.setInputError(this.$('.input-field-name'), false)
			}
		}, this);

		if (this.$('.input-field-name').val().trim().length === 0) {
			isValid = false;
			PJQ.helpers.inputHelpers.setInputError(this.$('.input-field-name'), false);
		}

		if (this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.CHOICE) {
			$('.input-custom-field-choice-name').each(function () {
				let $choice = $(this);
				if ($choice.val().trim().length === 0) {
					isValid = false;
					PJQ.helpers.inputHelpers.setInputError($choice, false);
				}
				else {
					PJQ.helpers.inputHelpers.setInputError($choice, true);
				}
			})
		}

		if (!isValid && isDuplicate) {
			new PJQ.Alert(this.$('.validation-error'), {
				type: 'danger',
				text: 'Field name already exists!'
			})
		}
		else if (!isValid) {
			new PJQ.Alert(this.$('.validation-error'), {
				type: 'danger',
				text: 'Required fields are empty'
			});
		}
		else {
			this.$('.validation-error').empty();
		}
		return isValid;
	},
	addChoice: function () {
		let newChoice = new PJQ.models.customFields.CustomFieldChoice({
			choiceName: "",
			sortOrder: _.size(this.model.choices.models) + 1
		});
		this.model.choices.add(newChoice);
		this.renderChoice(newChoice);
		this.$('.input-custom-field-choice-name').last().focus();
		this.updateChoicePicker();
	},
	deleteChoice: function (e) {
		let $choice = $(e.currentTarget).closest('.custom-field-choice'),
			cid = $choice.data('cid'),
			choice = this.model.choices.get(cid);

		if (choice.id > 0) {
			choice.set('isDeleted', true);
			this.model.isDirty = true;
		}
		else {
			this.model.choices.remove(cid);
		}
		$choice.remove();

		if (this.model.get('defaultValue') === choice.id)
			this.model.set('defaultValue', null);

		this.updateChoicePicker();
	},
	checkAllSub: function(e) {
		let isChecked = e.target.checked;
		let $visible = this.$('.btn-is-visible'),
			$editable = this.$('.btn-is-editable')
		if(this.fieldModel === 'contact' || this.fieldModel === 'company') {
			$visible.attr('disabled', isChecked);
			$editable.attr('disabled', isChecked);
			if (isChecked) {
				this.model.set('isVisibleInRSVP', true)
				this.model.set('isChangeableInRSVP', true)
				$visible[0].checked = true;
				$editable[0].checked = true;
			}
		}
	},
	save: function () {
		if (!this.validate())
			return;

		if (this.options.onSave) {
			this.options.onSave(this.model);
			this.removeModal();
		}
	},
	close: function () {
		if (this.model.hasChanged()) {
			new PJQ.views.modals.SaveDontSave({
				header: "Unsaved Changes",
				body: "Do you want to save changes?",
				onSave: _.bind(function () {
					this.save();
				}, this),
				onDontSave: _.bind(function () {
					if (this.options.onClose) {
						this.options.onClose(this.model);
					}
					this.removeModal();
				}, this)
			});
		}
		else if (this.options.onClose) {
			this.options.onClose(this.model);
			this.removeModal();
		}
	},
	numbersOnly: function (e) {
		return PJQ.helpers.inputHelpers.numbersOnly(e);
	},
	delete: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this field?",
			onDelete: _.bind(function () {
				if (this.options.onDelete) {
					this.options.onDelete(this.model);
				}
				this.removeModal();
			}, this)
		});
	},
	fetchModel: function () {
		this.model.fetch();
	},
	sortChoicesAlpha: function () {
		let newModel;
		if (this.model.isNew()) {
			newModel = true;
		}
		this.model.save(null, {
			success: _.bind(function () {
				if (this.fieldModel === 'project') {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'settings'
							},
							{
								endpoint: 'sortprojectchoicesalpha',
								value: this.model.get('id')
							},
						])
					}).put().done(_.bind(function () {
						this.model.fetch({
							success: _.bind(function () {
								this.render();
								if (newModel) {
									this.options.newSort(this.model);
								}
							}, this)
						})
					}, this));
				}
				else if (this.fieldModel === 'contact') {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'settings'
							},
							{
								endpoint: 'sortcontactchoicesalpha',
								value: this.model.get('id')
							},
						])
					}).put().done(_.bind(function () {
						this.model.fetch({
							success: _.bind(function () {
								this.render();
								if (newModel) {
									this.options.newSort(this.model);
								}
							}, this)
						})
					}, this));
				}
				else if (this.fieldModel === 'company') {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'settings'
							},
							{
								endpoint: 'sortcontactcompanychoicesalpha',
								value: this.model.get('id')
							},
						])
					}).put().done(_.bind(function () {
						this.model.fetch({
							success: _.bind(function () {
								this.render();
								if (newModel) {
									this.options.newSort(this.model);
								}
							}, this)
						})
					}, this));
				}
				else if (this.fieldModel === 'submittals') {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'settings'
							},
							{
								endpoint: 'sortsubmittalchoicesalpha',
								value: this.model.get('id')
							},
						])
					}).put().done(_.bind(function () {
						this.model.fetch({
							success: _.bind(function () {
								this.render();
								if (newModel) {
									this.options.newSort(this.model);
								}
							}, this)
						})
					}, this));
				}
				else {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'settings'
							},
							{
								endpoint: 'sortpunchlistchoicesalpha',
								value: this.model.get('id')
							},
						])
					}).put().done(_.bind(function () {
						this.model.fetch({
							success: _.bind(function () {
								this.render();
								if (newModel) {
									this.options.newSort(this.model);
								}
							}, this)
						})
					}, this));
				}
			}, this)
		});
	}
});

PJQ.views.settings.DailyReportSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Daily-Reports')
    },
    events: {},
    beforeFirstRender: function () {
    },
    beforeRender: function () {
    },
    afterRender: function () {

    }
});

PJQ.views.directcosts = PJQ.views.directcosts ? PJQ.views.directcosts : {};
PJQ.views.directcosts.DirectCostSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'direct-costs'),
        model: null,
        customFields: null
    },
    events: {

    },
    afterRender: function() {
        new PJQ.inputs.Selectpicker({
            el: this.$('.select-default-accounting-method'),
            isIntChoices: true,
            isMultiple: false,
            defaultValue: this.model.get('defaultAccountingMethod') != null ? this.model.get('defaultAccountingMethod') : PJQ.constants.budget.accountingMethod.UNIT_QUANTITY,
            onChange: _.bind(function (value) {
                this.model.set('defaultAccountingMethod', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});

PJQ.views.settings.FinanceCoreFieldSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Finance-Core-Fields')
    },
    events: {
        'click .cb-visible': 'isVisibleChanged',
        'click .cb-required': 'isRequiredChanged',
    },
    beforeFirstRender: function () {
        let fnRender = _.bind(function(fillFields){
            _.each(fillFields, _.bind(function (field, index) {
                let matchField = this.collection.findWhere({fieldName: field.fieldName});
                if (matchField == null) {
                    this.collection.add(_.defaults(field, {
                        isVisible: true,
                        isRequired: false,
                        sortOrder: index,
                        canContactEdit: field.canEdit !== false
                    }));
                }
                else {
                    matchField.set({
                        name: field.name,
                        sortOrder: index,
                        canContactEdit: field.canEdit !== false
                    });
                }
            }, this));

            this.render();
        }, this);
        if(this.options.context){
            switch (this.options.context){
                case 'primecontracts':
                    PJQ.app.session.fetchPrimeContractFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.primeContacts.primeContract);
                    }, this));
                    break;
                case 'commitments':
                    PJQ.app.session.fetchCommitmentFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.commitments.commitment);
                    }, this));
                    break;
                case 'commitmentchangeorders':
                    PJQ.app.session.fetchCommitmentChangeOrderFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.commitments.changeOrder);
                    }, this));
                    break;
                case 'primecontractchangeorders':
                    PJQ.app.session.fetchPrimeContractChangeOrderFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.primeContacts.changeOrder);
                    }, this));
                    break;
                case 'receivableinvoices':
                    PJQ.app.session.fetchReceivableInvoiceFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.invoices.receivableInvoice);
                    }, this));
                    break;
                case 'payableinvoices':
                    PJQ.app.session.fetchPayableInvoiceFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.invoices.payableInvoice);
                    }, this));
                    break;
                case 'directcosts':
                    PJQ.app.session.fetchDirectCostFieldSettings(_.bind(function(fields) {
                        this.collection = fields;
                        fnRender(PJQ.constants.financeCoreFields.directCosts.directCost);
                    }, this));
                    break;
            }
        }
    },
    afterRender: function () {
        if (this.collection == null || !this.collection.isFetched) {
            return;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".field-table"),
            data: this.collection.models,
            isHideSearch: true,
            paging: false,
            rowId: "cid",
            order: [0, 'asc'],
            columns: [
                {
                    "title": "",
                    "data": "attributes.sortOrder",
                    "visible": false
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": false
                },
                {
                    "title": "Visible",
                    "data": "attributes.isVisible",
                    "orderable": false,
                    "render": function (data, type, row) {
                        let contactEdit = row.get('canContactEdit') !== false;
                        return '<div class="pretty p-switch" ' + (contactEdit ? '' : 'title="This field is never visible to contacts"') + '><input ' + (contactEdit ? '' : 'disabled') + ' type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-visible"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>';
                    }
                },
                {
                    "title": "Required",
                    "data": "attributes.isRequired",
                    "orderable": false,
                    "render": function (data, type, row) {
                        let contactEdit = row.get('canContactEdit') !== false;
                        return '<div class="pretty p-switch" ' + (contactEdit ? '' : 'title="This field is never visible to contacts"') + '><input ' + (contactEdit ? '' : 'disabled') + ' type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-required"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>';
                    }
                }
            ]
        });
    },
    isVisibleChanged: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row),
            setting = row.data(),
            enabled = $target.prop('checked');
        setting.set('isVisible', enabled);

        if (!enabled) {
            // if the field is made invisible to contacts
            // it must be made not required for contacts
            setting.set('isRequired', false);
        }

        setting.queueSave();
        this.dataTable.refresh();
    },
    isRequiredChanged: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row),
            setting = row.data();
        setting.set('isRequired', $target.prop('checked'));
        if(!setting.get('isVisible') && $target.prop('checked')){
            setting.set('isVisible', true);
        }

        setting.queueSave();
        this.dataTable.refresh();
    }
});
PJQ.views.settings.GroupSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Groups')
    },
    events: {
        'click .add-group': 'addClicked',
        'click .edit-group': 'editClicked',
        'click .delete-group': 'deleteClicked',
        'click tr': 'selectGroup',
        'click .merge-groups': 'mergeGroups',
        'click .link-groups': 'changeLinked',
        'click .btn-sort-alpha': 'sortGroupsAlpha'
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            linkStatus: (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED))
        };
    },
    afterRender: function () {
        $('.link-groups').prop('hidden', !PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY));
        $('.current-status').prop('hidden', !PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY));
        if (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED)) {
            let $button = $('.link-groups');
            $button.append("Unlink All Groups");
        } else {
            $('.link-groups').append("Link Groups");
        }

        this.groupLevels = parseInt(PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS));
        this.groupLevels = this.groupLevels ? this.groupLevels : 1;
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".group-table"),
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new group'
            },
            sortableOptions: {
                data: this.collection,
                containment: ".group-table"
            },
            pageLength: 50,
            bSort: false,
            onRowDoubleClick: _.bind(function (row) {
                let groupArr = _.each(this.collection.models, function (model) {
                    let groups = [];
                    groups.push(model.attributes.groupName);
                    return groups
                }, this);
                this.editGroup(row.data(), groupArr);
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            let groupArr = _.each(this.collection.models, function (model) {
                                let groups = [];
                                groups.push(model.attributes.groupName);
                                return groups
                            }, this);
                            this.editGroup(row.data(), groupArr);
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteGroup(row);
                        }, this)

                    }
                ]
            },
            columns: [
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "orderable": false,
                    "visible": false,
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (data != null) {
                            content = '<div><i class="fas fa-sort"></i></div>'
                        }

                        return content
                    }, this)
                },
                {
                    "title": "Name",
                    "data": "attributes.groupName",
                    "orderable": true
                },
                {
                    "title": "Parent Group",
                    "defaultContent": "",
                    "data": "attributes.groupDescription",
                    "orderable": true,
                    "render": _.bind(function (data) {
                        if (data.includes("|")) {
                            return data.replace(/\|/g, " / ")
                        } else {
                            return data
                        }
                    })
                },
                {
                    "title": "Created On",
                    "data": "attributes.createdOn",
                    "orderable": true,
                    "render": _.bind(function (data) {
                        if (data) {
                            let date = PJQ.helpers.dateHelpers.parseDateString(data);
                            return PJQ.helpers.dateHelpers.getDateString(date, "MM/dd/yyyy")
                        }
                    })
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "100px",
                    "render": _.bind(function (data, type, row) {
                        return '<div class="text-align-right show-on-row-hover" style="width:80px;"><button type="button" class="btn btn-info edit-group ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button><button type="button" class="btn btn-danger delete-group ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button></div>';
                    }, this)
                }
            ]
        });

        this.groupLevelSelect = new PJQ.inputs.Selectpicker({
            el: this.$('.input-group-levels'),
            defaultValue: this.groupLevels,
            onChange: _.bind(function (value) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Change Group Levels?",
                    body: 'Changing group levels will delete all existing parent groups.  Do you still want to change group levels?',
                    deleteButtonText: "Confirm",
                    deleteButtonColorClass: 'success',
                    declineButtonText: "Decline",
                    declineButtonColorClass: "danger",
                    onDelete: _.bind(function () {
                        new PJQ.ajax.Request({
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'groups',
                                    value: 'level'
                                }
                            ], [
                                {
                                    parameter: 'level',
                                    value: value
                                }
                            ])
                        }).post().done(_.bind(function () {
                            PJQ.app.session.fetch({
                                success: _.bind(function () {
                                    PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.GROUP_LEVELS, value);
                                    this.collection.fetch({
                                        success: _.bind(function () {
                                            PJQ.notifications.notify.successNotify({
                                                message: 'Group Level Successfully Changed'
                                            });
                                            this.render()
                                        }, this)
                                    });
                                }, this)
                            });
                        }, this));
                    }, this),
                    onCancel: _.bind(function () {
                        this.render()
                    }, this)
                });
            }, this)
        });
    },
    addClicked: function () {
        let newGroup = new this.options.groupModel({
            groupName: "",
            groupDescription: "",
            sortOrder: this.collection.length + 1,
            createdOn: PJQ.helpers.dateHelpers.getDateString(new Date(), "MM/dd/yyyy")
        });
        let groupArr = _.each(this.collection.models, function (model) {
            let groups = [];
            groups.push(model.attributes.groupName);
            return groups
        }, this);
        this.editGroup(newGroup, groupArr);
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            group = row.data(),
            groupArr = _.each(this.collection.models, function (model) {
                let groups = [];
                groups.push(model.attributes.groupName);
                return groups
            }, this);

        this.editGroup(group, groupArr);
    },
    changeLinked: function () {
        let isLinked = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED);
        if (!isLinked) {
            new PJQ.views.settings.GroupLinkModal({
                onSuccess: _.bind(function () {
                    PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED, !isLinked);
                    PJQ.notifications.notify.successNotify({
                        message: 'Groups successfully Linked'
                    });
                    this.render();
                }, this),
                onError: _.bind(function () {
                    PJQ.notifications.notify.errorNotify({
                        message: 'An error has occurred.  Please check and make sure you have selected an excel file, and that it is correctly formatted.'
                    });
                }, this)
            })
        } else {
            new PJQ.views.modals.YesNo({
                header: "Unlink Groups",
                body: 'Are you sure you would like to unlink groups?',
                onYes: _.bind(function () {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'groups',
                                value: 'unlink'
                            }
                        ])
                    }).post().done(_.bind(function () {
                        PJQ.app.session.fetch({
                            success: _.bind(function () {
                                PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED, !isLinked);
                                PJQ.notifications.notify.successNotify({
                                    message: 'Groups successfully Unlinked'
                                });
                                this.render();
                            }, this)
                        });
                    }, this));
                }, this)
            });
        }
    },
    editGroup: function (group, extra) {
        new PJQ.views.settings.EditGroupModal({
            model: group,
            groupArr: extra,
            groupLevels: this.groupLevels,
            onSave: _.bind(function (group) {
                let isNew = group.isNew();
                if (group.hasChanged() || isNew) {
                    group.save(null, {
                        notify: true,
                        success: () => {
                            if (isNew) {
                                this.collection.add(group);
                                this.dataTable.addRow(group);
                            }
                            this.dataTable.refresh();
                        }
                    });
                }
            }, this),
            onClose: _.bind(function (group) {
                if (group ? group.hasChanged() : group) {
                    group.fetch({
                        success: _.bind(function () {
                            this.dataTable.refresh();
                        }, this)
                    });
                }
            }, this),
            onDelete: _.bind(function (group) {
                if (group.id > 0) {
                    let row = this.dataTable.getRow(group.cid);
                    this.collection.remove(group);
                    group.destroy();
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                }
            }, this)
        });
    },
    sortGroupsAlpha: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'groups',
                    value: 'sortalpha'
                },
            ]), data: {
                groupLevels: this.groupLevels
            }
        }).put().done(_.bind(function () {
            this.collection.fetch({
                success: _.bind(function () {
                    PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.GROUP_LEVELS, parseInt(this.groupLevelSelect.getValue()));
                    this.dataTable.render();
                }, this)
            });
        }, this));
    },
    selectGroup: function (e) {
        if (e.ctrlKey === true) {
            let target = $(e.currentTarget);
            target.toggleClass('selected');
            this.checkMergeButton()
        }
    },
    checkMergeButton: function () {
        if (this.dataTable.dataTable.rows('.selected').data().length >= 2) {
            $('.merge-groups').attr('disabled', false);
        } else {
            $('.merge-groups').attr('disabled', true);
        }
    },
    mergeGroups: function () {
        let groupArray = [];
        _.each(this.dataTable.dataTable.rows('.selected').data(), function (group) {
            groupArray.push(group)
        });
        new PJQ.views.settings.MergeGroupsModal({
            groups: groupArray,
            onSave: _.bind(function () {
                this.collection.fetch({
                    success: _.bind(function () {
                        let page = this.dataTable.dataTable.page();
                        this.$('.merge-groups').attr('disabled', true);
                        this.dataTable.render();
                        this.dataTable.dataTable.page(page).draw('page');
                    }, this)
                });

            }, this)
        })
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteGroup(row);
    },
    deleteGroup: function (row) {
        let group = row.data();

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this field?",
            onDelete: _.bind(function () {
                this.collection.remove(group);
                group.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.settings.MergeGroupsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Merge-Groups'),
        maxWidth: 250
    },
    events: {
        'click .merge-save': 'splitGroups',
        'click .merge-close': 'onClose'
    },
    beforeRender: function () {
        this.renderData = {
            groups: this.options.groups
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ]
        });

        this.mergePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.merge-groups'),
            onChange: _.bind(function (value) {

            }, this)
        });
    },
    onClose: function () {
        this.removeModal()
    },
    splitGroups: function () {
        let mergeInto = parseInt(this.mergePicker.getValue()),
            mergeGroups = [];
        _.each(this.options.groups, function (group) {
            if (group.get('groupId') !== mergeInto) {
                mergeGroups.push(group.get('groupId'))
            }
        });
        mergeGroups = mergeGroups.join('|');
        this.onSave(mergeInto, mergeGroups)
    },
    onSave: function (group, mergeGroups) {
        let loader = new PJQ.Loader(this.$('.modal-body'));
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'groups',
                    value: 'merge'
                },
            ], [
                {
                    parameter: 'groupId',
                    value: group
                },
                {
                    parameter: 'groupIdToMerge',
                    value: mergeGroups
                }
            ])
        }).put().done(_.bind(function () {
            loader.remove();
            this.options.onSave();
            this.removeModal();
        }, this));
    }
});

PJQ.views.settings.EditGroupModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Edit-Groups'),
        maxWidth: 600
    },
    events: {
        'click .group-save': 'validate',
        'click .group-close': 'close',
        'click .group-delete': 'delete',
        'focusout .group-desc': 'updateTotal',
        'focusout .group-desc-sub': 'updateTotal',
        "click .btn-new-parent": "groupTwoNew",
        'click .btn-existing-parent': "groupTwoExisting",
        "click .btn-new-sub-parent": "groupThreeNew",
        'click .btn-existing-sub-parent': "groupThreeExisting",
        'click .change-to-existing': "groupTwoExisting",
        'click .change-to-existing-sub': "groupThreeExisting"
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            options: this.options,
            groupArr: this.options.groupArr
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ]
        });
        this.groupTwoPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-parent-group'),
            noneSelectedText: 'Select Parent Group',
            defaultValue: this.model.get('groupDescription').split('|')[0],
            onChange: _.bind(function (value) {
                if (this.options.groupLevels === 2) {
                    this.model.set('groupDescription', value);
                }
                if (this.options.groupLevels === 3) {
                    this.$('.group-desc').val(value);
                    this.updateTotal();
                }
            }, this),
            liveSearch: true
        });

        this.groupThreePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-sub-parent-group'),
            noneSelectedText: 'Select Sub-Parent Group',
            defaultValue: this.model.get('groupDescription').split('|')[1],
            onChange: _.bind(function (value) {
                if (this.options.groupLevels === 3) {
                    this.$('.group-desc-sub').val(value);
                    this.updateTotal();
                }
            }, this),
            liveSearch: true
        });
        this.showExistButtons()
    },
    showExistButtons: function () {
        let show = [],
            subShow = [];
        _.each(this.options.groupArr, function (model) {
            if (_.size(model.get('groupDescription')) > 0) {
                show.push(model);
                if (model.get('groupDescription').includes('|')) {
                    subShow.push(model);
                }
            }
        });
        if (_.size(show) > 0) {
            $('.btn-existing-parent').attr('hidden', false);
        }
        if (_.size(subShow) > 0) {
            $('.btn-existing-sub-parent').attr('hidden', false);
        }
    },
    updateTotal: function () {
        if (this.options.groupLevels === 3 && this.$('.group-desc-sub').val().length > 0) {
            this.$('.group-desc-total').val(this.$('.group-desc').val() + "|" + this.$('.group-desc-sub').val())
        } else {
            this.$('.group-desc-total').val(this.$('.group-desc').val())
        }
    },
    groupTwoNew: function () {
        $('.new-or-existing-parent').hide();
        $('.new-parent-group').attr('hidden', false);
    },
    groupTwoExisting: function () {
        this.model.get('groupDescription').length > 0 ? $('.parent-group').hide() : $('.new-or-existing-parent').hide();
        $('.existing-parent-group').attr('hidden', false);
        this.groupTwoPicker.updateChoices(_.each([...new Set(_.map(_.filter(this.options.groupArr, _.bind(function (item) {
            return (_.size(item.attributes.groupDescription) > 0);
        }, this)), function (item) {
            return item.attributes.groupDescription.split(/\|/)[0]
        }))], function (arr) {
            return arr;
        }))
    },
    groupThreeNew: function () {
        $('.new-or-existing-sub-parent').hide();
        $('.new-sub-parent-group').attr('hidden', false);
    },
    groupThreeExisting: function () {
        this.model.get('groupDescription').length > 0 ? $('.sub-parent-group').hide() : $('.new-or-existing-sub-parent').hide();
        $('.existing-sub-parent-group').attr('hidden', false);
        this.groupThreePicker.updateChoices(_.each([...new Set(_.map(_.filter(this.options.groupArr, _.bind(function (item) {
            return item.attributes.groupDescription.includes("|")

        }, this)), function (item) {
            return item.attributes.groupDescription.split(/\|/)[1]
        }))], function (set) {
            return set
        }))
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    if (this.options.onClose) {
                        this.options.onClose(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else if (this.options.onClose) {
            this.options.onClose(this.model);
            this.removeModal();
        }
    },
    validate: function () {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }
        let match = 0,
            errors = 0,
            errorMsg = "",
            id = this.model.get('groupId');
        if (this.$('.input-group-name').val().length <= 0) {
            errorMsg += "Name must be included";
            errors++
        }
        _.each(this.options.groupArr, function (model) {
            if (model.attributes.groupId !== id)
                if (model.attributes.groupName === this.$('.input-group-name').val()) {
                    match++
                }

        }, this);
        if (match > 0) {
            errors++;
            errorMsg += "Group name already exists"

        }
        if (errors === 0) {
            this.save();
        } else {
            this.renderError(errorMsg)
        }
    },
    renderError: function (text) {
        this.$('.group-save').prop('disabled', false);
        this.errorAlert = new PJQ.Alert(this.$('.error'), {
            type: 'danger',
            text: text
        });
    },
    save: function () {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }
        if (this.options.onSave) {
            if (this.options.groupLevels === 3 && this.$('.group-desc-total').val().length > 0) {
                this.model.set('groupDescription', this.$('.group-desc-total').val());
            }
            this.options.onSave(this.model);
            this.removeModal();
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this field?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.settings.GroupLinkModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Link-Groups'),
        maxWidth: 600
    },
    afterRender: function () {
        let isLinked = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED);
        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.group-map-file-uploader'),
            canUpload: true,
            dictDefaultMessage: "Drop Trade Mapping file here or click to upload",
            canDelete: false,
            isRemoveOnComplete: true,
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'groups',
                    value: 'link'
                }
            ]),
            onSuccess: _.bind(function () {
                this.removeModal();
                this.options.onSuccess();
            }, this),
            onError: _.bind(function (result) {
                this.removeModal();
                this.options.onError()
            }, this)
        });
    }
});

PJQ.views.settings.PayableInvoiceSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'payable-invoices'),
        model: null,
        customFields: null
    },
    events: {},
    beforeFirstRender: function () {
        this.listenTo(this.model, 'fetch', this.render);
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(this.onChange, this)
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format'),
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('numberFormat', value);
                this.onChange();
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.model);
        }
    }
});

PJQ.views.settings.ReceivableInvoiceSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'receivable-invoices'),
        model: null,
        customFields: null
    },
    events: {},
    beforeFirstRender: function () {
        this.listenTo(this.model, 'fetch', this.render);
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(this.onChange, this)
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format'),
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('numberFormat', value);
                this.onChange();
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.model);
        }
    }
});
PJQ.views.meetings = PJQ.views.meetings ? PJQ.views.meetings : {};
PJQ.views.meetings.MeetingSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'meetings'),
        model: null,
        customFields: null
    },
    events: {

    },
    afterRender: function() {
        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.onChange(this.model);
            }, this)
        });
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});

PJQ.views.settings.SettingsNav = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Settings-Nav'),
        initView: null
    },
    events: {
        'click .settings-nav-item': 'navItemClicked',
        'click .cb-enable-contact-core-field-settings': 'enableContactCoreFieldSettings'
    },
    beforeFirstRender: function () {

    },
    beforeRender: function () {

    },
    afterRender: function () {
        if (this.options.subscriptionId != null && this.options.subscriptionId > 0) {
            this.renderAccountSettings(this.options.subscriptionId)
        } else {
            this.renderAccountSettings();
        }

        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });
        this.saveToolbar = new PJQ.views.toolbars.SettingsSaveToolbar({
            el: this.$('.save-toolbar-outer'),
            validate: _.bind(function () {
                if (!this.companyInfoSettings.validate()) {
                    this.$('.settings-nav-item').removeClass('active');
                    this.$('.settings-nav-content').addClass('hidden');
                    this.$('.account-item').addClass('active');
                    this.$('.settings-nav-content[data-nav="ACCOUNT"]').removeClass('hidden');
                } else {
                    return true;
                }
            }, this)
        });

        if (this.options.initView != null) {
            switch (this.options.initView) {
                case "billing":
                    if (this.companyInfoSettings != null) {
                        this.companyInfoSettings.changeCard();
                    }
                    break;
                default:
                    this.activateNavItem(this.options.initView);
            }
        }
    },
    navItemClicked: function (e) {
        let $target = $(e.currentTarget),
            tab = $target.data('nav');
        this.activateNavItem(tab);
    },
    activateNavItem: function (tab) {
        let tabUpper = tab.toUpperCase();
        this.$('.settings-nav-item').removeClass('active');
        this.$('.settings-nav-content').addClass('hidden');
        this.$('.settings-nav-item[data-nav="' + tabUpper + '"]').addClass('active');
        this.$('.settings-nav-content[data-nav="' + tabUpper + '"]').removeClass('hidden');

        PJQ.app.router.navigate('settings/' + tab.toLowerCase(), {
            trigger: false
        });

        switch (tabUpper) {
            case 'ACCOUNT':
                this.renderAccountSettings();
                break;
            case 'ADDRESSBOOK':
                this.renderAddressBookSettings();
                break;
            case 'ORDERING':
                this.renderOrderingSettings();
                break;
            case 'PROJECTS':
                this.renderProjectSettings();
                break;
            case 'BIDFORMS':
                this.renderBidFormSettings();
                break;
            case 'SCHEDULE':
                this.renderScheduleSettings();
                break;
            case 'RFI':
                this.renderRFISettings();
                break;
            case 'DAILYREPORTS':
                this.renderDailyReportSettings();
                break;
            case 'PUNCHLIST':
                this.renderPunchListSettings();
                break;
            case 'ACTIONITEMS':
                this.renderActionItemSettings();
                break;
            case 'COSTCODES':
                this.renderCostCodeSettings();
                break;
            case 'TAXCODES':
                this.renderTaxCodeSettings();
                break;
            case 'TIMECARD':
                this.renderTimeCardSettings();
                break;
            case 'PRIMECONTRACTS':
                this.renderPrimeContractSettings();
                break;
            case 'GROUPS':
                this.renderGroupSettings();
                break;
            case 'REGIONS':
                this.renderRegionSettings();
                break;
            case 'COMMITMENTS':
                this.renderCommitmentSettings();
                break;
            case 'INVOICING':
                this.renderInvoicingSettings();
                break;
            case 'DIRECTCOSTS':
                this.renderDirectCostSettings();
                break;
            case 'MEETINGS':
                this.renderMeetingSettings();
                break;
            case 'USERTYPES':
                this.renderUserTypeSettings();
                break;
            case 'USERS':
                this.renderUsers();
                break;
            case 'SSO':
                this.renderSSO();
                break;
            case 'SUBMITTALS':
                this.renderSubmittalSettings();
                break;
            case 'INTEGRATIONS':
                this.renderIntegrations();
                break;
            case 'CHANGEREQUESTS':
                this.renderChangeRequestSettings();
                break;
            case 'INSPECTIONS':
                this.renderInspectionSettings();
                break;
            case 'FEATURES':
                this.renderFeatureSettings();
                break;
            case 'CREWS':
                this.renderCrewsSettings();
                break;
            case 'EQUIPMENT':
                this.renderEquipmentSettings();
                break;
        }
    },
    renderBidFormSettings: function () {
        this.bidFormSettings = new PJQ.views.bidForms.Settings({
            el: this.$('.bid-form-settings'),
            onChange: _.bind(function (model) {
                this.saveToolbar.addSaveModel(model);
            }, this)
        });

        new PJQ.views.bidForms.TemplateManagement({
            el: this.$('.bid-form-templates')
        });
    },
    renderIntegrations: function () {
        this.integrationSettings = new PJQ.integrations.views.IntegrationsList({
            el: this.$('.integrations'),
            initOptions: this.options.initOptions
        });
    },
    renderFeatureSettings: function () {
        if (!this.featureSettings) {
            this.featureSettings = new PJQ.views.featureSettings.FeatureSettings({
                el: this.$('.features-settings'),
                model: new PJQ.models.featureSettings.FeatureSetting(),
                onChange: _.bind(function (model) {
                    this.saveToolbar.addSaveModel(model);
                }, this)
            })
        }
    },
    renderScheduleSettings: function () {
        if (this.scheduleSettings == null) {
            this.scheduleSettings = new PJQ.views.schedule.Settings({
                el: this.$('.schedule-settings'),
                onChange: _.bind(function (model) {
                    this.saveToolbar.addSaveModel(model);
                }, this)
            });

            // PJQ.app.session.fetchScheduleCustomFields(null, _.bind(function (fields) {
            // 	if (!this.scheduleFieldSettings) {
            // 		this.scheduleFieldSettings = new PJQ.views.settings.CustomFieldSettings({
            // 			el: this.$('.schedule-custom-fields'),
            // 			collection: fields,
            // 			fieldModel: PJQ.models.schedule.ScheduleCustomField
            // 		});
            // 	}
            // }, this));

            new PJQ.views.schedule.TaskStatuses({
                el: this.$('.schedule-statuses')
            });

            new PJQ.views.schedule.TemplateManagement({
                el: this.$('.template-management')
            });
        }
    },
    renderAccountSettings: function (subscriptionId) {
        if (this.companyInfoSettings == null) {
            this.companyInfoSettings = new PJQ.views.settings.CompanyInfo({
                el: this.$('.company-info'),
                procoreCode: this.options.procoreCode,
                subscriptionId: subscriptionId != null ? subscriptionId : 0,
                onChange: _.bind(function (model) {
                    this.saveToolbar.addSaveModel(model);
                }, this)
            });
        }
    },
    renderOrderingSettings: function () {
        if (this.orderingSettings == null) {
            PJQ.app.session.fetchOrderingSettings(_.bind(function (settings) {
                this.orderingSettings = new PJQ.views.settings.PlanRoomOrderingSettings({
                    el: this.$('.ordering'),
                    model: settings,
                    onChange: _.bind(function (model) {
                        this.saveToolbar.addSaveModel(model);
                    }, this)
                });
            }, this));
        }
    },
    renderInspectionSettings: function () {
        if(!this.inspectionTemplates) {
            this.inspectionTemplates = new PJQ.views.inspections.InspectionTemplatesList({
                el: this.$('.inspections-template-management')
            });
        }

        if(!this.inspectionTypes) {
            this.inspectionTypes = new PJQ.views.inspections.TypesList({
                el: this.$('.inspection-types')
            });
        }

        if(!this.inspectionResponseTypes) {
            this.inspectionResponseTypes = new PJQ.views.inspections.ResponseTypesList({
                el: this.$('.inspection-response-types')
            });
        }
    },
    renderAddressBookSettings: function () {
        if (this.addressBookSettings == null) {
            PJQ.app.session.fetchAddressBookSettings(_.bind(function (settings) {
                this.addressBookSettings = new PJQ.views.settings.AddressBookGeneralSettings({
                    el: this.$('.address-book-general'),
                    model: settings,
                    onChange: _.bind(function (model) {
                        this.saveToolbar.addSaveModel(model);
                    }, this)
                });
            }, this));

            PJQ.app.session.fetchCompanyCustomFields(null, _.bind(function (fields) {
                if (!this.companyFieldSettings) {
                    this.companyFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                        el: this.$('.company-custom-fields'),
                        collection: fields,
                        fieldModel: PJQ.models.contacts.CompanyCustomField
                    });
                }
            }, this));

            PJQ.app.session.fetchContactCustomFields(null, _.bind(function (fields) {
                if (!this.contactFieldSettings) {
                    this.contactFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                        el: this.$('.contact-custom-fields'),
                        collection: fields,
                        fieldModel: PJQ.models.contacts.ContactCustomField
                    });
                }
            }, this));

            this.renderContactCoreFieldSettings();
        }
    },
    renderContactCoreFieldSettings: function () {
        let $fields = this.$('.contact-core-fields');
        $fields.empty();
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS)) {
            this.contactCoreFieldSettings = new PJQ.views.settings.ContactFieldSettings({
                el: $fields
            });
        } else {
            new PJQ.Alert($fields, {
                type: 'primary',
                text: 'Enable advanced settings to show this feature'
            });
        }
    },
    enableContactCoreFieldSettings: function (e) {
        let enable = $(e.currentTarget).prop('checked');
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts'
                },
                {
                    endpoint: 'fields'
                }
            ], [
                {
                    parameter: 'enable',
                    value: enable
                }
            ])
        }).put().done(_.bind(function () {
            if (enable) {
                PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS, enable);
            } else {
                PJQ.app.session.preferences.deletePref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS);
            }
            this.renderContactCoreFieldSettings();
            if (this.addressBookSettings != null) {
                this.addressBookSettings.render();
            }
        }, this));
    },
    renderProjectSettings: function () {
        if (this.planroomSettings == null) {
            PJQ.app.session.fetchPlanRoomSettings(_.bind(function (settings) {
                this.planroomSettings = new PJQ.views.settings.PlanRoomGeneralSettings({
                    el: this.$('.general'),
                    model: settings,
                    onChange: _.bind(function (model) {
                        this.saveToolbar.addSaveModel(model);
                    }, this)
                });
            }, this));

            PJQ.app.session.fetchProjectCustomFields(null, _.bind(function (fields) {
                if (!this.customFieldSettings) {
                    this.customFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                        el: this.$('.project-custom-fields'),
                        collection: fields,
                        fieldModel: PJQ.models.projects.ProjectCustomField
                    });
                }
            }, this));

            new PJQ.views.settings.ProjectStatuses({
                el: this.$('.project-statuses')
            });

            new PJQ.views.settings.MessageStatuses({
                el: this.$('.message-statuses')
            });

            if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_STATUS_ID)) {
                PJQ.app.session.fetchProjectStatuses(_.bind(function () {
                    new PJQ.views.settings.ProjectStatusList({
                        el: this.$('.project-status-list')
                    });
                }, this));
            }

            new PJQ.views.settings.ProjectNDAs({
                el: this.$('.project-nda-outer')
            });
        }
    },
    renderRFISettings: function () {
        if (this.rfiCustomFieldSettings == null) {
            PJQ.app.session.fetchRFICustomFields(null, _.bind(function (fields) {
                this.rfiCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                    el: this.$('.rfi-custom-fields'),
                    collection: fields,
                    fieldModel: PJQ.models.rfi.CustomField
                });
            }, this));
        }

        if (this.rfiSettings == null) {
            PJQ.app.session.fetchRFISettings(_.bind(function (settings) {
                this.rfiSettings = new PJQ.views.rfi.RFISettings({
                    el: this.$('.rfi-settings'),
                    model: settings,
                    onChange: _.bind(function (model) {
                        this.saveToolbar.addSaveModel(model);
                    }, this)
                });
            }, this));
        }
    },
    renderDailyReportSettings: function () {
        if (this.dailyReportSettings == null) {
            this.dailyReportSettings = new PJQ.views.settings.DailyReportSettings({
                el: this.$('.daily-reports')
            });
        }
    },
    renderPunchListSettings: function () {
        if (this.punchListSettings == null) {
            PJQ.app.session.fetchPunchListCustomFields(null, _.bind(function (fields) {
                this.punchListSettings = new PJQ.views.settings.CustomFieldSettings({
                    el: this.$('.punch-list-custom-fields'),
                    collection: fields,
                    fieldModel: PJQ.models.punchlists.PunchlistCustomField
                });
            }, this));
        }

        if (!this.punchlistTemplates) {
            this.punchlistTemplates = new PJQ.views.punchlists.TemplateManagement({
                el: this.$('.punchlists-template-management')
            });
        }
    },
    renderActionItemSettings: function () {
        if (this.actionItemSettings == null) {
            PJQ.app.session.fetchActionItemCustomFields(null, _.bind(function (fields) {
                this.actionItemSettings = new PJQ.views.settings.CustomFieldSettings({
                    el: this.$('.action-items'),
                    collection: fields,
                    fieldModel: PJQ.models.actionItems.ActionItemCustomField
                });
            }, this));
        }

        if (!this.actionItemTemplates) {
            this.actionItemTemplates = new PJQ.views.actionItems.TemplateManagement({
                el: this.$('.actionitems-template-management')
            });
        }

    },
    renderCostCodeSettings: function () {
        if (this.costCodeSettings == null) {
            this.costCodeSettings = new PJQ.views.budget.CostCodeSettings({
                el: this.$('.cost-code-settings')
            });
        }
        if (this.costTypeSettings == null) {
            this.costTypeSettings = new PJQ.views.budget.CostTypeSettings({
                el: this.$('.cost-type-settings')
            });
        }
    },
    renderTaxCodeSettings: function () {
        if (this.taxCodeSettings == null) {
            this.taxCodeSettings = new PJQ.views.budget.TaxCodeSettings({
                el: this.$('.tax-code-settings')
            });
        }
    },
    renderTimeCardSettings: function () {
        if (this.timeCardSettingsView == null) {
            this.timeCardSettings = new PJQ.models.timecards.TimeCardSettings();
            this.timeCardSettings.fetch({
                success: _.bind(function () {
                    this.timeCardCategories = new PJQ.collections.timecards.TimeCardCategories();
                    this.timeCardCategories.fetch({
                        success: _.bind(function () {
                            this.timeCardSettingsView = new PJQ.views.settings.TimeCardSettings({
                                el: this.$('.timecard-settings'),
                                model: this.timeCardSettings,
                                categories: this.timeCardCategories,
                                saveToolbar: this.saveToolbar,
                                onChange: _.bind(function (model) {
                                    this.saveToolbar.addSaveModel(model);
                                }, this)
                            });
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderCrewsSettings: function () {
        if(this.crewsSettingsView == null){
            this.crewsSettingsView = new PJQ.views.timecards.CrewsList({
                el: this.$('.crews-settings')
            });
        }
    },
    renderEquipmentSettings: function () {
        if(this.equipmentSettingsView == null){
            this.equipmentSettingsView = new PJQ.views.timecards.EquipmentList({
                el: this.$('.equipment-settings')
            });
        }
    },
    renderGroupSettings: function () {
        if (this.groupSettings == null) {
            PJQ.app.session.fetchUserGroups(null, _.bind(function (groups) {
                this.groupSettings = new PJQ.views.settings.GroupSettings({
                    el: this.$('.groups'),
                    collection: groups,
                    groupModel: PJQ.models.groups.Group
                });
            }, this));

            new PJQ.views.bidPackages.TemplateManagement({
                el: this.$('.bid-package-template-management'),
                templateType: "Bid Package"
            });
        }
    },
    renderRegionSettings: function () {
        if (this.regionSettings == null) {
            this.regionSettings = new PJQ.views.settings.RegionSettings({
                el: this.$('.regions')
            });
        }
    },
    renderChangeRequestSettings: function () {
        if (!this.changeRequestSettings) {
            this.changeRequestCustomFields = new PJQ.collections.changeRequests.CustomFields();
            this.changeRequestCustomFields.fetch({
                success: _.bind(function () {
                    this.changeRequestSettings = new PJQ.models.changeRequests.Settings();
                    this.changeRequestSettings.fetch({
                        success: _.bind(function () {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.ChangeRequestSettings({
                                    el: this.$('.change-request-settings'),
                                    model: this.changeRequestSettings,
                                    customFields: this.changeRequestCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                this.changeRequestCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.change-request-custom-fields'),
                                    collection: this.changeRequestCustomFields,
                                    fieldModel: PJQ.models.changeRequests.CustomField
                                });
                            }, this));
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderPrimeContractSettings: function () {
        if (!this.primeContractSettings) {
            this.primeContractCustomFields = new PJQ.collections.primeContracts.CustomFields();
            this.primeContractCustomFields.fetch({
                success: _.bind(function () {
                    this.primeContractSettings = new PJQ.models.primeContracts.Settings();
                    this.primeContractSettings.fetch({
                        success: _.bind(function () {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.PrimeContractSettings({
                                    el: this.$('.prime-contract-settings'),
                                    model: this.primeContractSettings,
                                    customFields: this.primeContractCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                new PJQ.views.settings.TermsList({
                                    el: this.$('.contract-terms'),
                                    context: 'contracts'
                                })

                                new PJQ.views.settings.FinanceCoreFieldSettings({
                                    el: this.$('.prime-contract-field-settings'),
                                    context: 'primecontracts'
                                });

                                new PJQ.views.settings.FinanceCoreFieldSettings({
                                    el: this.$('.prime-contract-change-order-field-settings'),
                                    context: 'primecontractchangeorders'
                                });

                                this.primeContractCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.prime-contract-custom-fields'),
                                    collection: this.primeContractCustomFields,
                                    fieldModel: PJQ.models.primeContracts.CustomField
                                });
                            }, this));
                        }, this)
                    });
                }, this)
            });
        }
        if (!this.primeContractCOSettings) {
            this.primeContractCOCustomFields = new PJQ.collections.primeContracts.ChangeOrderCustomFields();
            this.primeContractCOCustomFields.fetch({
                success: _.bind(function () {
                    this.primeContractCOSettings = new PJQ.models.primeContracts.ChangeOrderSettings();
                    this.primeContractCOSettings.fetch({
                        success: _.bind(function () {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.PrimeContractChangeOrderSettings({
                                    el: this.$('.prime-contract-change-order-settings'),
                                    model: this.primeContractCOSettings,
                                    customFields: this.primeContractCOCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                this.primeContractCOCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.prime-contract-change-order-custom-fields'),
                                    collection: this.primeContractCOCustomFields,
                                    fieldModel: PJQ.models.primeContracts.ChangeOrderCustomField
                                });
                            }, this));
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderCommitmentSettings: function () {
        if (!this.commitmentSettings) {
            this.commitmentCustomFields = new PJQ.collections.commitments.CustomFields();
            this.commitmentCustomFields.fetch({
                success: _.bind(function () {
                    this.commitmentSettings = new PJQ.models.commitments.Settings();
                    this.commitmentSettings.fetch({
                        success: () => {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.CommitmentSettings({
                                    el: this.$('.commitment-settings'),
                                    model: this.commitmentSettings,
                                    customFields: this.commitmentCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                new PJQ.views.settings.TermsList({
                                    el: this.$('.commitment-terms'),
                                    context: 'commitments'
                                });

                                new PJQ.views.settings.FinanceCoreFieldSettings({
                                    el: this.$('.commitment-field-settings'),
                                    context: 'commitments'
                                });

                                this.commitmentCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.commitment-custom-fields'),
                                    collection: this.commitmentCustomFields,
                                    fieldModel: PJQ.models.commitments.CustomField
                                });
                            }, this));
                        }
                    });
                }, this)
            });
        }
        if (!this.commitmentCOSettings) {
            this.commitmentCOCustomFields = new PJQ.collections.commitments.ChangeOrderCustomFields();
            this.commitmentCOCustomFields.fetch({
                success: _.bind(function () {
                    this.commitmentCOSettings = new PJQ.models.commitments.ChangeOrderSettings();
                    this.commitmentCOSettings.fetch({
                        success: _.bind(function () {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.CommitmentChangeOrderSettings({
                                    el: this.$('.commitment-change-order-settings'),
                                    model: this.commitmentCOSettings,
                                    customFields: this.commitmentCOCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                new PJQ.views.settings.FinanceCoreFieldSettings({
                                    el: this.$('.commitment-change-order-field-settings'),
                                    context: 'commitmentchangeorders'
                                });

                                this.commitmentCOCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.commitment-change-order-custom-fields'),
                                    collection: this.commitmentCOCustomFields,
                                    fieldModel: PJQ.models.commitments.ChangeOrderCustomField
                                });
                            }, this));
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderInvoicingSettings: function () {
        if (!this.payableInvoiceSettings) {
            this.payableInvoiceCustomFields = new PJQ.collections.invoicing.PayableInvoiceCustomFields();
            this.payableInvoiceCustomFields.fetch({
                success: _.bind(function () {
                    this.payableInvoiceSettings = new PJQ.models.invoicing.PayableInvoiceSettings();
                    this.payableInvoiceSettings.fetch({
                        success: _.bind(function () {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.PayableInvoiceSettings({
                                    el: this.$('.payable-invoice-settings'),
                                    model: this.payableInvoiceSettings,
                                    customFields: this.payableInvoiceCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                new PJQ.views.settings.FinanceCoreFieldSettings({
                                    el: this.$('.payable-invoice-field-settings'),
                                    context: 'payableinvoices'
                                });

                                this.payableInvoiceCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.payable-invoice-custom-fields'),
                                    collection: this.payableInvoiceCustomFields,
                                    fieldModel: PJQ.models.invoicing.PayableInvoiceCustomField
                                });
                            }, this));
                        }, this)
                    });
                }, this)
            });
        }
        if (!this.receivableInvoiceSettings) {
            this.receivableInvoiceCustomFields = new PJQ.collections.invoicing.ReceivableInvoiceCustomFields();
            this.receivableInvoiceCustomFields.fetch({
                success: _.bind(function () {
                    this.receivableInvoiceSettings = new PJQ.models.invoicing.ReceivableInvoiceSettings();
                    this.receivableInvoiceSettings.fetch({
                        success: _.bind(function () {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.ReceivableInvoiceSettings({
                                    el: this.$('.receivable-invoice-settings'),
                                    model: this.receivableInvoiceSettings,
                                    customFields: this.receivableInvoiceCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                new PJQ.views.settings.FinanceCoreFieldSettings({
                                    el: this.$('.receivable-invoice-field-settings'),
                                    context: 'receivableinvoices'
                                });

                                this.receivableInvoiceCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.receivable-invoice-custom-fields'),
                                    collection: this.receivableInvoiceCustomFields,
                                    fieldModel: PJQ.models.invoicing.ReceivableInvoiceCustomField
                                });
                            }, this));
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderMeetingSettings: function () {
        if (!this.meetingCustomFields) {
            this.meetingCustomFields = new PJQ.collections.meetings.CustomFields();
            this.meetingCustomFields.fetch({
                success: _.bind(function () {
                    this.meetingSettings = new PJQ.models.meetings.Settings();
                    this.meetingSettings.fetch({
                        success: _.bind(function () {
                            new PJQ.views.meetings.MeetingSettings({
                                el: this.$('.meeting-settings'),
                                model: this.meetingSettings,
                                onChange: _.bind(function (model) {
                                    this.saveToolbar.addSaveModel(model);
                                }, this)
                            });

                            this.meetingCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                el: this.$('.meeting-custom-fields'),
                                collection: this.meetingCustomFields,
                                fieldModel: PJQ.models.meetings.CustomField
                            });

                            if (!this.meetingTemplates) {
                                this.meetingTemplates = new PJQ.views.meetings.TemplateManagement({
                                    el: this.$('.meetings-template-management')
                                });
                            }
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderDirectCostSettings: function () {
        if (!this.directCostCustomFields) {
            this.directCostCustomFields = new PJQ.collections.directcosts.CustomFields();
            this.directCostCustomFields.fetch({
                success: _.bind(function () {
                    this.directCostSettings = new PJQ.models.directcosts.Settings();
                    this.directCostSettings.fetch({
                        success: _.bind(function () {
                            new PJQ.views.directcosts.DirectCostSettings({
                                el: this.$('.direct-cost-settings'),
                                model: this.directCostSettings,
                                onChange: _.bind(function (model) {
                                    this.saveToolbar.addSaveModel(model);
                                }, this)
                            });

                            this.directCostCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                el: this.$('.direct-cost-custom-fields'),
                                collection: this.directCostCustomFields,
                                fieldModel: PJQ.models.directcosts.CustomField
                            });

                            new PJQ.views.settings.FinanceCoreFieldSettings({
                                el: this.$('.direct-cost-field-settings'),
                                context: 'directcosts'
                            });
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderUserTypeSettings: function () {
        if (this.userTypeSettings == null) {
            PJQ.app.session.fetchUserTypes(_.bind(function (types) {
                this.userTypeSettings = new PJQ.views.settings.UserTypeSettings({
                    el: this.$('.user-types'),
                    collection: types,
                    model: PJQ.models.userTypes.UserType
                });
            }, this));
        }
    },
    renderUsers: function () {
        if (this.userManagement == null) {
            PJQ.app.session.fetchUsers(_.bind(function (users) {
                this.userManagement = new PJQ.views.settings.UserSettings({
                    el: this.$('.user-management'),
                    collection: users
                });
            }, this));

            PJQ.app.session.fetchUserCustomFields(null, _.bind(function (fields) {
                if (!this.userCustomFieldSettings) {
                    this.userCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                        el: this.$('.user-custom-fields'),
                        collection: fields,
                        fieldModel: PJQ.models.users.UserCustomField
                    });
                }
            }, this));
        }
    },
    renderSSO: function () {
        if (this.ssoSettings == null) {
            PJQ.app.session.fetchSSOProviders(_.bind(function (providers) {
                this.ssoSettings = new PJQ.views.settings.SSOSettings({
                    el: this.$('.sso-settings'),
                    collection: providers
                });
            }, this));
        }
    },
    renderSubmittalSettings: function () {
        if (this.submittalSettings == null) {
            this.submittalSettings = new PJQ.views.submittals.Settings({
                el: this.$('.submittal-settings'),
                onChange: _.bind(function (model) {
                    this.saveToolbar.addSaveModel(model);
                }, this)
            });
            if (!this.submittalTemplates) {
                this.submittalTemplates = new PJQ.views.submittals.TemplateManagement({
                    el: this.$('.submittal-template-management')
                });
            }
            if (!this.submittalStatuses) {
                this.submittalStatuses = new PJQ.views.submittals.SubmittalStatusSettings({
                    el: this.$('.submittal-status-settings')
                })
            }
            // if(!this.submittalItemTypes){
            // 	this.submittalItemTypes = new PJQ.views.submittals.ItemTypeSettings({
            // 		el: this.$('.submittal-item-type-settings')
            // 	})
            // }
            PJQ.app.session.fetchSubmittalCustomFields(null, _.bind(function (fields) {
                if (!this.submittalFieldSettings) {
                    this.submittalFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                        el: this.$('.submittal-custom-fields'),
                        collection: fields,
                        fieldModel: PJQ.models.submittals.SubmittalCustomField
                    });
                }
            }, this));
        }
    }
});

PJQ.helpers.numberFormatHelpers = {
    createFormatStringPreview(numberFormat) {
        let result = '';
        _.each(numberFormat, function (token) {
            if (token.isText)
                result += token.label;
            else
                result += '<span class="border-1p border-light p-1 bg-light">[' + token.label + ']</span>';
        });
        return result;
    }
};

PJQ.views.settings.NumberFormatInput = PJQ.views.BaseView.extend({
    defaults: {
        commitmentType: null,
        settings: null,
        customFields: null,
        numberFormatProperty: 'numberFormat',
        onSave: _.noop()
    },
    afterRender: function () {
        if (this.options.commitmentType === PJQ.constants.commitments.commitmentType.SUBCONTRACT) {
            this.options.numberFormatProperty = 'subcontractNumberFormat';
        } else if (this.options.commitmentType === PJQ.constants.commitments.commitmentType.PURCHASE_ORDER) {
            this.options.numberFormatProperty = 'purchaseOrderNumberFormat';
        }

        this.numberFormat = this.options.settings.get(this.options.numberFormatProperty);
        let editButton = $('<button type="button" class="btn btn-transparent-light text-info btn-sm number-format-edit ml-1"><i class="fal fa-pencil"></i></button>');
        this.$el.closest('.form-group').find('label').append(editButton);
        editButton.on('click', _.bind(this.edit, this));

        this.renderFormatString();
    },
    edit: function () {
        new PJQ.views.settings.NumberFormatEditModal({
            settings: this.options.settings,
            numberFormatProperty: this.options.numberFormatProperty,
            onSave: _.bind(function (value) {
                this.numberFormat = value;
                this.options.settings.set(this.options.numberFormatProperty, value);
                this.renderFormatString();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(value);
                }
            }, this)
        });
    },
    renderFormatString: function () {
        this.$el.html('<div class="alert alert-link wd-100 min-ht-40p p-2" role="alert">' + PJQ.helpers.numberFormatHelpers.createFormatStringPreview(this.numberFormat) + '</div>');
    }
});

PJQ.views.settings.NumberFormatEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'modal-number-format-edit'),
        minWidth: 800,
        numberFormatProperty: 'numberFormat',
        onSave: _.noop(),
        parentView: null
    },
    events: {
        'click a.new-token': 'addToken',
        'click .edit-token': 'editToken',
        'change .input-ct-min-len': 'counterMinLengthChanged',
        'click .cancel-edit-token': 'cancelEdit',
        'click .delete-token': 'deleteToken',
        'click .save-token': 'saveToken',
        'click .save': 'saveFormat'
    },
    beforeModalCreated: async function () {
        let numFmt = this.options.settings.get(this.options.numberFormatProperty);
        if (numFmt != null) {
            this.numberFormat = [...numFmt];
        } else {
            this.numberFormat = [];
        }

        this.tokens = [
            {
                token: '',
                label: 'Enter Text',
                isText: true
            },
            {
                token: 'project.projectId',
                label: 'Project Id',
                category: 'Project Details'
            },
            {
                token: 'project.startDate',
                label: 'Project Start',
                isDate: true,
                dateFormatId: 0,
                category: 'Project Details'
            },
            {
                token: 'today',
                label: 'Current Date',
                isDate: true,
                dateFormatId: 0
            }];

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.erpIntegration != null) {
            this.tokens.push({
                token: 'externalProjectNumber',
                label: 'ERP Project Id',
                category: 'Project Details'
            });
        }

        // add the custom fields
        _.each(PJQ.app.session.customFields.project[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            switch (customField.get('fieldType')) {
                case PJQ.constants.customFields.fieldTypes.DATE:
                case PJQ.constants.customFields.fieldTypes.DATETIME:
                    this.tokens.push(
                        {
                            token: 'fieldValue' + customField.get('fieldNumber'),
                            label: customField.get('fieldName'),
                            isDate: true,
                            dateFormatId: 0,
                            category: 'Project Details'
                        });
                    break;
                case PJQ.constants.customFields.fieldTypes.INT:
                case PJQ.constants.customFields.fieldTypes.TEXT:
                    this.tokens.push(
                        {
                            token: 'fieldValue' + customField.get('fieldNumber'),
                            label: customField.get('fieldName'),
                            category: 'Project Details'
                        });
                    break;
                // case PJQ.constants.customFields.fieldTypes.CHOICE:
                //     if (!customField.get('isMultipleChoice')) {
                //         this.tokens.push(
                //             {
                //                 token: 'fieldValue' + customField.get('fieldNumber'),
                //                 label: customField.get('fieldName')
                //             });
                //         break;
                //     }
                //     break;
            }
        }, this));

        this.tokens.push({
            token: 'counter',
            label: 'Counter'
        });

        this.render();
    },
    renderData: function () {
        return {
            tokens: this.tokens
        };
    },
    afterRender: function () {
        this.$('.number-format-preview').html(PJQ.helpers.numberFormatHelpers.createFormatStringPreview(this.numberFormat));

        this.editRow = null;
        this.dateFormatSelectPicker = null;
        this.datatable = new PJQ.views.dataTables.DataTable({
            el: this.$('.token-datatable'),
            data: this.numberFormat,
            isHideSearch: true,
            order: [],
            pageLength: 99999,
            sortableOptions: {
                data: this.numberFormat,
                containment: ".token-datatable",
                stop: _.bind(function () {
                    let self = this, rows = [];
                    this.$('.token-datatable tbody tr').each(function (a, b) {
                        rows.push(self.datatable.getRow(b).data());
                    });

                    this.numberFormat = rows;
                    this.render();
                }, this)
            },
            bSort: false,
            onTableDraw: _.bind(function (dataTable) {
                if (this.$('.token-text').length) {
                    this.$('.token-text').inputmask('', {
                        regex: '^[0-9A-Z-a-z\.\-]*$'
                    })
                    this.$('.token-text').focus();
                } else if (this.$('.date-format').length) {
                    this.dateFormatSelectPicker = new PJQ.inputs.Selectpicker({
                        el: this.$('.date-format'),
                        isIntChoices: true,
                        isMultiple: false,
                        defaultValue: parseInt(this.$('.date-format').data('default'))
                    });
                    this.$('.date-format').focus();
                }

            }, this),
            columns: [
                {
                    "title": "Element",
                    "orderable": false,
                    "searchable": false,
                    "render": (data, type, row) => {
                        if (this.editRow === row) {
                            if (row.isText) {
                                return '<input type="text" class="form-control token-text " value="' + row.label + '" placeholder="Enter Text" >';
                            } else if (row.isDate) {
                                return '<div class="d-flex align-items-center"><div class="d-flex flex-fill">' + '[' + row.label + ']' + '</div><div class="wd-200p"><select class="date-format" data-default="' + row.dateFormatId.toString() + '"><option value="0">Full Date</option><option value="1">Month</option><option value="2">Day</option><option value="3">Year (2-Digit)</option><option value="4">Year</option></select></div></div>';
                            }

                            return '';
                        } else {
                            if (row.token === 'counter') {
                                return '<div class="d-flex align-items-center"><div>' + '[' + row.label + ']' + '</div><div class="ml-3 fs-14 font-weight-bold">Min. Length:</div><input type="number" min="1" max="5" style="width:60px" class="form-control ml-1 input-ct-min-len" value="' + (row.minLength ?? 4) + '" /></div>';
                            } else if (row.isText) {
                                return row.label;
                            } else {
                                return '[' + row.label + ']' + (row.isDate ? ' (' + PJQ.constants.commitments.commitmentNumberTokenDateFormatNames[row.dateFormatId] + ')' : '');
                            }
                        }
                    }
                },
                {
                    "title": '',
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="show-on-row-hover">';
                        if (this.editRow === row) {
                            html += '<button type="button" class="btn btn-success save-token ml-1" title="Save"><i class="fal fa-save"></i></button>';
                            html += '<button type="button" class="btn btn-danger cancel-edit-token ml-1" title="Cancel Edit"><i class="fal fa-times"></i></button>';
                        } else {
                            if (row.isText || row.isDate)
                                html += '<button type="button" class="btn btn-info edit-token ml-1" title="Edit"><i class="fal fa-pencil"></i></button>';

                            html += '<button type="button" class="btn btn-danger delete-token ml-1" title="Delete"><i class="fal fa-trash"></i></button>';
                        }
                        html += '</div>';
                        return html;
                    }, this),
                    "orderable": false,
                    "searchable": false,
                    "width": "75px",
                    "className": "text-right",
                    "visible": true
                }
            ],
            dom: 't'
        });
        // '<"top"<"clear">>rt<"bottom"p<"clear">>'
    },
    counterMinLengthChanged: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr')[0],
            row = this.datatable.getRow($row),
            token = row.data();

        if (token == null) {
            return;
        }

        let minLen = parseInt($target.val());
        if (!isNaN(minLen) && minLen >= 1 && minLen <= 5) {
            token.minLength = minLen;
        }
    },
    addToken: function (e) {
        let tokenIndex = $(e.currentTarget).data('tokenIndex'),
            newToken = _.clone(this.tokens[tokenIndex]);
        this.editRow = null;
        if (newToken.isText) {
            newToken.label = '';
            this.editRow = newToken;
        } else if (newToken.isDate) {
            this.editRow = newToken;
        }

        if (this.editRow)
            this.$('.save').prop('disabled', true);

        this.datatable.addRow(newToken);

        this.isAdding = true;


        this.$('.number-format-preview').html(PJQ.helpers.numberFormatHelpers.createFormatStringPreview(this.datatable.dataTable.data()));
    },
    editToken: function (e) {
        let row = this.datatable.getRow($(e.currentTarget).closest('tr')[0]);
        this.editRow = row.data();
        this.$('.save').prop('disabled', true);
        row.invalidate().draw();
    },
    cancelEdit: function (e) {
        let row = this.datatable.getRow($(e.currentTarget).closest('tr')[0]);
        this.editRow = null;
        this.dateFormatSelectPicker = null;
        this.$('.save').prop('disabled', false);
        if (this.isAdding) {
            this.datatable.removeRow(row);
        } else {
            row.invalidate().draw();
        }
        this.isAdding = false;
    },
    deleteToken: function (e) {
        let row = this.datatable.getRow($(e.currentTarget).closest('tr')[0]);
        if (row == null) {
            return;
        }

        this.datatable.removeRow(row);
        this.$('.number-format-preview').html(PJQ.helpers.numberFormatHelpers.createFormatStringPreview(this.datatable.dataTable.data()));
    },
    saveToken: function (e) {
        let row = this.datatable.getRow($(e.currentTarget).closest('tr')[0]),
            data = row.data();
        if (data.isText) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.token-text'), true);
            let value = this.$('.token-text').val().trim();
            if (_.size(value) === 0) {
                PJQ.helpers.inputHelpers.setInputError(this.$('.token-text'), false);
                return;
            }

            data.label = value;
        } else if (data.isDate) {
            data.dateFormatId = this.dateFormatSelectPicker.getValue();
            this.dateFormatSelectPicker = null;
        }

        this.editRow = null;
        this.isAdding = false;
        this.$('.save').prop('disabled', false);
        row.invalidate().draw();
        this.$('.number-format-preview').html(PJQ.helpers.numberFormatHelpers.createFormatStringPreview(this.datatable.dataTable.data()));
    },
    saveFormat: function () {
        if (typeof this.options.onSave === 'function') {
            let tokens = [];
            for (let i = 0; i < this.datatable.dataTable.data().length; i++)
                tokens.push(this.datatable.dataTable.data()[i]);

            this.options.onSave(tokens);
        }

        this.removeModal();
    }
});
PJQ.views.settings.PlanRoomOrderingSettings = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Planroom-Ordering')
	},
	events: {
		'click .btn-ordering-save': 'saveSettings',
		'click .btn-payment-info': 'changePaymentInfo'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		}
	},
	afterRender: function () {
		new PJQ.Binder(this.$el, this.model, {
			setDefaultValues: true,
			afterChange: _.bind(function () {
				this.onChange();
			}, this)
		});

		$(function () {
			$('[data-toggle="tooltip"]').tooltip()
		});


		new PJQ.inputs.Selectpicker({
			el: this.$('.select-delivery-options'),
			defaultValue: (this.model.get('deliverBy').length > 0) ? this.model.get('deliverBy') : "Next Day (Morning)",
			onChange: _.bind(function (value) {
				this.model.set('deliverBy', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-large-copies'),
			defaultValue: this.model.get('largeFormatCopyCount'),
			onChange: _.bind(function (value) {
				this.model.set('largeFormatCopyCount', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-large-print-size'),
			defaultValue: (this.model.get('largeFormatPrintSize').length > 0) ? this.model.get('largeFormatPrintSize') : "FULL SIZE",
			onChange: _.bind(function (value) {
				this.model.set('largeFormatPrintSize', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-large-paper'),
			defaultValue: (this.model.get('largeFormatPaper').length > 0) ? this.model.get('largeFormatPaper') : "WHITE BOND",
			onChange: _.bind(function (value) {
				this.model.set('largeFormatPaper', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-large-binding'),
			defaultValue: (this.model.get('largeFormatBinding').length > 0) ? this.model.get('largeFormatBinding') : "LOOSE",
			onChange: _.bind(function (value) {
				this.model.set('largeFormatBinding', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-small-copies'),
			defaultValue: this.model.get('smallformatCopyCount'),
			onChange: _.bind(function (value) {
				this.model.set('smallFormatCopyCount', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-small-paper'),
			defaultValue: (this.model.get('smallFormatPaper').length > 0) ? this.model.get('smallFormatPaper') : "WHITE BOND",
			onChange: _.bind(function (value) {
				this.model.set('smallFormatPaper', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-small-binding'),
			defaultValue: (this.model.get('smallFormatBinding').length > 0) ? this.model.get('smallFormatBinding') : "LOOSE",
			onChange: _.bind(function (value) {
				this.model.set('smallFormatBinding', value);
				this.onChange();
			}, this)
		});
	},
	changePaymentInfo: function () {
		new PJQ.views.settings.PaymentInfoModal();
	},
	onChange: function () {
		if (typeof this.options.onChange === 'function') {
			this.options.onChange(this.model);
		}
	},
	cancelEdit: function () {
		this.model.fetch({
			success: _.bind(function () {
				this.render();
			}, this)
		});
		this.render();
	},
	saveSettings: function () {
		if (this.model.hasChanged()) {
			this.model.patch(null, {
				success: _.bind(function () {
					this.render();
					PJQ.notifications.notify.successNotify({
						message: 'Address book settings saved'
					});
				}, this)
			});
		}
	}
});

PJQ.views.settings.PaymentInfoModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Payment-Settings'),
		minWidth: 700
	},
	defaultEvents: {
		'click .btn-save': 'save',
		'click .btn-cancel': 'cancel',
		'keyup .input-card-number': 'setCardBrand',
		'click .btn-edit': 'edit',
		'click .btn-copy-profile': 'copyProfile'
	},
	beforeModalCreated: function () {
		this.user = new PJQ.models.contacts.Contact({
			id: -PJQ.app.session.user.id
		});

		if (!this.user.isFetched) {
			this.user.fetch();
		}

		if (this.model == null) {
			this.model = new PJQ.models.settings.PaymentInfo();
		}

		if (!this.model.isFetched) {
			this.model.fetch({
				success: _.bind(function () {
					this.render();
				}, this)
			});
		}
	},
	renderData: function () {
		return {
			model: this.model,
			today: new Date()
		};
	},
	afterRender: function () {
		this.isEdit = false;
		new PJQ.Binder(this.$el, this.model);

		PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-user-phone'));
		PJQ.helpers.inputHelpers.inputMaskCreditCard(this.$('.input-card-number'));

		this.statePicker = new PJQ.inputs.Selectpicker({
			el: this.$('.user-edit-state'),
			defaultValue: _.size(this.model.get('state')) > 0 ? this.model.get('state').toLowerCase() : null,
			onChange: _.bind(function (value) {
				this.model.set('state', value.toUpperCase());
			}, this)
		});
		this.countryChanged();

		new PJQ.inputs.Selectpicker({
			el: this.$('.user-edit-country'),
			noneSelectedText: 'Select Value',
			defaultValue: _.size(this.model.get('country')) > 0 ? this.model.get('country').toLowerCase() : null,
			onChange: _.bind(function (value) {
				this.model.set('country', value.toUpperCase());
				this.model.set('zip', '');
				this.model.set('state', '');
				this.countryChanged();
			}, this)
		});

		this.monthPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.select-expiration-month'),
			noneSelectedText: '',
			onChange: _.bind(function (value) {
				this.model.set('expMonth', value);
			}, this)
		});

		this.yearPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.select-expiration-year'),
			noneSelectedText: '',
			onChange: _.bind(function (value) {
				this.model.set('expYear', value);
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-expiration-month-disabled'),
			noneSelectedText: '',
			defaultValue: this.model.get('expMonth'),
			onChange: _.bind(function (value) {
				this.model.set('expMonth', value);
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-expiration-year-disabled'),
			noneSelectedText: '',
			defaultValue: this.model.get('expYear'),
			onChange: _.bind(function (value) {
				this.model.set('expYear', value);
			}, this)
		});
		this.setCardBrand();
	},
	copyProfile: function () {
		this.model.set('companyName', this.user.get('companyName'));
		this.model.set('cardholderName', this.user.get('contactName'));
		this.model.set('address1', this.user.get('address1'));
		this.model.set('address2', this.user.get('address2'));
		this.model.set('city', this.user.get('city'));
		this.model.set('zip', this.user.get('zip'));
		this.model.set('state', this.user.get('state'));
		this.model.set('country', this.user.get('country'));
		this.model.set('phone', this.user.get('phone'));
		this.model.set('phoneExt', this.user.get('phoneExtension'));
		this.model.set('email', this.user.get('email'));
		this.render()
	},
	setCardBrand: function () {
		let cardBrand = PJQ.helpers.paymentHelpers.getCardIssuer(this.model.get('cardNumber')),
			icon = PJQ.helpers.paymentHelpers.getCardIssuerIconFAClass(cardBrand);
		this.$('.card-brand').addClass('fs-30 ' + icon);
	},
	countryChanged: function () {
		let country = _.size(this.model.get('country')) > 0 ? this.model.get('country').toLowerCase() : 'us',
			options = '<option value="">Select Value</option>';
		_.each(PJQ.constants.states[country], function (state) {
			options += '<option value="' + state.abbreviation.toLowerCase() + '">' + state.name + '</option>';
		});
		this.statePicker.$el.html(options);
		this.statePicker.refresh();
		if (_.size(this.model.get('state')) > 0)
			this.statePicker.setValue(this.model.get('state').toLowerCase());

		PJQ.helpers.inputHelpers.inputMaskZip(this.$('.user-edit-zip'), country);
	},
	edit: function () {
		this.isEdit = true;
		let $prepend = this.$('.card-type-prepend');
		this.$('.card-hidden').hide();
		this.$('.card-shown').attr('hidden', false);
		this.$('.select-expiration-year').attr('disabled', false);
		this.$('.select-expiration-month').attr('disabled', false);
		$prepend.removeClass();
		$prepend.addClass('card-type-prepend fal fa-question fs-30')
	},
	validate: function () {
		let isValid = true;

		let isCompanyValid = _.size(this.model.get('companyName').trim()) > 0;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-company-name'), isCompanyValid);
		isValid = isCompanyValid && isValid;

		let emailValid = PJQ.helpers.validators.validateEmail(this.$('.input-user-email').val());
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-email'), (emailValid.success));
		isValid = emailValid.success && isValid;

		let isContactValid = _.size(this.model.get('cardholderName').trim()) > 0;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-cardholder-name'), isContactValid);
		isValid = isContactValid && isValid;

		let isAddressValid = _.size(this.model.get('address1').trim()) > 0;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-address-1'), isAddressValid);
		isValid = isAddressValid && isValid;

		let isStateValid = _.size(this.model.get('state').trim()) > 0;
		isValid = isStateValid && isValid;
		this.$('.user-edit-state').removeClass('p-field-error');
		if (!isStateValid) {
			this.$('.user-edit-state').addClass('p-field-error');
		}

		let isCityValid = _.size(this.model.get('city').trim()) > 0;
		PJQ.helpers.inputHelpers.setInputError(this.$('.user-edit-city'), isCityValid);
		isValid = isCityValid && isValid;

		let isZipValid = _.size(this.model.get('zip').trim()) > 4;
		PJQ.helpers.inputHelpers.setInputError(this.$('.user-edit-zip'), isZipValid);
		isValid = isZipValid && isValid;

		let isPhoneValid = _.size(this.model.get('phone')) >= 10;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-phone'), isPhoneValid);
		isValid = isPhoneValid && isValid;

		let isCardValid = PJQ.helpers.paymentHelpers.validateCreditCard(this.model.get('cardNumber'));
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-card-number'), isCardValid);
		isValid = isCardValid && isValid;

		let isYearValid = (this.yearPicker.getValue() != null);
		isValid = isYearValid && isValid;
		this.$('.select-expiration-year').removeClass('p-field-error');
		if (!isYearValid) {
			this.$('.select-expiration-year').addClass('p-field-error');
		}

		let isMonthValid = (this.monthPicker.getValue() != null);
		isValid = isMonthValid && isValid;
		this.$('.select-expiration-month').removeClass('p-field-error');
		if (!isMonthValid) {
			this.$('.select-expiration-month').addClass('p-field-error');
		}

		return isValid;
	},
	save: function () {
		if (this.isEdit) {
			let cardNumber = this.$('.input-card-number').val();
			this.model.set('cardNumber', cardNumber.replace(/\D/g, ''));
		}
		if (this.validate()) {
			this.model.save();
			this.isEdit = false;
			this.removeModal();
		}
	},
	cancel: function () {
		this.isEdit = false;
		this.removeModal();
	}
});

PJQ.views.settings.PrimeContractSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'prime-contracts'),
        model: null,
        customFields: null
    },
    events: {},
    beforeFirstRender: function () {
        this.listenTo(this.model, 'fetch', this.render);
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.onChange();
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-default-accounting-method'),
            isIntChoices: true,
            isMultiple: false,
            defaultValue: this.model.get('defaultAccountingMethod') != null ? this.model.get('defaultAccountingMethod') : PJQ.constants.budget.accountingMethod.UNIT_QUANTITY,
            onChange: _.bind(function (value) {
                this.model.set('defaultAccountingMethod', value);
                this.onChange();
            }, this)
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format'),
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('numberFormat', value);
                this.onChange();
            }
        });

        new PJQ.views.settings.SignatureEditInput({
            el: this.$('.manage-signature-input'),
            signature: this.model.get('defaultSignature'),
            headerSubText: "Manage your company's default signature for Contracts",
            onSave: _.bind(function(signature) {
                this.model.set('defaultSignature', signature);
                this.onChange();
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});

PJQ.views.settings.PrimeContractChangeOrderSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'prime-contract-change-orders'),
        model: null,
        customFields: null
    },
    events: {},
    beforeFirstRender: function () {
        this.listenTo(this.model, 'fetch', this.render);
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.onChange();
            }, this)
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format'),
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('numberFormat', value);
                this.onChange();
            }
        });

        new PJQ.views.settings.SignatureEditInput({
            el: this.$('.manage-signature-input'),
            signature: this.model.get('defaultSignature'),
            headerSubText: "Manage your company's default signature for Contract Change Orders",
            onSave: _.bind(function(signature) {
                this.model.set('defaultSignature', signature);
                this.onChange();
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});
PJQ.views.settings.PlanRoomGeneralSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Planroom-General')
    },
    events: {
        'keydown .input-default-bid-due-time': function () {
            return false;
        },
        'contextmenu .input-default-bid-due-time': function () {
            return false;
        },
        'click .input-project-user-2-show': 'showUser2Changed'
    },
    beforeFirstRender: function () {
        this.listenTo(this.model, 'fetch', this.render);
    },
    beforeRender: function () {
        this.enableFax = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_FAX) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ENABLE_FAX) : false;
        this.renderData = {
            model: this.model,
            enableFax: this.enableFax,
            showGroupCompanyView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY),
            showGroupContactView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT),
            showCompanyView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_COMPANY) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_COMPANY),
            showContactView: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_CONTACT) || PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_VIEW_CONTACT)
        };
    },
    afterRender: function () {
        this.createDefaultItbMethodArray();

        new PJQ.inputs.Selectpicker({
            el: this.$('.input-default-part-view'),
            defaultValue: (this.model.get('itbDefaultView').length > 0) ? this.model.get('itbDefaultView') : "view_default",
            onChange: _.bind(function (value) {
                this.model.set('itbDefaultView', value);
                this.onChange();
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.input-default-bid-due-time'),
            datepickerOptions: {
                format: 'LT',
                defaultDate: 4
            },
            isTimeOnly: true,
            onChange: _.bind(function () {
                let dateVal = this.$('.input-default-bid-due-time').val(),
                    time = dateVal.split(" ")[0],
                    amPm = dateVal.split(" ")[1],
                    changed = false;
                if (this.model.get('defaultBidDueTime') !== time) {
                    this.model.set('defaultBidDueTime', time);
                    changed = true;
                }
                if (this.model.get('defaultBidDueTimeAMPM') !== amPm) {
                    this.model.set('defaultBidDueTimeAMPM', amPm);
                    changed = true;
                }
                if (changed) {
                    this.onChange();
                }
            }, this),
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.input-participants-per-page'),
            defaultValue: this.model.get('itbRowsPerPage'),
            onChange: _.bind(function (value) {
                this.model.set('itbRowsPerPage', value);
                this.onChange();
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.input-default-time-zone'),
            defaultValue: (this.model.get('itbDefaultTimeZone').length > 0) ? this.model.get('itbDefaultTimeZone') : "Central",
            onChange: _.bind(function (value) {
                this.model.set('itbDefaultTimeZone', value);
                this.onChange();
            }, this)
        });

        this.itbPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.input-itb-method'),
            defaultValue: this.defaultArray,
            exclusiveChoices: ["itb-fax", "itb-no-email", "itb-email-fail"],
            isMultiple: true,
            hideDisabled: false,
            onChange: _.bind(function (value) {
                let newValue = [value[0], "itb-email"];
                this.itbPicker.setValue(newValue);
                this.model.set('isITBSendEmail', true);
                if (value.includes('itb-no-email')) {
                    this.model.set('isITBSendFaxIfNoEmail', true);
                } else {
                    this.model.set('isITBSendFaxIfNoEmail', false);
                }
                if (value.includes('itb-email-fail')) {
                    this.model.set('isITBSendFaxIfEmailFails', true);
                } else {
                    this.model.set('isITBSendFaxIfEmailFails', false);
                }
                if (value.includes('itb-fax')) {
                    this.model.set('isITBSendFax', true);
                } else {
                    this.model.set('isITBSendFax', false);
                }

                this.onChange();
            }, this)
        });

        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.onChange();
            }, this)
        });
    },
    createDefaultItbMethodArray: function () {
        this.defaultArray = [];
        if (this.model.get('isITBSendEmail') === true) {
            this.defaultArray.push('itb-email')
        }
        if (this.model.get('isITBSendFaxIfNoEmail') === true) {
            this.defaultArray.push('itb-no-email')
        }
        if (this.model.get('isITBSendFaxIfEmailFails') === true) {
            this.defaultArray.push('itb-email-fail')
        }
        if (this.model.get('isITBSendFax') === true) {
            this.defaultArray.push('itb-fax')
        }
    },
    showUser2Changed: function () {
        if (this.model.get('isShowProjectUser2')) {
            this.$('.project-user-2-outer').removeClass('hidden');
        } else {
            this.$('.project-user-2-outer').addClass('hidden');
        }
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.model);
        }
    }
});

PJQ.views.settings.MessageStatuses = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Message-Statuses')
    },
    events: {
        'click .add-message-status': 'addStatusClicked',
        'click .edit-message-status': 'editStatusClicked',
        'click .delete-message-status': 'deleteStatus',
        'click .save-message-status': 'statusSave',
        'click .cancel-edit-message-status': 'cancelEditStatus',
        'keydown .input-message-status': 'disableCommasAndPipes'
    },
    beforeRender: function () {
        this.model = PJQ.app.session.planRoomSettings;
        if (!this.model.isFetched) {
            this.model.fetch({
                success: _.bind(function () {
                    this.render();
                }, this)
            });
        }
        this.renderData = {
            model: this.model,
            options: this.options,
            collection: this.collection
        };
    },
    afterRender: function () {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
        if (this.model.messageStatuses) {
            this.dataTable = new PJQ.views.dataTables.DataTable({
                el: this.$(".message-status-table"),
                isHideSearch: true,
                data: this.model.messageStatuses.models,
                rowId: "cid",
                order: [0, 'asc'],
                targets: 'no-sort',
                bSort: false,
                language: {
                    zeroRecords: 'Click "Add" to create a new Message Status'
                },
                columns: [
                    {
                        "data": "attributes.sortOrder",
                        "title": "",
                        "searchable": false,
                        "visible": false
                    },
                    {
                        "data": {
                            "display": _.bind(function (row) {
                                if (this.messageStatusContext != null && this.messageStatusContext.get('name') === row.get('name') && row.get('name') !== "YES" && row.get('name') !== "NO") {
                                    return '<input type="text" class="form-control input-message-status wd-250p" value="' + row.get('name') + '">';
                                } else {
                                    return row.get('name');
                                }
                            }, this)
                        },
                        "title": "Status"
                    },
                    {
                        "data": "",
                        "title": "RSVP",
                        "width": "25%",
                        "orderable": false,
                        "searchable": false,
                        "render": _.bind(function (data, type, row) {
                            let content = row.get('canParticipantSet') === true ? "Yes" : "No";
                            if (this.messageStatusContext != null && this.messageStatusContext.get('name') === row.get('name') && this.messageStatusContext.get('sortOrder') === row.get('sortOrder')) {
                                content = '<div class="pretty p-switch mr-1 mb-2 mt-2">\n' +
                                    '                <input type="checkbox" class="input-participant-can-set"\n' +
                                    '                       />\n' +
                                    '                <div class="state p-primary">\n' +
                                    '                    <label><span class="fs-16">RSVP</span></label>\n' +
                                    '                </div>\n' +
                                    '            </div>'
                            }

                            if (this.messageStatusContext != null && this.messageStatusContext.get('canParticipantSet') === true) {
                                this.$('.input-participant-can-set').prop('checked', true)
                            } else {
                                this.$('.input-participant-can-set').prop('checked', false)
                            }


                            return '<div>' + content + '</div>'
                        }, this)
                    },
                    {
                        "data": "",
                        "title": "",
                        "orderable": false,
                        "searchable": false,
                        resizable: false,
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            let content = '';
                            if (this.messageStatusContext != null && this.messageStatusContext.get('name') === row.get('name') && this.messageStatusContext.get('sortOrder') === row.get('sortOrder')) {
                                content = '<button type="button" class="btn btn-success save-message-status"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger cancel-edit-message-status ml-1"><i class="fal fa-times"></i></button>';
                            } else if (row.get('name') !== "YES" && row.get('name') !== "NO") {
                                let disabledAttr = this.messageStatusContext != null ? ' disabled ' : '';
                                content = '<button type="button" class="btn btn-info edit-message-status"' + disabledAttr + '><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger delete-message-status ml-1"' + disabledAttr + '><i class="fal fa-trash"></i></button>';
                            }
                            return '<div class="text-align-right show-on-row-hover" style="width:80px;">' + content + '</div>'
                        }, this)
                    }
                ],
            })
        }
    },
    disableCommasAndPipes: function (e) {
        if (e.keyCode === 188 || e.keyCode === 220) {
            e.preventDefault();
        }
    },
    addStatusClicked: function () {
        this.messageStatusContext = new PJQ.models.settings.PlanRoomSettings({
            name: "",
            canParticipantSet: false,
            sortOrder: this.model.get('messageStatuses').length + 1
        });
        this.dataTable.addRow(this.messageStatusContext);
        this.dataTable.refresh()
    },
    editStatusClicked: function (e) {
        this.messageStatusContext = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();
        this.dataTable.refresh();
    },
    deleteStatus: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Status",
            body: "Are you sure you want to delete this status?",
            onDelete: _.bind(function () {
                this.dataTable.removeRow(row);
                this.dataTable.refresh;
                this.model.set('messageStatuses', this.dataTable.dataTable.rows().data().toArray());
                this.model.patch(null, {
                    success: _.bind(function () {
                        this.messageStatusContext = null;
                        this.dataTable.refresh();
                    }, this)
                });
            }, this)
        });
    },
    messageStatusConstructor: function ({name, canParticipantSet, sortOrder}) {
        this.name = name;
        this.canParticipantSet = canParticipantSet;
        this.sortOrder = sortOrder
    },
    statusSave: function (e) {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }
        let $row = $(e.currentTarget).closest('tr'),
            status = this.dataTable.getRow($row).data(),
            $name = $row.find('.input-message-status'),
            isNameValid = _.size($name.val().trim()) > 0;

        if ($name.val().indexOf(',') > -1 || $name.val().indexOf('|') > -1) {
            isNameValid = false;
            this.errorAlert = new PJQ.Alert(this.$('.error'), {
                type: 'danger',
                text: "Password cannot contain commas or pipe characters."
            });
        }
        if (isNameValid) {
            status.set('name', $name.val().trim())
        }
        status.set('canParticipantSet', this.$('.input-participant-can-set').prop('checked'));

        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);
        if (isNameValid) {
            this.model.set('messageStatuses', this.dataTable.dataTable.rows().data().toArray());
            this.model.patch(null, {
                success: _.bind(function () {
                    this.messageStatusContext = null;
                    this.dataTable.refresh();
                }, this)
            });
        }
    },
    cancelEditStatus: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);
        if (this.messageStatusContext.name.length === 0) {
            this.dataTable.removeRow(row);
        }
        this.messageStatusContext = null;
        this.dataTable.refresh();
    },
});

// Project status of a Project Contact
PJQ.views.settings.ProjectStatuses = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Project-Statuses')
    },
    events: {
        'click .add-project-status': 'addStatusClicked',
        'click .edit-project-status': 'editStatusClicked',
        'click .delete-project-status': 'deleteStatus',
        'click .save-project-status': 'statusSave',
        'click .cancel-edit-project-status': 'cancelEditStatus',
        'colorpickerChange': 'setBGColor',
        'keyup .colorpicker-input-box': 'setBGColor',
        'keydown .input-project-status': 'disableCommasAndPipes',
        'keydown .input-activity-rank': 'disableNumbers'
    },
    beforeRender: function () {
        this.model = PJQ.app.session.planRoomSettings;
        if (!this.model.isFetched) {
            this.model.fetch({
                success: _.bind(function () {
                    this.render();
                }, this)
            });
        }
        this.renderData = {
            model: this.model,
            options: this.options,
            collection: this.collection
        };
    },
    afterRender: function () {
        if (this.model.projectStatuses == null) {
            return;
        }

        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
        let self = this;
        this.filteredData = new PJQ.collections.settings.ProjectStatuses(_.filter(this.model.projectStatuses.models, function (status) {
            let sNameLower = status.get('name').toLowerCase();
            return sNameLower !== "pending" && sNameLower !== "unsent";
        }));
        // this.listenTo(this.model.projectStatuses, 'change', _.bind(this.startReorder, this));
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".project-status-table"),
            isHideSearch: true,
            data: this.filteredData.models,
            rowId: "cid",
            order: [0, 'asc'],
            targets: 'no-sort',
            pageLength: 50,
            bSort: false,
            language: {
                zeroRecords: 'Click "Add" to create a new Project Status'
            },
            sortableOptions: {
                data: this.filteredData,
                stop: (a, b) => {
                    self.$('tbody>tr').each(function (index, html) {
                        let row = $(html).attr('id'),
                            rowData = self.filteredData.get(row);
                        rowData.set('sortOrder', index + 1);
                    });
                    this.startReorder();
                }
            },
            columns: [
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "orderable": false,
                    "visible": false,
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (row.get('sortOrder') > 2) {
                            content = '<div><i class="fas fa-sort"></i></div>'
                        }
                        return content
                    }, this)
                },
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.projectStatusContext != null && this.projectStatusContext.get('name') === row.get('name') && this.projectStatusContext.get('sortOrder') === row.get('sortOrder') && row.get('name') !== "PENDING" && row.get('name') !== "UNSENT" && row.get('name') !== "DOWNLOADED" && row.get('name') !== "VIEWED") {
                                return '<input type="text" class="form-control input-project-status wd-200p" value="' + row.get('name') + '">';
                            } else {
                                return '<span style="color:' + row.get('backgroundColor') + ';">' + row.get('name') + '</span>';
                            }
                        }, this)
                    },
                    "title": "Status",
                    "width": "200px"
                },
                {
                    "data": "",
                    "title": "RSVP",
                    "width": "50px",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let content = row.get('canParticipantSet') === true ? "Yes" : "No";
                        if (this.projectStatusContext != null && this.projectStatusContext.get('name') === row.get('name') && this.projectStatusContext.get('sortOrder') === row.get('sortOrder') && row.get('name') !== "PENDING" && row.get('name') !== "UNSENT" && row.get('name') !== "DOWNLOADED" && row.get('name') !== "VIEWED") {
                            content = '<div class="pretty p-switch mr-1 wd-50p mr-2 ml-2">\n' +
                                '                <input type="checkbox" class="input-participant-can-set"\n' +
                                '                       />\n' +
                                '                <div class="state p-primary">\n' +
                                '                    <label><span class="fs-16">RSVP</span></label>\n' +
                                '                </div>\n' +
                                '            </div>'
                        }
                        if (this.projectStatusContext != null && this.projectStatusContext.get('canParticipantSet') === true) {
                            this.$('.input-participant-can-set').prop('checked', true)
                        } else {
                            this.$('.input-participant-can-set').prop('checked', false)
                        }

                        return '<div>' + content + '</div>'
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "200px",
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.projectStatusContext != null && this.projectStatusContext.get('name') === row.get('name') && row.get('name') !== "DOWNLOADED" && row.get('name') !== "VIEWED") {
                            return '<div class="input-group project-status-color-input wd-200p"><input type="text" class="form-control colorpicker-input-box"/><span class="input-group-append"><div class="input-group color-picker"><span class="input-group-text colorpicker-input-addon"><i></i></span></div></span></div>'
                        }
                        return '<div>' + content + '</div>'
                    }, this)
                },
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.projectStatusContext != null && this.projectStatusContext.get('name') === row.get('name') && this.projectStatusContext.get('sortOrder') === row.get('sortOrder') && row.get('name') !== "PENDING" && row.get('name') !== "UNSENT") {
                                return '<input type="text" class="form-control input-activity-rank wd-100p" value="' + row.get('activityRank') + '">';
                            } else {
                                return '<span>' + row.get('activityRank') + '</span>';
                            }
                        }, this)
                    },
                    "title": "Activity Score",
                    "width": "100px"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "100px",
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.projectStatusContext != null && this.projectStatusContext.get('name') === row.get('name')) {
                            content = '<button type="button" class="btn btn-success save-project-status"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger cancel-edit-project-status ml-1"><i class="fal fa-times"></i></button>';
                        } else {
                            if (row.get('name') === "UNSENT" || row.get('name') === "PENDING" || row.get('name') === "VIEWED" || row.get('name') === "DOWNLOADED" || row.get('sortOrder') === 1 || row.get('sortOrder') === 2) {
                                let disabledAttr = this.projectStatusContext != null ? ' disabled ' : '';
                                content = '<button type="button" class="btn btn-info edit-project-status"' + disabledAttr + '><i class="fal fa-pencil"></i></button>'
                            } else {
                                let disabledAttr = this.projectStatusContext != null ? ' disabled ' : '';
                                content = '<button type="button" class="btn btn-info edit-project-status"' + disabledAttr + '><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger delete-project-status ml-1"' + disabledAttr + '><i class="fal fa-trash"></i></button>';
                            }
                        }
                        return '<div class="text-align-right show-on-row-hover" style="width:80px;">' + content + '</div>'
                    }, this),
                }
            ],
        });
    },
    disableCommasAndPipes: function (e) {
        if (e.keyCode === 188 || e.keyCode === 220) {
            e.preventDefault();
        }
    },
    disableNumbers: function (e) {
        PJQ.helpers.inputHelpers.numbersOnly(e, true, true);
    },
    addStatusClicked: function () {
        this.projectStatusContext = new PJQ.models.settings.PlanRoomSettings({
            name: "",
            backgroundColor: "#000000",
            foregroundColor: "#000000",
            canParticipantSet: false,
            activityRank: 0,
            sortOrder: this.model.get('projectStatuses').length + 1,
        });
        this.dataTable.addRow(this.projectStatusContext);
        this.editStatus();
    },
    editStatusClicked: function (e) {
        this.projectStatusContext = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();
        this.editStatus();
    },
    editStatus: function (e) {
        this.dataTable.refresh();
        this.colorPicker = new PJQ.colors.ColorPicker(this.$('.color-picker'), {
            format: 'hex',
            color: this.projectStatusContext.get('backgroundColor'),
            autoInputFallback: false
        });
        this.$('.colorpicker-input-box').val(this.projectStatusContext.get('backgroundColor'));
        this.$('.input-project-status').css('color', this.projectStatusContext.get('backgroundColor'));
    },
    setBGColor: function (e) {
        if (e.type === 'keyup') {
            if (e.keyCode === 13) {
                $(e.currentTarget).blur()
            }
            let color = this.$('.colorpicker-input-box').val();
            if (color.split('')[0] === '#' && color.trim().length === 7) {
                this.colorPicker.setColor(color);
                this.projectStatusContext.set('backgroundColor', color.toUpperCase());
                this.$('.input-project-status').css('color', color.toUpperCase());
                PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), true);
            }
        } else {
            let color = this.colorPicker.getColor();
            if (color.split('')[0] === '#' && color.trim().length === 7) {
                this.$('.colorpicker-input-box').val(color);
                this.projectStatusContext.set('backgroundColor', color);
                this.$('.input-project-status').css('color', color);
                PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), true);
            }
        }
    },
    startReorder: function () {
        let newArray = [];
        _.each(this.dataTable.dataTable.rows().data().toArray(), function (status) {
            newArray[status.attributes.sortOrder - 1] = status;
        });
        this.saveReorder(newArray)
    },
    saveReorder: function (array) {
        let isNull = false;
        if (array.length !== this.dataTable.dataTable.rows().data().toArray().length) {
            isNull = true;
        }

        _.each(array, function (node, index) {
            if (node !== undefined) {
                // Don't allow Accept or Decline to be reordered
                if (index === 0) {
                    if (node.get('name') !== 'ACCEPT') {
                        isNull = true;
                    }
                } else if (index === 1) {
                    if (node.get('name') !== 'DECLINE') {
                        isNull = true;
                    }
                }
            } else {
                isNull = true
            }
        });
        if (!isNull && this.projectStatusContext == null) {
            this.loader = new PJQ.Loader(this.$('.project-status-table'));
            this.model.set('projectStatuses', array);
            this.model.patch(null, {
                success: _.bind(function () {
                    if (this.loader) {
                        this.loader.remove();
                    }
                    this.render();
                }, this)
            });
        } else {
            this.dataTable.render()
        }
    },
    deleteStatus: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            status = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Status",
            body: "Are you sure you want to delete this status?",
            onDelete: _.bind(function () {
                this.dataTable.removeRow(row);
                this.dataTable.refresh;
                this.model.set('projectStatuses', this.dataTable.dataTable.rows().data().toArray());
                this.model.patch(null, {
                    success: _.bind(function () {
                        this.projectStatusContext = null;
                        this.dataTable.refresh();
                    }, this)
                });
            }, this)
        });
    },
    projectStatusConstructor: function ({name, canParticipantSet, color, sortOrder}) {
        this.name = name;
        this.color = color;
        this.canParticipantSet = canParticipantSet;
        this.sortOrder = sortOrder
    },
    statusSave: function (e) {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }
        let $row = $(e.currentTarget).closest('tr'),
            status = this.dataTable.getRow($row).data(),
            $name = $row.find('.input-project-status'),
            name = $row.find('.input-project-status').length > 0 ? $row.find('.input-project-status').val() : status.get('name'),
            $rank = $row.find('.input-activity-rank'),
            isNameValid = _.size(name.trim()) > 0,
            isRankValid = _.size($rank.val().trim()) > 0 && !isNaN(parseInt($rank.val().trim()));

        let color = '#555',
            isColorValid;
        if (name.toLowerCase() !== "downloaded" && name.toLowerCase() !== "viewed") {
            color = this.$('.colorpicker-input-box').val();
            isColorValid = color.split('')[0] === '#' && color.trim().length === 7;
        } else {
            isColorValid = true;
        }

        if (name.indexOf(',') > -1 || name.indexOf('|') > -1) {
            isNameValid = false;
            this.errorAlert = new PJQ.Alert(this.$('.error'), {
                type: 'danger',
                text: "Name cannot contain commas or pipe characters."
            });
        }
        if (isNameValid) {
            status.set('name', name);
        }
        if (isRankValid) {
            status.set('activityRank', parseInt($rank.val().trim()));
        }
        status.set('canParticipantSet', (this.$('.input-participant-can-set').prop('checked')));
        status.set('foregroundColor', PJQ.helpers.colorHelpers.idealLinkColorForBackground(color));


        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);
        PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), isColorValid, {
            errorText: isColorValid ? "" : "Hex must begin with a # followed by 6 letters and/or numbers!"
        });
        PJQ.helpers.inputHelpers.setInputError($rank, isRankValid, {
            errorText: isRankValid ? "" : "Rank can not be empty and must be a number!"
        });

        if (isNameValid && isColorValid && isRankValid) {
            this.model.set('projectStatuses', this.dataTable.dataTable.rows().data().toArray());
            this.model.patch(null, {
                success: _.bind(function () {
                    this.projectStatusContext = null;
                    this.render()
                }, this)
            });
        }
    },
    cancelEditStatus: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);
        if (this.projectStatusContext.get('name').length === 0) {
            this.dataTable.removeRow(row);
        }
        this.projectStatusContext = null;
        this.dataTable.refresh();
    },
});

// ProjectStatusId of a Project
PJQ.views.settings.ProjectStatusList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Project-Status-List')
    },
    events: {
        'click .add-project-status': 'addClicked',
        'click .btn-edit-project-status': 'editProjectStatusClicked',
        'click .btn-delete-project-status': 'deleteProjectStatusClicked',
        'click .btn-save-project-status': 'projectStatusSave',
        'click .btn-cancel-edit-project-status': 'cancelEditProjectStatus'
    },
    beforeFirstRender: function () {

    },
    afterRender: function () {
        this.collection = PJQ.app.session.projectStatuses;
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".project-status-list-table"),
            isHideSearch: true,
            data: PJQ.app.session.projectStatuses.models,
            rowId: "cid",
            targets: 'no-sort',
            order: [2, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new Project Status'
            },
            bSort: false,
            sortableOptions: {
                data: PJQ.app.session.projectStatuses,
            },
            rowCallback: function (row, data, index) {
                $(row).find('td:eq(0)').css('color', '#' + data.get('color'));
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function (row) {
                            return row.data().get('masterUserId') !== -1;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteProjectStatus(row);
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.projectStatusContext != null && this.projectStatusContext.id === row.id) {
                                return '<input type="text" class="form-control input-project-status-name" value="' + row.get('name') + '">';
                            } else {
                                return row.get('name');
                            }
                        }, this)
                    },
                    "title": "Status",
                    "orderable": false
                },
                {
                    "data": "",
                    "title": "",
                    "width": this.projectStatusContext != null ? "200px" : '0px',
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.projectStatusContext != null && this.projectStatusContext.id === row.id) {
                            content = '<div class="input-group project-status-color-input wd-200p"><input type="text" class="form-control"/><span class="input-group-append"><span class="input-group-text colorpicker-input-addon"><i></i></span></span></div>'
                        }
                        return '<div class="text-align-right">' + content + '</div>'
                    }, this)
                },
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "visible": false
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": '120px',
                    "render": _.bind(function (data, type, row) {
                        let buttons = '';
                        if (this.projectStatusContext != null && this.projectStatusContext.id === row.id) {
                            buttons = '<button type="button" class="btn btn-success btn-save-project-status mr-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger btn-cancel-edit-project-status"><i class="fal fa-times"></i></button>';
                        } else {
                            buttons += '<button type="button" class="btn btn-info btn-edit-project-status mr-1"><i class="fal fa-pencil"></i></button>';
                            if (row.get('masterUserId') !== -1) {
                                buttons += '<button type="button" class="btn btn-danger btn-delete-project-status"><i class="fal fa-trash"></i></button>';
                            }
                        }
                        return '<div class="text-align-right show-on-row-hover">' + buttons + '</div>'
                    }, this)
                },
            ],
        });
    },
    editProjectStatusClicked: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            projectStatus = row.data(),
            fnEdit = _.bind(function (eps) {
                this.projectStatusContext = eps;
                this.defaultColor = '#' + eps.get('color');
                this.dataTable.refresh();
                new PJQ.colors.ColorPicker(this.$('.project-status-color-input'), {
                    format: 'hex',
                    color: '#' + eps.get('color'),
                    onChange: _.bind(function (value) {
                        this.projectStatusContext.set('color', value.substring(1));
                        this.$('.input-project-status-name').css('color', value);
                    }, this)
                });
                this.$('.input-project-status-name').css('color', '#' + eps.get('color'));
            }, this);
        if (projectStatus.get('masterUserId') === -1) {
            this.changeDefaultAlert(projectStatus, function (projectStatuses, newProjectStatus) {
                fnEdit(newProjectStatus);
            });
        } else {
            fnEdit(projectStatus);
        }

    },
    changeDefaultAlert(returnCopy, callback) {
        this.dataTable.refresh();
        new PJQ.views.modals.YesNo({
            header: "Change Project Statuses?",
            body: 'You are currently using the system default project statuses.  To edit a project status, we will need to create custom project statuses for your company.  This may take a minute, would you like to continue?',
            onYes: _.bind(function () {
                this.copyProjectStatuses(returnCopy, _.bind(function (projectStatuses, newProjectStatus) {
                    this.dataTable.resetData(PJQ.app.session.projectStatuses.models);
                    callback(projectStatuses, newProjectStatus);
                }, this));
            }, this)
        });
    },
    copyProjectStatuses: function (returnCopy, callback) {
        this.collection.copy(_.bind(function () {
            let newPs = null;
            if (returnCopy != null) {
                let returnName = returnCopy.get('name');
                newPs = _.find(this.collection.models, function (u) {
                    return u.get('name') === returnName;
                });
            }
            callback(this.collection.models, newPs);
        }, this));
    },
    addClicked: function () {
        let fnAdd = _.bind(function () {
            let newProjectStatus = new PJQ.models.projectStatuses.ProjectStatus({
                name: "",
                color: '000000',
                sortOrder: this.collection.length + 1,
                isDefault: this.collection.length === 0
            });
            this.collection.add(newProjectStatus);
            this.dataTable.addRow(newProjectStatus);
            this.projectStatusContext = newProjectStatus;
            this.defaultColor = this.projectStatusContext.get('color');
            this.projectStatusColor = this.projectStatusContext.attributes.color;
            this.dataTable.refresh();
            new PJQ.colors.ColorPicker(this.$('.project-status-color-input'), {
                format: 'hex',
                color: '#' + this.projectStatusColor,
                onChange: _.bind(function (value) {
                    this.projectStatusContext.set('color', value.substring(1));
                    this.$('.input-project-status-name').css('color', value);
                }, this)
            });
            this.$('.input-user-type-name').css('color', this.projectStatusContext.get('color'));
        }, this);
        if (this.collection.length > 0 && this.collection.models[0].get('masterUserId') === -1) {
            this.changeDefaultAlert(null, function () {
                fnAdd();
            });
        } else {
            fnAdd();
        }
    },
    projectStatusSave: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            projectStatus = this.dataTable.getRow($row).data(),
            $name = $row.find('.input-project-status-name');

        let isNameValid = _.size($name.val()) > 0;
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);

        if (!isNameValid)
            return;
        ``
        projectStatus.set('name', $name.val());
        projectStatus.set('sortOrder', projectStatus.attributes.sortOrder);

        projectStatus.save(null, {
            success: _.bind(function () {
                this.projectStatusContext = null;
                this.dataTable.refresh();
            }, this)
        });
    },
    deleteProjectStatusClicked(e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);

        this.deleteProjectStatus(row);
    },
    deleteProjectStatus: function (row) {
        let projectStatus = row.data(),
            fnDelete = _.bind(function (dps) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Project Status",
                    body: "Are you sure you want to delete this Project Status?  Any Project that currently has this Status will be set to the Default Status.",
                    onDelete: _.bind(function () {
                        projectStatus.destroy({
                            success: _.bind(function () {
                                this.collection.remove(dps);
                                this.dataTable.removeRow(row);
                                this.dataTable.refresh();
                            }, this)
                        });
                    }, this)
                });
            }, this);
        if (projectStatus.get('masterUserId') === -1) {
            this.changeDefaultAlert(projectStatus, function (projectStatuses, newProjectStatus) {
                fnDelete(newProjectStatus);
            });
        } else {
            fnDelete(projectStatus);
        }

    },
    cancelEditProjectStatus: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            status = row.data();
        status.set('color', this.defaultColor);
        this.projectStatusContext = null;
        this.projectStatusColor = null;
        if (status.get('name').length === 0) {
            this.dataTable.removeRow(row);
        }
        this.dataTable.refresh();
    },
});


PJQ.views.settings.ProjectNDAs = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'project-ndas')
    },
    events: {
        'click .btn-add-nda': 'addNDAClicked',
        'click .btn-edit-nda': 'editNDAClicked',
        'click .btn-delete-nda': 'deleteNDAClicked'
    },
    beforeFirstRender: function () {
        PJQ.app.session.fetchNDAs(_.bind(function (ndas) {
            this.collection = ndas;
            this.render();
        }, this));
    },
    afterRender: function () {
        if (this.collection == null) {
            return;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".project-ndas"),
            isHideSearch: true,
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new Project NDA'
            },
            onRowDoubleClick: _.bind(function (row) {
                this.editNDA(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editNDA(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteNDA(row);
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": "attributes.isDefault",
                    "title": "",
                    "width": "40px",
                    "render": _.bind(function (data) {
                        if (data) {
                            return '<i class="fad fa-crown text-gold"></i>';
                        }
                        return '';
                    }, this)
                },
                {
                    "data": "attributes.name",
                    "title": "Name",
                    // "render": _.bind(function (data, type, row) {
                    //
                    // }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "width": "100px",
                    orderable: false,
                    searchable: false,
                    resizable: false,
                    "render": _.bind(function (data, type, row) {
                        return '<div class="show-on-row-hover" style="width:80px;"><button type="button" class="btn btn-info btn-edit-nda"><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger btn-delete-nda ml-1"><i class="fal fa-trash"></i></button></div>';
                    }, this)
                }
            ],
        });
    },
    addNDAClicked: function () {
        let newNda = new PJQ.models.projects.ProjectNDA();
        if (_.size(this.collection.models) === 0) {
            newNda.set('isDefault', true);
        }
        this.editNDA(newNda);
    },
    editNDAClicked: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            nda = row.data();
        this.editNDA(nda);
    },
    editNDA: function (nda) {
        let isNew = nda.isNew();
        new PJQ.views.projects.EditProjectNDAModal({
            model: nda,
            onSave: _.bind(function () {
                if (isNew) {
                    this.collection.add(nda);
                    this.dataTable.addRow(nda);
                }
                this.dataTable.refresh();
            }, this),
            onDelete: _.bind(function (nda) {
                if (nda.id > 0) {
                    let row = this.dataTable.getRow(nda.cid);
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                }
            }, this)
        });
    },
    deleteNDAClicked: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);
        this.deleteNDA(row);
    },
    deleteNDA: function (row) {
        let nda = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Delete NDA",
            body: "Are you sure you want to delete this project NDA?",
            onDelete: _.bind(function () {
                this.dataTable.removeRow(row);
                this.dataTable.refresh;
                this.collection.remove(nda);
                nda.destroy();
            }, this)
        });
    }
});

//Model
PJQ.models.settings.Region = PJQ.models.BaseModel.extend({
    idAttribute: 'regionId',
    notifyName: 'Region',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'regions',
                value: this.id
            }
        ])
    }
});
//Collection
PJQ.collections.settings.Regions = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.settings.Region,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'regions'
            }
        ])
    }
});

PJQ.views.settings.RegionSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Regions')
    },
    events: {
        'click .add-region': 'addClicked',
        'click .btn-edit-region': 'editRegion',
        'click .btn-delete-region': 'deleteRegion',
        'click .btn-save-region': 'regionSave',
        'click .btn-cancel-edit-region': 'cancelEditRegion'
    },
    beforeFirstRender() {
        if (this.collection == null) {
            this.collection = new PJQ.collections.settings.Regions();
        }
        if (!this.options.isFetched) {
            this.collection.fetch({
                success: _.bind(function () {
                    this.options.isFetched = true;
                    this.render();

                    if (typeof this.options.onFetch === 'function') {
                        this.options.onFetch();
                    }
                }, this)
            });
        }
        else {
            this.render();
        }
    },
    beforeRender: function(){
        this.renderData = {
            options: this.options,
            collection: this.collection
        };
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".region-table"),
            isHideSearch: true,
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new Region'
            },
            columns: [
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.regionContext != null && this.regionContext.id === row.id) {
                                return '<input type="text" class="form-control input-region-name" value="' + row.get('name') + '">';
                            } else {
                                return row.get('name');
                            }
                        }, this)
                    },
                    "title": "Region"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.regionContext != null && this.regionContext.id === row.id) {
                            content = '<button type="button" class="btn btn-success btn-save-region wd-30p mr-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger btn-cancel-edit-region wd-30p"><i class="fal fa-times"></i></button>';
                        } else {
                            let disabledAttr = this.regionContext != null ? ' disabled ' : '';
                            content = '<button type="button" class="btn btn-info btn-edit-region wd-30p mr-1"' + disabledAttr + '><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger btn-delete-region wd-30p"' + disabledAttr + '><i class="fal fa-trash"></i></button>';
                        }
                        return '<div class="text-align-right show-on-row-hover">' + content + '</div>'
                    }, this),
                    "width": "160px"
                }
            ],
        })
    },
    addClicked: function () {
        let newRegion = new PJQ.models.settings.Region({
            name: "",
            regionDescription: "",
            sortOrder: this.collection.length + 1,
        });
        this.dataTable.addRow(newRegion);
        this.regionContext = newRegion;
        this.dataTable.refresh()
    },
    editRegion: function (e) {
        this.regionContext = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();
        this.dataTable.refresh();
    },
    deleteRegion: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            region = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Region",
            body: "Are you sure you want to delete this region?",
            onDelete: _.bind(function () {
                region.destroy({
                    success: _.bind(function () {
                        // this.collection.remove(region);
                        this.dataTable.removeRow(row);
                    }, this)
                });
            }, this)
        });
    },
    regionSave: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            region = this.dataTable.getRow($row).data(),
            $name = $row.find('.input-region-name');
        region.set('name', $name.val());

        let isNameValid = _.size(region.get('name')) > 0;
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);

        if (isNameValid) {
            region.save(null, {
                success: _.bind(function () {
                    this.regionContext = null;
                    this.dataTable.refresh();
                }, this)
            });
        }
    },
    cancelEditRegion: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);
        if (this.regionContext.get('name').length === 0){
            this.dataTable.removeRow(row);
        }        this.regionContext = null;
        this.dataTable.refresh();
    },
});

PJQ.models.settings.PaymentInfo = PJQ.models.BaseModel.extend({
	idAttribute: "paymentInfoId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'settings'
			},
			{
				endpoint: 'ordering'
			},
			{
				endpoint: 'paymentinfo'
			}
		])
	},
	afterInit: function () {
		this.set({
			companyName: '',
			cardholderName: '',
			address1: '',
			address2: '',
			city: '',
			state: '',
			zip: '',
			country: '',
			phone: '',
			phoneExt: '',
			email: '',
			cardNumber: '',
			expMonth: '',
			expYear: ''
		});
	},
});

PJQ.models.settings.PlanRoomSettings = PJQ.models.BaseModel.extend({
	defaults: {
		type: 'planroom'
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'settings'
			},
			{
				endpoint: 'planroom'
			}
		])
	},
	parse: function (model) {
		if (!model)
			return model;
		this.projectStatuses = new PJQ.collections.settings.ProjectStatuses(model.projectStatuses);
		this.messageStatuses = new PJQ.collections.settings.MessageStatuses(model.messageStatuses);
		return model
	}
});

PJQ.models.settings.OrderingSettings = PJQ.models.BaseModel.extend({
	defaults: {
		type: 'ordering'
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'settings'
			},
			{
				endpoint: 'ordering'
			}
		])
	}
});

PJQ.models.settings.AddressBookSettings = PJQ.models.BaseModel.extend({
	defaults: {
		type: 'address-book'
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'settings'
			},
			{
				endpoint: 'addressbook'
			}
		])
	}
});

PJQ.collections.settings.ProjectStatuses = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.settings.PlanRoomSettings
});

PJQ.collections.settings.MessageStatuses = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.settings.PlanRoomSettings
});

PJQ.views.settings.SignatureEditInput = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'signature-edit-input'),
        model: null,
        signature: null
    },
    events: {
        'click .btn-manage-signature': 'manageSignature'
    },
    beforeFirstRender: function () {
        this.signature = this.options.signature;
    },
    renderData: function() {
        return {
            signature: this.signature
        }
    },
    manageSignature: function() {
        new PJQ.views.signatures.SignatureSubmitModal({
            headerSubText: this.options.headerSubText,
            fetchSignature: false,
            signature: this.signature,
            onSubmit: _.bind(function (signature, cb) {
                if(typeof this.options.onSave === 'function'){
                    this.options.onSave(signature);
                }
                this.signature = signature;
                this.render();
                cb();
            }, this)
        });
    }
});
PJQ.constants.sso = {
    providerNames: {
        AZURE_AD: "Azure Active Directory",
        OKTA: "Okta",
        ONELOGIN: "OneLogin",
        OTHER: "Other"
    },
    providers: {
        AZURE_AD: "AZURE_AD",
        OKTA: "OKTA",
        ONELOGIN: "ONELOGIN",
        OTHER: "OTHER"
    }
};

PJQ.models.sso = {};

PJQ.models.sso.Provider = PJQ.models.BaseModel.extend({
    idAttribute: 'id',
    endpoint: function () {
        let params = [];
        if (this.get('disableProvisioning')) {
            params.push({
                parameter: 'disableProvisioning',
                value: true
            });
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'saml',
                value: this.id
            }
        ], params)
    },
    getProviderName: function () {
        return PJQ.constants.sso.providerNames[this.get('provider')];
    },
    refreshProvisioningToken: function (callback) {
        if (this.id > 0) {
            new PJQ.ajax.Request({
                endpoint: this.endpoint() + "/refreshprovisioningtoken",
                type: 'POST',
                data: this.toJSON()
            }).post().done(_.bind(function (response) {
                if (typeof callback === 'function') {
                    let token = null;
                    if (_.size(response.provisioningToken) > 0) {
                        token = response.provisioningToken;
                        this.set('provisioningToken', token);
                    }
                    callback(token);
                }
            }, this)).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
            });
        } else {
            let token = PJQ.helpers.guid();
            this.set('provisioningToken', token);
            callback(token);
        }
    },
    afterSave: function () {
        this.set('disableProvisioning', null);
    }
});

//Collections
PJQ.collections.sso = {};

PJQ.collections.sso.Providers = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.sso.Provider,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'saml'
            }
        ]);
    }
});

PJQ.views.settings.SSOSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'sso-settings')
    },
    events: {
        'click .btn-add-provider': 'addClicked',
        'click .btn-edit-provider': 'editClicked',
        'click .btn-delete-provider': 'deleteClicked'
    },
    beforeRender: function () {
    },
    renderData: function () {
        return {
            enablePermissions: this.options.enablePermissions
        };
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".sso-table"),
            data: this.collection.models,
            rowId: "id",
            order: [0, 'asc'],
            paging: false,
            language: {
                zeroRecords: "You haven't added any SSO providers yet"
            },
            onRowDoubleClick: _.bind(function (row) {
                this.editProvider(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editProvider(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteProvider(row);
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "title": "Default",
                    "width": "100px",
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (row.get('isDefault')) {
                            content = '<i class="fs-16 text-dark far fa-check"</i>'
                        }
                        return content;
                    })
                },
                {
                    'title': "Provider",
                    "data": "attributes.provider",
                    "render": _.bind(function (data, type, row) {
                        return row.getProviderName();
                    })
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": this.options.enablePermissions ? '160px' : '120px',
                    "render": _.bind(function (data, type, row) {
                        let buttons = '';
                        buttons += '<button type="button" title="Edit" class="btn btn-info btn-edit-provider mr-1"><span class="fal fa-pencil"></span></button>';
                        buttons += '<button type="button" title="Delete" class="btn btn-danger btn-delete-provider"><span class="fal fa-trash"></span></button>';
                        return '<div class="text-align-center show-on-row-hover">' + buttons + '</div>';
                    }, this)
                }
            ]
        });
    },
    addClicked: function () {
        this.editProvider(new PJQ.models.sso.Provider({
            isDefault: _.size(this.collection.models) === 0
        }));
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            note = row.data();
        this.editProvider(note);
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteProvider(row);
    },
    editProvider: function (provider) {
        let isNew = provider.isNew();
        new PJQ.views.settings.EditSSOProviderModal({
            model: provider,
            onSave: _.bind(function () {
                if (isNew) {
                    this.collection.add(provider);
                }
                this.render();
            }, this),
            onDelete: _.bind(function (provider) {
                if (!isNew) {
                    this.collection.remove(provider);
                    this.render();
                }
            }, this)
        });
    },
    deleteProvider: function (row) {
        let provider = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this provider?",
            onDelete: _.bind(function () {
                this.collection.remove(provider);
                provider.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.settings.EditSSOProviderModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'modal-sso'),
        minWidth: 600,
        onSave: null,
        isUpdatingCertificate: false
    },
    defaultEvents: {
        'change .cb-enable-provisioning': 'provisioningChanged',
        'click .btn-refresh-provisioning-token': 'refreshProvisioningToken',
        'click .btn-update-certificate': 'updateCertificate',
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-delete': 'delete'
    },
    beforeModalCreated: function () {
        if (this.model == null) {
            this.model = new PJQ.models.sso.Provider({
                isDefault: false,
                provider: PJQ.constants.sso.providers.AZURE_AD
            });
        }

        if (_.size(this.model.get('provider')) === 0) {
            this.model.set('provider', PJQ.constants.sso.providers.AZURE_AD);
        }
    },
    renderData: function () {
        return {
            model: this.model,
            options: this.options
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ]
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-provider'),
            hideDisabled: true,
            defaultValue: this.model.get('provider'),
            onChange: _.bind(function (value) {
                this.model.set('provider', value);
                this.render();
            }, this)
        });
    },
    provisioningChanged: function (e) {
        let provisioningEnabled = $(e.currentTarget).prop('checked');
        this.model.set('disableProvisioning', !provisioningEnabled);
        if (provisioningEnabled && _.size(this.model.get('provisioningToken')) === 0) {
            this.model.refreshProvisioningToken(_.bind(function () {
                this.render();
            }, this));
        } else {
            this.render();
        }
    },
    refreshProvisioningToken: function () {
        new PJQ.views.modals.YesNo({
            header: "Confirm Authentication Token Refresh",
            body: 'Are you sure you want to generate a new authentication token?  This action cannot be reversed.',
            onYes: _.bind(function () {
                new PJQ.Loader(this.$('.provisioning-token-outer'));
                this.model.refreshProvisioningToken(_.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Provisioning token successfully refreshed'
                    });
                    this.render();
                }, this));
            }, this)
        });
    },
    updateCertificate: function () {
        this.options.isUpdatingCertificate = true;
        this.render();
    },
    validate: function(){
        let isValid = true;

        let isSignOnUrlValid =_.size(this.model.get('issuer')) > 0;
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-sign-on-url'), isSignOnUrlValid);
        isValid = isValid && isSignOnUrlValid;

        let isIssuerValid =_.size(this.model.get('issuer')) > 0;
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-issuer'), isIssuerValid);
        isValid = isValid && isIssuerValid;

        if(this.options.isUpdatingCertificate || this.model.isNew()){
            let isCertificateValid =_.size(this.model.get('certificate')) > 0;
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-certificate'), isCertificateValid);
            isValid = isValid && isCertificateValid;
        }

        if(!isValid) {
            if (this.errorAlert != null) {
                this.errorAlert.destroy();
            }
            this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
                type: 'danger',
                text: 'Required fields missing data'
            });
        }

        return isValid;
    },
    save: function () {
        if(!this.validate()){
            return;
        }

        this.model.save(null, {
            success: _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'SSO provider successfully created'
                });
                this.removeModal();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        })
    },
    cancel: function () {
        this.model.restore();
        this.removeModal();
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this provider?",
            onDelete: _.bind(function () {
                this.model.destroy();
                this.removeModal();
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
            }, this)
        });
    }
});
PJQ.views.settings.TermsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Terms')
    },
    events: {
        'click .edit-terms': 'editTermsClicked',
        'click .delete-terms': 'deleteTermsClicked',
        'click .add-terms': 'addTermsClicked'
    },
    beforeFirstRender: function () {
        this.context = this.options.context.toLowerCase();
       if(this.context && !this.collection){
           switch(this.context) {
               case 'commitments':
                   PJQ.app.session.fetchCommitmentTerms(_.bind(function(termsCollection){
                       this.collection = termsCollection;
                       this.render();
                   }, this));
                   break;
               case 'contracts':
                   PJQ.app.session.fetchPrimeContractTerms(_.bind(function(termsCollection){
                       this.collection = termsCollection;
                       this.render();
                   }, this));
           }
       }
    },
    renderData: function () {
        return {

        };
    },
    afterRender: function () {
        if(this.collection) {
            this.dataTable = new PJQ.views.dataTables.DataTable({
                el: this.$(".terms-table"),
                data: this.collection.models,
                rowId: "cid",
                order: [0, 'asc'],
                language: {
                    zeroRecords: 'Click "Add Terms" to create new terms'
                },
                pageLength: 50,
                isHideSearch: true,
                bSort: false,
                onRowDoubleClick: _.bind(function (row) {
                    this.editTerms(row.data());
                }, this),
                contextMenuOptions: {
                    actions: [
                        {
                            name: 'Edit',
                            onClick: _.bind(function (row) {
                                this.editTerms(row.data());
                            }, this)
                        },
                        {
                            name: 'Delete',
                            isDanger: true,
                            onClick: _.bind(function (row) {
                                this.deleteGroup(row);
                            }, this)

                        }
                    ]
                },
                columns: [
                    {
                        "title": "Name",
                        "data": "attributes.name",
                        "orderable": true
                    },
                    {
                        "data": "",
                        "title": "",
                        "orderable": false,
                        "searchable": false,
                        resizable: false,
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return '<div class="text-align-right show-on-row-hover" style="width:80px;"><button type="button" class="btn btn-info edit-terms"><span class="fal fa-pencil"></span></button><button type="button" class="btn btn-danger delete-terms ml-1"><span class="fal fa-trash"></span></button></div>';
                        }, this)
                    }
                ]
            });
        }
    },
    addTermsClicked: function(e){
        let newTerm = new this.collection.model({
            name: '',
            type: this.context,
            terms: '',
            isDefault: false
        });

        this.editTerms(newTerm);
    },
    editTermsClicked: function(e){
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.editTerms(row.data());
    },
    editTerms: function (terms) {
        new PJQ.views.settings.EditTermsModal({
            model: terms,
            onSave: _.bind(function (model) {
                if (model.hasChanged() || model.isNew()) {
                    if (model.isNew()) {
                        this.collection.add(model);
                        this.dataTable.addRow(model);
                    }
                    model.save(null, {
                        notify: true,
                        success: _.bind(function(){
                            if(model.get('isDefault')){
                                _.each(this.collection.models, function(term){
                                    if(term !== model){
                                        term.set('isDefault', false);
                                    }
                                }, this)
                            }
                        }, this)
                    });
                    this.dataTable.refresh();
                }
            }, this),
            onDelete: _.bind(function(model){
                if (model.id > 0) {
                    let row = this.dataTable.getRow(model.cid);
                    this.collection.remove(model);
                    model.destroy();
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                }
            }, this)
        })
    },
    deleteTermsClicked: function(e){
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteTerms(row);
    },
    deleteTerms: function(row){
        let terms = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete these terms?",
            onDelete: _.bind(function () {
                this.collection.remove(terms);
                terms.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.settings.EditTermsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Edit-Terms'),
        maxWidth: 650
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-delete': 'delete',
        'click .btn-save': 'save'
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ]
        });

        this.termsEditor = new PJQ.inputs.HTMLEditor({
            el: this.$('.terms-editor'),
            editorHeight: 150,
            isHideTokens: true,
            defaultValue: this.model.get('terms'),
            onChange: _.bind(function (contents) {
                this.model.set('terms', contents);
            }, this)
        });
    },
    close: function () {
        this.removeModal()
    },
    save: function () {
        if(typeof this.options.onSave === "function"){
            this.options.onSave(this.model);
        }
        this.removeModal();
    },
    delete: function(){
        if(typeof this.options.onDelete === 'function'){
            this.options.onDelete(this.model);
        }
        this.removeModal();
    }
});
PJQ.views.settings.TimeCardSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Time-Card-Settings')
    },
    events: {
        'change .cb-enable-line-items': 'render',
        'change .cb-enable-clock-in': 'enableClockInChanged',
        'click .add-timecard-category': 'addCategory',
        'click .btn-save-category': 'saveCategory',
        'click .btn-edit-category': 'editCategory',
        'click .btn-cancel-edit-category': 'cancelEditCategory',
        'click .btn-delete-category': 'deleteCategory'
    },
    beforeFirstRender: function () {
        if (typeof this.options.onChange === 'function') {
            this.listenTo(this.model, 'change', function () {
                this.options.onChange(this.model);
            });
        }

        this.isFetched = false;
        PJQ.app.session.fetchCostTypes((costTypes) => {
            this.costTypes = costTypes;
            this.isFetched = true;
            this.render();
        })
    },
    renderData: function () {
        return {
            model: this.model,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ]
        });

        this.renderCategoryTable();

        new PJQ.inputs.Selectpicker({
            el: this.$('.week-start'),
            isIntChoices: true,
            defaultValue: this.model.get('weekStart'),
            onChange: _.bind(function (value) {
                this.model.set('weekStart', value);
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-default-cost-type'),
            isIntChoices: true,
            defaultValue: this.model.get('defaultCostTypeId'),
            choices: _.map(this.costTypes.models, function (costType) {
                return {
                    id: costType.id,
                    name: costType.get('name')
                }
            }),
            onChange: _.bind(function (value) {
                this.model.set('defaultCostTypeId', value);
            }, this)
        });
    },
    renderCategoryTable: function () {
        this.categoryContext = null;
        if (this.model.get('enableLineItems')) {
            return
        }

        this.categoryDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".time-card-categories"),
            data: this.options.categories.models,
            isHideSearch: true,
            targets: 'no-sort',
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Click "Add Category" to create a new Category'
            },
            bSort: false,
            columns: [
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.categoryContext != null && this.categoryContext.id === row.id) {
                                return '<input type="text" class="form-control input-name" value="' + row.get('name') + '">';
                            } else {
                                return row.get('name');
                            }
                        }, this)
                    },
                    "title": "Category",
                    "orderable": false
                },
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "visible": false
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": '90px',
                    "resizable": false,
                    "render": _.bind(function (data, type, row) {
                        let buttons = '';
                        if (this.categoryContext != null && this.categoryContext.id === row.id) {
                            buttons = '<button type="button" class="btn btn-success btn-save-category mr-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger btn-cancel-edit-category wd-30p"><i class="fal fa-times"></i></button>';
                        } else {
                            buttons += '<button type="button" class="btn btn-info btn-edit-category mr-1"><i class="fal fa-pencil"></i></button>';
                            buttons += '<button type="button" class="btn btn-danger btn-delete-category"><i class="fal fa-trash"></i></button>';
                        }
                        return '<div class="show-on-row-hover text-align-right">' + buttons + '</div>'
                    }, this)
                }
            ],
        });
    },
    enableClockInChanged: function (e) {
        let enabled = $(e.currentTarget).prop('checked');
        if (enabled) {
            this.model.set({
                enableOvertime: false,
                enableDoubletime: false
            });
        }
        this.render();
    },
    addCategory: function () {
        let newCategory = new PJQ.models.timecards.TimeCardCategory({
            name: "",
            sortOrder: this.options.categories.length + 1
        });
        this.options.categories.add(newCategory);
        this.categoryContext = newCategory;
        this.categoryDataTable.addRow(newCategory);
    },
    editCategory: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            category = this.categoryDataTable.getRow($row).data();
        this.categoryContext = category;
        this.categoryDataTable.render();
    },
    saveCategory: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            category = this.categoryDataTable.getRow($row).data(),
            $name = $row.find('.input-name');
        category.set('name', $name.val());
        category.set('sortOrder', category.attributes.sortOrder);

        let isNameValid = _.size(category.get('name')) > 0;
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);
        if (isNameValid) {
            category.save(null, {
                success: _.bind(function () {
                    this.categoryContext = null;
                    this.categoryDataTable.render();
                }, this)
            });
        }
    },
    cancelEditCategory: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            category = this.categoryDataTable.getRow($row).data();

        new PJQ.views.modals.YesNo({
            header: "Cancel " + (category.isNew() ? "Add" : "Edit"),
            body: "Do you want to cancel " + (category.isNew() ? 'adding' : 'editing') + " this Category?",
            onYes: _.bind(function () {
                if (category.isNew()) {
                    this.options.categories.remove([category]);
                }

                this.categoryContext = null;
                this.categoryDataTable.render();
            }, this)
        });
    },
    deleteCategory: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            category = this.categoryDataTable.getRow($row).data();

        new PJQ.views.modals.YesNo({
            header: "Delete Category",
            body: "Do you want to delete this Category?",
            onYes: _.bind(function () {
                category.destroy({
                    success: _.bind(function () {
                        this.options.categories.remove([category]);
                        this.categoryDataTable.render();
                    }, this)
                });
            }, this)
        });
    }
});

PJQ.views.settings.UserSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'user-management'),
        subTemplates: {
            userSeats: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'user-management-user-seats-header'),
            userLimits: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'user-management-user-limits-header')
        }
    },
    events: {
        'click .btn-add-user': 'addClicked',
        'click .btn-edit-user-perms': 'editPermissionsClicked',
        'click .btn-edit-user': 'editClicked',
        'click .btn-delete-user': 'deleteClicked',
        'click .btn-edit-notification-settings': 'notificationSettingsClicked',
        'click .btn-change-seats': 'manageUserSeats',
        'click .btn-change-limits': 'manageUserLimits'
    },
    beforeRender: function () {
    },
    afterRender: function () {
        let defaultUserType = PJQ.app.session.userTypes.getDefault(true);

        this.renderUserSeats();
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".users-table"),
            data: this.collection.models,
            rowId: "cid",
            order: [1, 'asc'],
            language: {
                zeroRecords: "You don't have any users"
            },
            rowCallback: function (row, data) {
                if (data.userType) {
                    $(row).find('td:eq(7)').css('color', data.userType.get('color'));
                }
            },
            onRowDoubleClick: _.bind(function (row) {
                this.editUser(row.data());
            }, this),
            onTableDraw: _.bind(function () {
                this.$(".users-table").find('th').each(function (index, column) {
                    if (index === 0) {
                        $(column).removeClass('sorting')
                    }
                });
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editUser(row.data());
                        }, this)
                    },
                    {
                        name: 'Notifications',
                        isShown: _.bind(function (row) {
                            return PJQ.app.session.hasPermission('users.canModifyNotifications');
                        }, this),
                        onClick: _.bind(function (row) {
                            this.notificationSettings(row.data());
                        }, this)
                    },
                    {
                        name: 'Permissions',
                        onClick: _.bind(function (row) {
                            this.editPermissions(row.data());
                        }, this)
                    },
                    {
                        name: 'Add to Projects',
                        onClick: _.bind(function (row) {
                            this.addToProjects(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return PJQ.app.session.hasPermission('projects.isAdmin');
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function (row) {
                            return PJQ.app.session.user != null && PJQ.app.session.user.id !== row.data().get('userId');
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteUser(row);
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    'title': "hidden_search",
                    "data": "",
                    'width': '0px',
                    'visible': false,
                    "render": _.bind(function (data, type, row) {
                        return row.get('phone') + ' ' + row.get('address1') + ' ' + row.get('address2') + ' ' + row.get('city') + ' ' + row.get('state') + ' ' + row.get('zip');
                    })
                },
                {
                    'title': "Active",
                    "data": "attributes.isActive",
                    'width': '40px',
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (data === true) {
                            content = '<i class="fas fa-circle" style="color: #5cb85c"><div hidden>true</div></i>'
                        } else {
                            content = '<i class="fas fa-circle" style="color: #d9534f"><div hidden>false</div></i>'
                        }
                        return content
                    })
                },
                {
                    "title": "User Type",
                    "data": "userType",
                    "render": _.bind(function (data, type, row) {
                        let userType = row.userType != null ? row.userType : defaultUserType;
                        if (type === 'sort' && userType != null) {
                            return userType.get('sortOrder');
                        }
                        return '<span style="color:' + (userType != null ? userType.get('color') : '#000000') + ';">' + (userType != null ? userType.get('name') : "") + '</span>';
                    }, this)
                },
                {
                    "title": "Username",
                    "data": "attributes.username",
                },
                {
                    "title": "Name",
                    "data": "attributes.contactName",
                },
                {
                    "title": "Email",
                    "data": "attributes.email",
                },
                {
                    'title': "ITB User",
                    "data": "attributes.itbUser",
                    'width': '40px',
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (data === true) {
                            content = '<i class="fas fa-check text-dark"></i>'
                        }
                        return content
                    })
                },
                {
                    'title': "PM User",
                    "data": "attributes.pmUser",
                    'width': '40px',
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (data === true) {
                            content = '<i class="fas fa-check text-dark"></i>'
                        }
                        return content
                    })
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": '160px',
                    "render": _.bind(function (data, type, row) {
                        let buttons = '',
                            notificationButton = '<button type="button" title="Notifications" class="btn btn-purple btn-edit-notification-settings mr-1"><span class="fal fa-bell"></span></button>';
                        buttons += '<button type="button" title="Permissions" class="btn btn-dark btn-edit-user-perms mr-1"><span class="fal fa-key"></span></button>';
                        buttons += (row.get('userId') === PJQ.app.session.user.get('userId') || PJQ.app.session.hasPermission('users.canModifyNotifications')) ? notificationButton : ``
                        buttons += '<button type="button" title="Edit" class="btn btn-info btn-edit-user mr-1"><span class="fal fa-pencil"></span></button>'

                        if (row.get('userId') !== PJQ.app.session.user.id) {
                            buttons += '<button type="button" title="Delete" class="btn btn-danger btn-delete-user"><span class="fal fa-trash"></span></button>';
                        }

                        return '<div class="text-align-center show-on-row-hover" style="width:160px">' + buttons + '</div>';
                    }, this)
                }
            ]
        });
    },
    renderUserSeats: function () {
        let $userSeats = this.$('.user-seats');
        if (!PJQ.app.session.get('onAccount') && PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId) {
            let subscription = PJQ.app.session.subscription;
            if (subscription.id === PJQ.constants.subscriptions.types.FREE) {
                $userSeats.empty();
            } else {
                this.renderSubTemplate(false, this.options.subTemplates.userSeats, $userSeats, {
                    subscription: subscription,
                    users: this.collection
                }, _.bind(function () {
                    PJQ.app.session.listenSubscriptionChanged("accountSettings", _.bind(function () {
                        this.renderUserSeats();
                    }, this));
                }, this));
            }
        } else if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)) {
            PJQ.app.session.fetchUserLimits(_.bind(function (userLimits) {
                this.userLimits = userLimits;
                this.renderSubTemplate(false, this.options.subTemplates.userLimits, $userSeats, {
                    userLimits: userLimits,
                    users: this.collection,
                    showButtons: true
                });
            }, this))
        }
    },
    manageUserSeats: function () {
        new PJQ.views.settings.UserSeatsManagementModal();
    },
    manageUserLimits: function () {
        new PJQ.views.settings.UserLimitsManagementModal({
            model: this.userLimits,
            onSave: _.bind(function () {
                this.render();
            }, this)
        });
    },
    addToProjects: async function (user) {
        let projects = await user.getUserProjects();

        new PJQ.views.projects.ProjectSelectorModal({
            excludeProjectIds: _.map(projects, function (project) {
                return project.id;
            }),
            isSingleChoice: false,
            onSave: _.bind(async function (newProjects) {
                let projectIds = _.map(newProjects, function (project) {
                    return project.id;
                });

                try{
                    await user.addToProjects(projectIds);
                    PJQ.notifications.notify.successNotify({
                        message: `User successfully added to ${_.size(projectIds)} projects`
                    });
                }
                catch{
                    PJQ.notifications.notify.errorNotify({
                        message: 'Encountered an error adding user to projects'
                    });
                }
            }, this)
        });
    },
    addClicked: function () {
        let fnNew = _.bind(function () {
            let newUser = new PJQ.models.users.User({
                companyName: PJQ.app.session.user.get('companyName'),
                contactName: "",
                username: "",
                email: "",
                phone: "",
                address1: PJQ.app.session.user.get('address1'),
                address2: PJQ.app.session.user.get('address2'),
                city: PJQ.app.session.user.get('city'),
                state: PJQ.app.session.user.get('state'),
                zip: PJQ.app.session.user.get('zip'),
                country: PJQ.app.session.user.get('country'),
                sortOrder: this.collection.length + 1,
                pmUser: true,
                itbUser: false,
                isActive: true
            });
            this.editUser(newUser);
        }, this);

        if (PJQ.app.session.user.isFetched) {
            fnNew();
        } else {
            PJQ.app.session.user.fetch({
                success: fnNew
            })
        }
    },
    notificationSettingsClicked: function (e) {
        let target = $(e.currentTarget),
            user = this.dataTable.getRow(target.closest('tr')).data();
        this.notificationSettings(user);
    },
    notificationSettings: function (user) {
        new PJQ.views.notificationSettings.NotificationSettingsEditorModal({
            model: user
        });
    },
    editPermissionsClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            user = row.data();

        this.editPermissions(user);
    },
    editPermissions: function (user) {
        new PJQ.views.permissions.PermissionsEditorModal({
            model: user
        });
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            user = row.data();

        this.editUser(user);
    },
    editUser: function (user) {
        let isNew = user.isNew();
        // force the modal to re-fetch
        user.isFetched = false;
        new PJQ.views.contacts.BaseEditContactModal({
            model: user,
            onSave: _.bind(function (user) {
                if (isNew) {
                    this.collection.add(user);
                    this.dataTable.addRow(user);
                }
                this.renderUserSeats();
                this.dataTable.refresh();
            }, this),
            onClose: _.bind(function (user) {
                if (user.hasChanged()) {
                    user.fetch({
                        success: _.bind(function () {
                            this.dataTable.refresh();
                        }, this)
                    });
                }
            }, this),
            onDelete: _.bind(function (user) {
                if (!user.isNew()) {
                    let row = this.dataTable.getRow(user.cid);
                    this.collection.remove(user);
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                    this.renderUserSeats();
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteUser(row);
    },
    deleteUser: function (row) {
        let user = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this user?",
            onDelete: _.bind(function () {
                this.collection.remove(user);
                user.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.settings.UserSeatsManagementModal = PJQ.views.payment.PaySimplePaymentModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'modal-user-seats-management'),
        minWidth: 500,
        onSave: null,
        onError: null,
        isVerticalCenter: true,
        isShowCloseButton: true,
        selectedSubscriptionId: null
    },
    defaultEvents: {
        'click .btn-add-seat': 'userSeatAdded',
        'click .btn-remove-seat': 'userSeatRemoved',
        'keyup .input-user-seats': 'userSeatsInputChanged',
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        this.userSeats = PJQ.app.session.subscription.get('userSeats');
        PJQ.app.session.subscription.getCostsPerUser(_.bind(function (costs) {
            this.changeCosts = costs;
            PJQ.app.session.fetchUsers(_.bind(function (users) {
                this.activeUsers = _.size(users.where({isActive: true}));
                this.render();
            }, this));
        }, this));
    },
    renderData: function () {
        return {
            subscription: PJQ.app.session.subscription,
            userSeats: this.userSeats,
            activeUsers: this.activeUsers
        };
    },
    afterRender: function () {
        if (this.activeUsers == null) {
            new PJQ.Loader(this.$('.modal-content'));
            return;
        }
        this.$('.input-user-seats').focus().select();
    },
    userSeatAdded: function () {
        this.userSeats += 1;
        this.userSeatsChanged();
    },
    userSeatRemoved: function () {
        this.userSeats -= 1;
        this.userSeatsChanged();
    },
    userSeatsInputChanged: function () {
        this.userSeats = parseInt(this.$('.input-user-seats').val());
        this.userSeatsChanged();
    },
    userSeatsChanged: function () {
        this.$('.input-user-seats').val(this.userSeats);
        this.$('.btn-remove-seat').prop('disabled', this.userSeats === 0);

        let $err = this.$('.error-container'),
            $btnSave = this.$('.btn-save');
        if (this.userSeats < this.activeUsers) {
            // cant have less seats than active users
            $err.html("You can't select less seats than you have active users");
            $btnSave.prop('disabled', true);
        } else {
            let $payment = this.$('.payment-outer');
            if (this.userSeats > this.activeUsers) {
                this.renderTotal();
                $payment.removeClass('hidden');
            } else {
                $payment.addClass('hidden');
            }

            $err.empty();
            $btnSave.prop('disabled', false);
        }
    },
    renderTotal: function () {
        let subscription = PJQ.app.session.subscription,
            cost;
        switch (subscription.id) {
            case PJQ.constants.subscriptions.types.BASIC:
                cost = this.changeCosts.basic;
                break;
            case PJQ.constants.subscriptions.types.PRO:
                cost = this.changeCosts.pro;
                break;
            case PJQ.constants.subscriptions.types.ENTERPRISE:
                cost = this.changeCosts.enterprise;
                break;
            default:
                cost = 0;
                break;
        }

        let $pOuter = this.$('.payment-outer'),
            newUserSeats = this.userSeats - subscription.get('userSeats');
        if (newUserSeats > 0) {
            this.$('.payment-total').html(PJQ.helpers.formatHelpers.formatCurrency(cost * newUserSeats, 2, true));
            this.$('.new-seats-count').html(newUserSeats);
            $pOuter.removeClass('hidden');
        } else {
            $pOuter.addClass('hidden');
        }
    },
    save: function () {
        if (this.userSeats > PJQ.app.session.subscription.get('userSeats')) {
            let loader = new PJQ.Loader(this.$('.modal-content')),
                err = function () {
                    loader.remove();
                    PJQ.notifications.notify.errorNotify({
                        message: 'Encountered an error upgrading your subscription.  Please contact customer service.'
                    });
                };
            PJQ.app.session.changeUserSeats(this.userSeats, _.bind(function (data) {
                if (data == null || data.subscription == null) {
                    err();
                } else {
                    PJQ.notifications.notify.successNotify({
                        message: 'Users seats successfully updated'
                    });
                    this.removeModal();
                }
            }, this), _.bind(function () {
                err();
            }, this));
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.settings.UserLimitsManagementModal = PJQ.views.payment.PaySimplePaymentModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'modal-user-limits-management'),
        subTemplates: {
            userLimits: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'user-management-user-limits-header')
        },
        minWidth: 500,
        onSave: null,
        onError: null,
        isVerticalCenter: true,
        isShowCloseButton: true
    },
    defaultEvents: {
        'click .btn-add-itb-seat': 'itbUserSeatAdded',
        'click .btn-add-pm-seat': 'pmUserSeatAdded',
        'click .btn-remove-pm-seat': 'itbUserSeatRemoved',
        'click .btn-remove-itb-seat': 'pmUserSeatRemoved',
        'keyup .input-itb-user-seats': 'itbUserSeatsInputChanged',
        'keyup .input-pm-user-seats': 'pmUserSeatsInputChanged',
        'click .btn-cancel': 'cancel',
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        let fnFetchUsers = _.bind(function () {
            PJQ.app.session.fetchUsers(_.bind(function (users) {
                this.users = users;
                this.isFetched = true;
                this.render();
            }, this))
        }, this);

        if (this.model == null) {
            PJQ.app.session.fetchUserLimits(_.bind(function (userLimits) {
                fnFetchUsers();
            }, this))
        } else {
            fnFetchUsers();
        }
    },
    renderData: function () {
        return {
            model: this.model,
            itbUsers: this.itbUsers,
            pmUsers: this.pmUsers
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            new PJQ.Loader(this.$('.modal-content'));
            return;
        }
        this.$('.input-itb-user-seats').focus().select();

        this.renderHeader();
    },
    renderHeader: function(){
        this.renderSubTemplate(false, this.options.subTemplates.userLimits, this.$('.limits-header'), {
            userLimits: this.model,
            users: this.users
        });
    },
    pmUserSeatAdded: function () {
        this.model.set('pmUserLimit', this.model.get('pmUserLimit') + 1);
        this.userSeatsChanged();
    },
    pmUserSeatRemoved: function () {
        let seats = this.model.get('pmUserLimit');
        this.model.set('pmUserLimit', seats > 0 ? seats - 1 : 0);
        this.userSeatsChanged();
    },
    pmUserSeatsInputChanged: function () {
        let seats = parseInt(this.$('.input-pm-user-seats').val());
        if(isNaN(seats) || seats < 0){
            seats = 0;
        }
        this.model.set('pmUserLimit', seats);
        this.userSeatsChanged();
    },
    itbUserSeatAdded: function () {
        this.model.set('itbUserLimit', this.model.get('itbUserLimit') + 1);
        this.userSeatsChanged();
    },
    itbUserSeatRemoved: function () {
        let seats = this.model.get('itbUserLimit');
        this.model.set('itbUserLimit', seats > 0 ? seats - 1 : 0);
        this.userSeatsChanged();
    },
    itbUserSeatsInputChanged: function () {
        let seats = parseInt(this.$('.input-itb-user-seats').val());
        if(isNaN(seats) || seats < 0){
            seats = 0;
        }
        this.model.set('itbUserLimit', seats);
        this.userSeatsChanged();
    },
    userSeatsChanged: function () {
        this.renderHeader();
    },
    cancel: function () {
        this.model.restore();
        this.removeModal();
    },
    save: function () {
        let loader = new PJQ.Loader(this.$('.modal-content')),
            err = function () {
                loader.remove();
                PJQ.notifications.notify.errorNotify({
                    message: 'Encountered an error update user seats'
                });
            };
        this.model.save(null, {
            success: _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'User seats updated'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave();
                }

                this.removeModal();
            }, this),
            error: _.bind(err, this)
        })
    }
});

PJQ.views.settings.UserTypeSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'User-Type-Settings')
    },
    events: {
        'click .add-user-type': 'addClicked',
        'click .btn-edit-ut-perms': 'editPermissionsClicked',
        'click .btn-edit-user-type': 'editUserTypeClicked',
        'click .btn-delete-user-type': 'deleteUserTypeClicked',
        'click .btn-save-user-type': 'userTypeSave',
        'click .btn-cancel-edit-user-type': 'cancelEditUserType',
        'click .add-company-user-type': 'addCompanyClicked',
        'click .btn-edit-company-ut-perms': 'editCompanyPermissionsClicked',
        'click .btn-edit-company-user-type': 'editCompanyUserTypeClicked',
        'click .btn-delete-company-user-type': 'deleteCompanyUserTypeClicked',
        'click .btn-save-company-user-type': 'companyUserTypeSave',
        'click .btn-cancel-edit-company-user-type': 'cancelEditCompanyUserType',
        'click .btn-edit-company-user-type-notification-settings': 'companyNotificationSettingsClicked',
        'click .btn-edit-notification-settings': 'notificationSettingsClicked',
        'colorpickerCreate': 'createColorPickerBind',
        'colorpickerChange': 'setColorPickerValue',
    },
    beforeFirstRender: function () {
        this.users = new PJQ.collections.users.Users();
        this.listenTo(this.users, 'sync', this.render);
        this.users.fetch();
    },
    afterRender: function () {
        this.companyDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".company-user-type-table"),
            isHideSearch: true,
            data: this.collection.getByIsCompany(true),
            rowId: "cid",
            targets: 'no-sort',
            order: [2, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new User Type'
            },
            bSort: false,
            rowCallback: function (row, data) {
                $(row).find('td:eq(0)').css('color', data.get('color'));
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Notifications',
                        isShown: _.bind(function (row) {
                            return PJQ.app.session.hasPermission('users.canModifyNotifications');
                        }, this),
                        onClick: _.bind(function (row) {
                            this.notificationSettings(row.data());
                        }, this)
                    },
                    {
                        name: 'Permissions',
                        onClick: _.bind(function (row) {
                            this.editPermissions(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function (row) {
                            return row.data().get('masterUserId') !== -1;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteUserType(row);
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.userTypeContext != null && this.userTypeContext.id === row.id) {
                                return '<input type="text" class="form-control input-user-type-name" value="' + row.get('name') + '">';
                            } else {
                                return row.get('name');
                            }
                        }, this)
                    },
                    "title": "Company User Types",
                    "orderable": false
                },
                {
                    "data": "",
                    "title": "",
                    "width": "120px",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.userTypeContext != null && this.userTypeContext.id === row.id) {
                            content = '<div class="input-group colorpicker-el"><input class="form-control input-block color-io"/><span class="input-group-append"><span id="color_picker" class="input-group colorpicker-element"><input type="hidden" class="form-control input-lg" name="color" value="#000000"><span class="input-group-text colorpicker-input-addon" data-original-title="" title="" tabIndex="0"><i style="background: #000000"></i></span></span></span></div>'
                        }
                        return '<div class="text-align-right">' + content + '</div>'
                    }, this)
                },
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "visible": false
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": '180px',
                    "render": _.bind(function (data, type, row) {
                        let buttons = '',
                            notificationButton = '<button type="button" title="Notifications" class="btn btn-share btn-edit-company-user-type-notification-settings mr-1"><span class="fal fa-bell"></span></button>';
                        if (this.userTypeContext != null && this.userTypeContext.id === row.id) {
                            buttons = '<button type="button" class="btn btn-success btn-save-company-user-type mr-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger btn-cancel-edit-company-user-type"><i class="fal fa-times"></i></button>';
                        } else {
                            buttons += '<button type="button" title="Permissions" class="btn btn-dark btn-edit-company-ut-perms mr-1"><span class="fal fa-key"></span></button>';
                            buttons += PJQ.app.session.hasPermission('users.canModifyNotifications') ? notificationButton : ``;
                            buttons += '<button type="button" class="btn btn-info btn-edit-company-user-typep mr-1"><i class="fal fa-pencil"></i></button>';
                            if (row.get('masterUserId') !== -1) {
                                buttons += '<button type="button" class="btn btn-danger btn-delete-company-user-type"><i class="fal fa-trash"></i></button>';
                            }
                        }
                        return '<div class="show-on-row-hover text-align-right">' + buttons + '</div>'
                    }, this)
                }
            ],
        });

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".user-type-table"),
            isHideSearch: true,
            data: this.collection.getByIsCompany(false),
            rowId: "cid",
            targets: 'no-sort',
            order: [2, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new User Type'
            },
            bSort: false,
            rowCallback: function (row, data, index) {
                $(row).find('td:eq(0)').css('color', data.get('color'));
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Notifications',
                        onClick: _.bind(function (row) {
                            this.notificationSettings(row.data());
                        }, this)
                    },
                    {
                        name: 'Permissions',
                        onClick: _.bind(function (row) {
                            this.editPermissions(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function (row) {
                            return row.data().get('masterUserId') !== -1;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteCompanyUserType(row);
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": {
                        "display": _.bind(function (row) {
                            if (this.userTypeContext != null && this.userTypeContext.id === row.id) {
                                return '<input type="text" class="form-control input-user-type-name" value="' + row.get('name') + '">';
                            } else {
                                return row.get('name');
                            }
                        }, this)
                    },
                    "title": "Guest User Types",
                    "orderable": false
                },
                {
                    "data": "",
                    "title": "",
                    "width": "120px",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.userTypeContext != null && this.userTypeContext.id === row.id) {
                            content = '<div class="input-group colorpicker-el"><input class="form-control input-block color-io"/><span class="input-group-append"><span id="color_picker" class="input-group colorpicker-element"><input type="hidden" class="form-control input-lg" name="color" value="#000000"><span class="input-group-text colorpicker-input-addon" data-original-title="" title="" tabIndex="0"><i style="background: #000000"></i></span></span></span></div>'
                        }
                        return '<div class="text-align-right">' + content + '</div>'
                    }, this)
                },
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "visible": false
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": '180px',
                    "render": _.bind(function (data, type, row) {
                        let buttons = '',
                            notificationButton = '<button type="button" title="Notifications" class="btn btn-purple btn-edit-notification-settings mr-1"><span class="fal fa-bell"></span></button>'
                        if (this.userTypeContext != null && this.userTypeContext.id === row.id) {
                            buttons = '<button type="button" class="btn btn-success btn-save-user-type mr-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger btn-cancel-edit-user-type"><i class="fal fa-times"></i></button>';
                        } else {
                            buttons += '<button type="button" title="Permissions" class="btn btn-dark btn-edit-ut-perms mr-1"><span class="fal fa-key"></span></button>';
                            buttons += PJQ.app.session.hasPermission('users.canModifyNotifications') ? notificationButton : ``
                            buttons += '<button type="button" class="btn btn-info btn-edit-user-type mr-1"><i class="fal fa-pencil"></i></button>';
                            if (row.get('masterUserId') !== -1) {
                                buttons += '<button type="button" class="btn btn-danger btn-delete-user-type"><i class="fal fa-trash"></i></button>';
                            }
                        }
                        return '<div class="text-align-right show-on-row-hover">' + buttons + '</div>'
                    }, this)
                },
            ],
        });
    },
    createColorPickerBind: function(e) {
        let io = this.$('.color-io');

        io.val(e.color.string());

        io.on('change keyup', function () {
            e.colorpicker.setValue(io.val());
        });
    },
    setColorPickerValue: function(e) {
        let io = this.$('.color-io');

        if (e.value === io.val() || !e.color || !e.color.isValid()) {
            return;
        }

        io.val(e.color.string());
    },
    refreshDataTables: function () {
        this.dataTable.refresh();
        this.companyDataTable.refresh();
    },
    changeDefaultTypeAlert(returnCopy, callback) {
        this.dataTable.refresh();
        new PJQ.views.modals.YesNo({
            header: "Change User Types?",
            body: 'You are currently using the system default user types.  To edit a user type, we will need to create custom user types for your company.  This may take a minute, would you like to continue?',
            onYes: _.bind(function () {
                this.copyUserTypes(returnCopy, _.bind(function (userTypes, newUserType) {
                    this.render();
                    callback(userTypes, newUserType);
                }, this));
            }, this)
        });
    },
    copyUserTypes: function (returnCopy, callback) {
        this.collection.copy(_.bind(function () {
            let newUt = null;
            if (returnCopy != null) {
                let returnName = returnCopy.get('name');
                newUt = _.find(this.collection.models, function (u) {
                    return u.get('name') === returnName;
                });
            }
            callback(this.collection.models, newUt);
        }, this));
    },
    addClicked: function () {
        let fnAdd = _.bind(function () {
            let newUserType = new PJQ.models.userTypes.UserType({
                name: "",
                color: '#000000',
                sortOrder: this.collection.length + 1,
                isCompanyUser: false
            });
            this.collection.add(newUserType);
            this.dataTable.addRow(newUserType);
            this.userTypeContext = newUserType;
            this.defaultColor = this.userTypeContext.get('color');
            this.userTypeColor = this.userTypeContext.attributes.color;
            this.dataTable.refresh();
            this.colorPicker = new PJQ.colors.ColorPicker(this.$('.colorpicker-element'), {
                format: 'hex',
                color: this.userTypeColor,
                onChange: _.bind(function (value) {
                    this.userTypeContext.set('color', value);
                    this.$('.input-user-type-name').css('color', value);
                }, this)
            });
            this.$('.input-user-type-name').css('color', this.userTypeContext.get('color'));
        }, this);
        if (this.collection.length > 0 && this.collection.models[0].get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(null, function () {
                fnAdd();
            });
        } else {
            fnAdd();
        }
    },
    addCompanyClicked: function () {
        let fnAdd = _.bind(function () {
            let newUserType = new PJQ.models.userTypes.UserType({
                name: "",
                color: '#000000',
                sortOrder: this.collection.length + 1,
                isCompanyUser: true
            });
            this.collection.add(newUserType);
            this.companyDataTable.addRow(newUserType);
            this.userTypeContext = newUserType;
            this.defaultColor = this.userTypeContext.get('color');
            this.userTypeColor = this.userTypeContext.attributes.color;
            this.companyDataTable.refresh();
            this.colorPicker = new PJQ.colors.ColorPicker(this.$('.colorpicker-element'), {
                format: 'hex',
                color: this.userTypeColor,
                onChange: _.bind(function (value) {
                    this.userTypeContext.set('color', value);
                    this.$('.input-user-type-name').css('color', value);
                }, this)
            });
            this.$('.input-user-type-name').css('color', this.userTypeContext.get('color'));
        }, this);
        if (this.collection.length > 0 && this.collection.models[0].get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(null, function () {
                fnAdd();
            });
        } else {
            fnAdd();
        }
    },
    companyNotificationSettingsClicked: function (e) {
        let target = $(e.currentTarget),
            userType = this.companyDataTable.getRow(target.closest('tr')).data();
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (newUserTypes, newUserType) {
                this.notificationSettings(newUserType);
            });
        } else {
            this.notificationSettings(userType);
        }
    },
    notificationSettingsClicked: function (e) {
        let target = $(e.currentTarget),
            userType = this.dataTable.getRow(target.closest('tr')).data();
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (newUserTypes, newUserType) {
                this.notificationSettings(newUserType);
            });
        } else {
            this.notificationSettings(userType);
        }
    },
    notificationSettings: function (userType) {
        new PJQ.views.notificationSettings.NotificationSettingsEditorModal({
            model: userType
        });
    },
    editCompanyPermissionsClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.companyDataTable.getRow(target.closest('tr')),
            userType = row.data();
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, _.bind(function (newUserTypes, newUserType) {
                this.editPermissions(newUserType);
            }, this));
        } else {
            this.editPermissions(userType);
        }
    },
    editPermissionsClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            userType = row.data();
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, _.bind(function (newUserTypes, newUserType) {
                this.editPermissions(newUserType);
            }, this));
        } else {
            this.editPermissions(userType);
        }
    },
    editPermissions: function (userType) {
        new PJQ.views.permissions.PermissionsEditorModal({
            model: userType
        });
    },
    editUserTypeClicked: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            userType = row.data();
        this.editUserType(userType);
    },
    editUserType: function (userType) {
        let fnEdit = _.bind(function (eut) {
            this.userTypeContext = eut;
            this.defaultColor = eut.get('color');
            this.dataTable.refresh();
            this.colorPicker = new PJQ.colors.ColorPicker(this.$('.colorpicker-element'), {
                format: 'hex',
                color: eut.get('color'),
                onChange: _.bind(function (value) {
                    this.userTypeContext.set('color', value);
                    this.$('.input-user-type-name').css('color', value);
                }, this)
            });
            this.$('.input-user-type-name').css('color', eut.get('color'));
        }, this);
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (userTypes, newUserType) {
                fnEdit(newUserType);
            });
        } else {
            fnEdit(userType);
        }
    },
    editCompanyUserTypeClicked: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.companyDataTable.getRow($row),
            userType = row.data();
        this.editCompanyUserType(userType);
    },
    editCompanyUserType: function (userType) {
        let fnEdit = _.bind(function (eut) {
            this.userTypeContext = eut;
            this.defaultColor = eut.get('color');
            this.companyDataTable.refresh();
            this.colorPicker = new PJQ.colors.ColorPicker(this.$('.colorpicker-element'), {
                format: 'hex',
                color: eut.get('color'),
                onChange: _.bind(function (value) {
                    this.userTypeContext.set('color', value);
                    this.$('.input-user-type-name').css('color', value);
                }, this)
            });
            this.$('.input-user-type-name').css('color', eut.get('color'));
        }, this);
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (userTypes, newUserType) {
                fnEdit(newUserType);
            });
        } else {
            fnEdit(userType);
        }
    },
    deleteUserTypeClicked(e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row);
        this.deleteUserType(row);
    },
    deleteUserType: function (row) {
        let userType = row.data(),
            fnDelete = _.bind(function (dut) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete User Type",
                    body: "Are you sure you want to delete this user type?  Any user who currently has this role will have to be changed to a new user type.",
                    onDelete: _.bind(function () {
                        let userHasType = false;
                        _.each(this.users.models, function (user) {
                            if (user.get('userTypeId') === userType.get('userTypeId')) {
                                userHasType = true;
                            }
                        });
                        if (userHasType) {
                            new PJQ.views.settings.ChangeUserTypeModal({
                                userTypeId: userType.get('userTypeId'),
                                title: userType.get('name') + " Users",
                                users: this.users,
                                onDelete: _.bind(function () {
                                    userType.destroy({
                                        success: _.bind(function () {
                                            this.collection.remove(dut);
                                            this.dataTable.removeRow(row);
                                            this.dataTable.refresh();
                                        }, this)
                                    });
                                }, this)
                            });
                        } else {
                            userType.destroy({
                                success: _.bind(function () {
                                    this.collection.remove(dut);
                                    this.dataTable.removeRow(row);
                                    this.dataTable.refresh();
                                }, this)
                            });
                        }
                    }, this)
                });
            }, this);
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (userTypes, newUserType) {
                fnDelete(newUserType);
            });
        } else {
            fnDelete(userType);
        }
    },
    deleteCompanyUserTypeClicked(e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.companyDataTable.getRow($row);
        this.deleteCompanyUserType(row);
    },
    deleteCompanyUserType: function (row) {
        let userType = row.data(),
            fnDelete = _.bind(function (dut) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete User Type",
                    body: "Are you sure you want to delete this user type?  Any user who currently has this role will have to be changed to a new user type.",
                    onDelete: _.bind(function () {
                        let userHasType = false;
                        _.each(this.users.models, function (user) {
                            if (user.get('userTypeId') === userType.get('userTypeId')) {
                                userHasType = true;
                            }
                        });
                        if (userHasType) {
                            new PJQ.views.settings.ChangeUserTypeModal({
                                userTypeId: userType.get('userTypeId'),
                                title: userType.get('name') + " Users",
                                users: this.users,
                                onDelete: _.bind(function () {
                                    userType.destroy({
                                        success: _.bind(function () {
                                            this.collection.remove(dut);
                                            this.companyDataTable.removeRow(row);
                                            this.companyDataTable.refresh();
                                        }, this)
                                    });
                                }, this)
                            });
                        } else {
                            userType.destroy({
                                success: _.bind(function () {
                                    this.collection.remove(dut);
                                    this.companyDataTable.removeRow(row);
                                    this.companyDataTable.refresh();
                                }, this)
                            });
                        }
                    }, this)
                });
            }, this);
        if (userType.get('masterUserId') === -1) {
            this.changeDefaultTypeAlert(userType, function (userTypes, newUserType) {
                fnDelete(newUserType);
            });
        } else {
            fnDelete(userType);
        }
    },
    userTypeSave: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            userType = this.dataTable.getRow($row).data(),
            $name = $row.find('.input-user-type-name');
        userType.set('name', $name.val());
        userType.set('sortOrder', userType.attributes.sortOrder);

        let isNameValid = _.size(userType.get('name')) > 0;
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);

        if (isNameValid) {
            userType.save(null, {
                success: _.bind(function () {
                    this.userTypeContext = null;
                    this.dataTable.refresh();
                }, this)
            });
        }
    },
    companyUserTypeSave: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            userType = this.companyDataTable.getRow($row).data(),
            $name = $row.find('.input-user-type-name');
        userType.set('name', $name.val());
        userType.set('sortOrder', userType.attributes.sortOrder);

        let isNameValid = _.size(userType.get('name')) > 0;
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);

        if (isNameValid) {
            userType.save(null, {
                success: _.bind(function () {
                    this.userTypeContext = null;
                    this.companyDataTable.refresh();
                }, this)
            });
        }
    },
    cancelEditUserType: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            user = row.data();
        user.set('color', this.defaultColor);
        this.userTypeContext = null;
        this.userTypeColor = null;
        if (user.get('name').length === 0) {
            this.dataTable.removeRow(row);
        }
        this.dataTable.refresh();
    },
    cancelEditCompanyUserType: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.companyDataTable.getRow($row),
            user = row.data();
        user.set('color', this.defaultColor);
        this.userTypeContext = null;
        this.userTypeColor = null;
        if (user.get('name').length === 0) {
            this.companyDataTable.removeRow(row);
        }
        this.companyDataTable.refresh();
    },
});

PJQ.views.settings.ChangeUserTypeModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Change-User-Type'),
        title: "Change User Types",
        subtitle: "These Users Type must be changed before deleting."
    },
    events: {
        'click .btn-edit-user': 'editClicked',
        'click .user-type-change-done': 'checkDone'
    },
    beforeModalCreated: function () {
        this.users = this.options.users;
    },
    beforeRender: function () {
        this.renderData = {
            options: this.options
        };
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".user-table"),
            isHideSearch: true,
            paginate: false,
            data: this.users.getByUserType(this.options.userTypeId),
            rowId: "cid",
            targets: 'no-sort',
            order: [2, 'asc'],
            bSort: false,
            language: {
                zeroRecords: 'No more users have this type.  Hit done to complete deleting.'
            },
            rowCallback: function (row, data) {
                $(row).find('td:eq(0)').css('color', data.get('color'));
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editUser(row.data());
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "title": "User Type",
                    "data": "userType",
                    "render": _.bind(function (data, type, row) {
                        if (type === 'sort' && row.userType !== undefined) {
                            return row.userType.get('sortOrder');
                        }
                        return '<span style="color:' + (row.userType !== undefined ? row.userType.get('color') : '#000000') + ';">' + (row.userType !== undefined ? row.userType.get('name') : "") + '</span>';
                    }, this)
                },
                {
                    "title": "Username",
                    "data": "attributes.username",
                },
                {
                    "title": "Name",
                    "data": "attributes.contactName",
                },
                {
                    "title": "Email",
                    "data": "attributes.email",
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": '40px',
                    "render": _.bind(function (data, type, row) {
                        let button = '';
                        button += '<button type="button" class="btn btn-info btn-edit-user mr-1"><i class="fal fa-pencil"></i></button>';
                        return '<div class="show-on-row-hover text-align-right">' + button + '</div>'
                    }, this)
                }
            ],
        });
        this.checkUsersLength()
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            user = row.data();

        this.editUser(user);
    },
    editUser: function (user) {
        new PJQ.views.contacts.BaseEditContactModal({
            model: user,
            onSave: _.bind(function (user) {
                if (user.hasChanged()) {
                    user.save(null, {
                        notify: true
                    });
                }
                this.dataTable.refresh();
                this.checkUsersLength()
            }, this),
            onClose: _.bind(function (user) {
                if (user.hasChanged()) {
                    user.fetch({
                        success: _.bind(function () {
                            this.dataTable.refresh();
                        }, this)
                    });
                    this.checkUsersLength()
                }
            }, this),
            onDelete: _.bind(function (user) {
                let row = this.dataTable.getRow(user.cid);
                this.users.remove(user);
                if (row != null) {
                    this.dataTable.removeRow(row);
                }
                this.checkUsersLength()
            }, this)
        });
    },
    checkUsersLength: function () {
        if (this.users.getByUserType(this.options.userTypeId).length === 0) {
            this.$('.user-type-change-done').attr('disabled', false)
        }
    },
    checkDone: function () {
        if (this.users.getByUserType(this.options.userTypeId).length === 0) {
            this.options.onDelete;
            this.removeModal();
        }
    }
});

